const mw5 = [
  {
    id: '3543',
    title: '『大阪西北部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2500978779, 34.836567156, 135.5000800779, 34.669922047],
  },
  {
    id: '3643',
    title: '『渡島小島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7493842629, 41.502577165, 139.9993943899, 41.335910541],
  },
  {
    id: '3642',
    title: '『山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [128.7508212729, 28.003857754, 129.0008028749, 27.837201771],
  },
  {
    id: '3638',
    title: '『久米島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [128.0008863019, 28.003846535, 128.2508676879, 27.837190731],
  },
  {
    id: '3637',
    title: '『赤木名』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.5007466289, 28.503815922, 129.7507284359, 28.337106986],
  },
  {
    id: '3641',
    title: '『亀津』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [128.7508275799, 27.670559521, 129.0008706009, 27.503907228],
  },
  {
    id: '3636',
    title: '『湯湾』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.2507715919, 28.337155905, 129.5008108059, 28.17045338],
  },
  {
    id: '3634',
    title: '『平島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.5007187679, 29.837001566, 129.7507414989, 29.670328992],
  },
  {
    id: '3633',
    title: '『種子島南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.7505945099, 30.503620024, 131.0005766499, 30.33696389],
  },
  {
    id: '3631',
    title: '『屋久島西北部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.2506382239, 30.503611224, 130.5006609839, 30.3369417],
  },
  {
    id: '3635',
    title: '『宝島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.0007832549, 28.837102133, 129.2507649019, 28.670456208],
  },
  {
    id: '3632',
    title: '『屋久島東南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.5006240289, 30.33696389, 130.7506022669, 30.170317797],
  },
  {
    id: '3630',
    title: '『屋久島西南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.2506420449, 30.336955217, 130.5006609839, 30.170313502],
  },
  {
    id: '3629',
    title: '『口永良部島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.0006601459, 30.503606887, 130.2506420449, 30.336950943],
  },
  {
    id: '3628',
    title: '『玉之浦』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [128.5007434829, 32.670016014, 128.7507248019, 32.503352733],
  },
  {
    id: '3627',
    title: '『砥用』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.7505546809, 32.670060316, 131.0005389309, 32.503401722],
  },
  {
    id: '3626',
    title: '『教良木』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.2505897989, 32.503388202, 130.5005870779, 32.33673245],
  },
  {
    id: '3625',
    title: '『島浦』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.7504563709, 32.670081655, 132.0004342929, 32.503411813],
  },
  {
    id: '3624',
    title: '『三井楽』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [128.5007394849, 32.836648968, 128.7507167529, 32.670003713],
  },
  {
    id: '3623',
    title: '『伊万里』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.7506192029, 33.336639445, 130.0006021189, 33.169989711],
  },
  {
    id: '3622',
    title: '『佐尾』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.0006930339, 32.836667759, 129.2506755399, 32.67001235],
  },
  {
    id: '3621',
    title: '『山鹿』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.5005601389, 33.170007828, 130.7505457949, 33.003351325],
  },
  {
    id: '3620',
    title: '『臼杵』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.7504566059, 33.170037766, 132.0004353079, 33.003360354],
  },
  {
    id: '3619',
    title: '『蒲江』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.7504665499, 32.836732353, 132.0004445029, 32.670067938],
  },
  {
    id: '3618',
    title: '『大用』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.7503636419, 33.170069188, 133.0003465779, 33.003409767],
  },
  {
    id: '3616',
    title: '『柏島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.2504030509, 32.836719097, 132.5003856499, 32.670072859],
  },
  {
    id: '3615',
    title: '『鶴御崎』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.0004205429, 33.003365319, 132.2504030509, 32.83671411],
  },
  {
    id: '3617',
    title: '『土佐中村』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.7503708749, 33.003417867, 133.0003465779, 32.836729202],
  },
  {
    id: '3613',
    title: '『呼子』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.7506046699, 33.6699159, 130.0005863649, 33.503260424],
  },
  {
    id: '3611',
    title: '『小倉』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.7505047589, 34.003256661, 131.0004999719, 33.83657584],
  },
  {
    id: '3612',
    title: '『唐津』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [129.7506090569, 33.503265047, 130.0005988309, 33.336631848],
  },
  {
    id: '3609',
    title: '『折尾』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.5005274489, 34.003221812, 130.7505253469, 33.83659527],
  },
  {
    id: '3610',
    title: '『行橋』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.7505253469, 33.836600123, 131.0005088419, 33.669958486],
  },
  {
    id: '3608',
    title: '『直方』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.5005462529, 33.836600123, 130.7505300309, 33.669954103],
  },
  {
    id: '3607',
    title: '『津屋崎』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.2505547329, 33.83659527, 130.5005490779, 33.669920598],
  },
  {
    id: '3605',
    title: '『前原』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.0005819349, 33.669920598, 130.2505730219, 33.503265047],
  },
  {
    id: '3606',
    title: '『玄界島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.0005774679, 33.836561423, 130.2505592469, 33.6699159],
  },
  {
    id: '3603',
    title: '『宇部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.0004868039, 34.003261603, 131.2504807449, 33.83657584],
  },
  {
    id: '3604',
    title: '『野島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.5004417319, 34.003266453, 131.7504192699, 33.836585657],
  },
  {
    id: '3602',
    title: '『簑島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.0004868039, 33.836580718, 131.2504689259, 33.669939801],
  },
  {
    id: '3601',
    title: '『梼原』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.7503586949, 33.503357681, 133.0003368699, 33.336701698],
  },
  {
    id: '3600',
    title: '『三津浜』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.5003472269, 34.003262037, 132.7503543079, 33.836605865],
  },
  {
    id: '3598',
    title: '『柳井』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.0003968549, 34.003284694, 132.2503968719, 33.83659567],
  },
  {
    id: '3599',
    title: '『久賀』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.2503744869, 34.003284694, 132.5003521669, 33.836600745],
  },
  {
    id: '3596',
    title: '『奈半利』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [134.2502114809, 33.503380778, 134.5001909859, 33.336699286],
  },
  {
    id: '3597',
    title: '『室津』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.0003968549, 33.836600745, 132.2503793459, 33.669954688],
  },
  {
    id: '3595',
    title: '『十津川』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500683389, 34.00333812, 136.0000471889, 33.836685053],
  },
  {
    id: '3592',
    title: '『串本』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500731669, 33.503394064, 136.0000613049, 33.336732388],
  },
  {
    id: '3593',
    title: '『那智勝浦』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500723249, 33.670048427, 136.0000558979, 33.503389495],
  },
  {
    id: '3590',
    title: '『栗栖川』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000951059, 33.836685053, 135.7500723249, 33.670041436],
  },
  {
    id: '3591',
    title: '『龍神』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000924859, 34.00333375, 135.7500697249, 33.836681187],
  },
  {
    id: '3589',
    title: '『江住』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000951059, 33.670044477, 135.7500731669, 33.503378151],
  },
  {
    id: '3588',
    title: '『田並』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000989969, 33.503394064, 135.7500827859, 33.336726762],
  },
  {
    id: '3587',
    title: '『川原河』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2501143609, 34.003333109, 135.5000952059, 33.836679298],
  },
  {
    id: '3585',
    title: '『御坊』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.0001263209, 34.003330756, 135.2501171809, 33.836659535],
  },
  {
    id: '3586',
    title: '『田辺』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2501152989, 33.836681187, 135.5000952059, 33.670023866],
  },
  {
    id: '3584',
    title: '『印南』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.0001316939, 33.836679298, 135.2501171809, 33.670018278],
  },
  {
    id: '3583',
    title: '『木本』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.0000454059, 34.003343436, 136.2500253999, 33.836687798],
  },
  {
    id: '3582',
    title: '『阿田和』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.0000471889, 33.836688034, 136.2500289369, 33.670046653],
  },
  {
    id: '3580',
    title: '『安岡』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.7505000839, 34.169908514, 131.0004999719, 34.003221812],
  },
  {
    id: '3581',
    title: '『阿川』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [130.7504906169, 34.503169002, 131.0004913949, 34.336513359],
  },
  {
    id: '3579',
    title: '『西市』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.0004913949, 34.336557064, 131.2504784419, 34.169908514],
  },
  {
    id: '3578',
    title: '『厚狭』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [131.0004959169, 34.169914933, 131.2504807449, 34.003256661],
  },
  {
    id: '3577',
    title: '『明石』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [134.7501264159, 34.6699184, 135.0001257869, 34.503248486],
  },
  {
    id: '3576',
    title: '『坊勢島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [134.5001539679, 34.669912305, 134.7501319249, 34.503242868],
  },
  {
    id: '3575',
    title: '『鳴門海峡』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [134.5001593879, 34.336612248, 134.7501514859, 34.169956308],
  },
  {
    id: '3574',
    title: '『徳島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [134.5001838389, 34.1699698, 134.7501481819, 34.003305159],
  },
  {
    id: '3594',
    title: '『新宮』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500697249, 33.836687798, 136.0000493919, 33.670044477],
  },
  {
    id: '3573',
    title: '『桜井』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500577499, 34.669933575, 136.0000419059, 34.503278142],
  },
  {
    id: '3572',
    title: '『吉野山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500604499, 34.503283069, 136.0000445109, 34.33662657],
  },
  {
    id: '3570',
    title: '『釈迦ヶ岳』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500662049, 34.1699901, 136.0000454059, 34.00333375],
  },
  {
    id: '3571',
    title: '『山上ヶ岳』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500634059, 34.336632584, 136.0000445109, 34.169984783],
  },
  {
    id: '3568',
    title: '『五條』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000836109, 34.503278142, 135.7500634059, 34.336623448],
  },
  {
    id: '3569',
    title: '『大阪東南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000800779, 34.669929361, 135.7500604499, 34.503275031],
  },
  {
    id: '3567',
    title: '『高野山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000859109, 34.33662657, 135.7500662049, 34.16998278],
  },
  {
    id: '3566',
    title: '『伯母子岳』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000888139, 34.169984783, 135.7500683389, 34.003333109],
  },
  {
    id: '3564',
    title: '『岸和田』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2500879969, 34.503275031, 135.5000859109, 34.336620659],
  },
  {
    id: '3565',
    title: '『大阪西南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2500879969, 34.669926627, 135.5000836109, 34.503259857],
  },
  {
    id: '3563',
    title: '『粉河』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2501086749, 34.336623448, 135.5000888139, 34.169979233],
  },
  {
    id: '3562',
    title: '『動木』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2501110469, 34.16998278, 135.5000924859, 34.003330756],
  },
  {
    id: '3560',
    title: '『和歌山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.0001154419, 34.336620659, 135.2501110469, 34.169961924],
  },
  {
    id: '3561',
    title: '『須磨』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.0001224029, 34.669922047, 135.2501015609, 34.503259857],
  },
  {
    id: '3558',
    title: '『贄浦』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.4999906049, 34.336650628, 136.7499737359, 34.169996549],
  },
  {
    id: '3559',
    title: '『波切』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.7499690789, 34.336650628, 136.9999476079, 34.170002474],
  },
  {
    id: '3557',
    title: '『長島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.2500201949, 34.336645028, 136.4999958969, 34.169995322],
  },
  {
    id: '3556',
    title: '『尾鷲』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.0000442449, 34.169995322, 136.2500253999, 34.00333812],
  },
  {
    id: '3555',
    title: '『利島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.2497382479, 34.670015174, 139.4997235559, 34.503357208],
  },
  {
    id: '3554',
    title: '『新島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.2497355469, 34.503363663, 139.4997298289, 34.336712111],
  },
  {
    id: '3551',
    title: '『温泉津』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.2503341349, 35.169825616, 132.5003511219, 35.003173581],
  },
  {
    id: '3552',
    title: '『大浦』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.2503289019, 35.336433266, 132.5003451139, 35.169787308],
  },
  {
    id: '3550',
    title: '『京都東北部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500511579, 35.169879844, 136.0000294309, 35.003225342],
  },
  {
    id: '3548',
    title: '『奈良』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500547089, 34.836575064, 136.0000358139, 34.669929361],
  },
  {
    id: '3549',
    title: '『京都東南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.7500534249, 35.00322985, 136.0000331669, 34.83657265],
  },
  {
    id: '3547',
    title: '『京都西北部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000705809, 35.169877644, 135.7500534249, 35.003222109],
  },
  {
    id: '3545',
    title: '『大阪東北部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000766999, 34.83657265, 135.7500577499, 34.669926627],
  },
  {
    id: '3544',
    title: '『広根』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2500971999, 35.003222109, 135.5000766999, 34.836563198],
  },
  {
    id: '3546',
    title: '『京都西南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000742449, 35.003225342, 135.7500547089, 34.836567156],
  },
  {
    id: '3541',
    title: '『磐田』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.7498632699, 34.836633331, 137.9998445999, 34.669985102],
  },
  {
    id: '3542',
    title: '『天竜』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.7498594419, 35.003282539, 137.9998408939, 34.836624809],
  },
  {
    id: '3540',
    title: '『家山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.9998374779, 35.003288331, 138.2498180639, 34.836633331],
  },
  {
    id: '3539',
    title: '『富津』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7496702769, 35.336615267, 139.9996465999, 35.169966064],
  },
  {
    id: '3538',
    title: '『那古』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7496768569, 35.169979666, 139.9996624019, 35.003314651],
  },
  {
    id: '3537',
    title: '『横須賀』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.4996877579, 35.336608389, 139.7496768569, 35.169959458],
  },
  {
    id: '3535',
    title: '『大島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.2497319129, 34.836656644, 139.4997172309, 34.670008692],
  },
  {
    id: '3536',
    title: '『三崎』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.4996979409, 35.169966064, 139.7496833829, 35.003308072],
  },
  {
    id: '3534',
    title: '『伊東』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [138.9997436949, 35.003304375, 139.2497319129, 34.836648039],
  },
  {
    id: '3533',
    title: '『稲取』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [138.9997479889, 34.836650135, 139.2497382479, 34.670003058],
  },
  {
    id: '3532',
    title: '『恵曇』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [132.7502727169, 35.669745333, 133.0002849249, 35.503089274],
  },
  {
    id: '3531',
    title: '『青谷』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [133.7501821419, 35.669767622, 134.0001959719, 35.503138628],
  },
  {
    id: '3529',
    title: '『鋸崎』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.5000256369, 35.669808421, 135.7500468829, 35.503168789],
  },
  {
    id: '3528',
    title: '『冠島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.2500419059, 35.836443271, 135.5000256369, 35.669802453],
  },
  {
    id: '3530',
    title: '『赤碕』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [133.5002047099, 35.669761979, 133.7502189469, 35.503137247],
  },
  {
    id: '3526',
    title: '『谷汲』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.4999645779, 35.66983533, 136.7499387339, 35.503180808],
  },
  {
    id: '3527',
    title: '『網野』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [135.0000642039, 35.836437326, 135.2500848219, 35.669811494],
  },
  {
    id: '3525',
    title: '『赤穂』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.7498343199, 35.836510064, 137.9998189919, 35.669864039],
  },
  {
    id: '3523',
    title: '『萩原』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [136.9999028029, 36.0031391, 137.2498787949, 35.836483745],
  },
  {
    id: '3522',
    title: '『身延』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [138.2498018529, 35.503231261, 138.4997836449, 35.336578609],
  },
  {
    id: '3524',
    title: '『時又』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.7498467829, 35.503222842, 137.9998292499, 35.33656602],
  },
  {
    id: '3521',
    title: '『東京東南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7496572529, 35.669911719, 139.9996425329, 35.503259228],
  },
  {
    id: '3520',
    title: '『木更津』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7496646109, 35.503265472, 139.9996440109, 35.336607437],
  },
  {
    id: '3519',
    title: '『東京西北部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.4996728779, 35.836546348, 139.7496572529, 35.669901811],
  },
  {
    id: '3517',
    title: '『秦野』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [138.9997311419, 35.503252147, 139.2497075699, 35.336592128],
  },
  {
    id: '3518',
    title: '『藤沢』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.2497059109, 35.503255809, 139.4996877579, 35.336602206],
  },
  {
    id: '3516',
    title: '『成田』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.2496047419, 35.836564239, 140.4995877189, 35.66991868],
  },
  {
    id: '3515',
    title: '『西郷』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [133.2501990939, 36.502989149, 133.5001820239, 36.336338674],
  },
  {
    id: '3514',
    title: '『小山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7496321139, 36.336492434, 139.9996163059, 36.169845264],
  },
  {
    id: '3513',
    title: '『古河』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.4996554249, 36.336485512, 139.7496381939, 36.169839044],
  },
  {
    id: '3512',
    title: '『鴻巣』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.4996616419, 36.169845264, 139.7496447919, 36.003188447],
  },
  {
    id: '3508',
    title: '『川部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.4995408559, 37.003103942, 140.7495282839, 36.836446881],
  },
  {
    id: '3507',
    title: '『河原田』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.9997116659, 38.002925465, 138.2497240869, 37.836273939],
  },
  {
    id: '3506',
    title: '『加茂』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [138.9996555189, 37.6696617, 139.2496391169, 37.503005381],
  },
  {
    id: '3505',
    title: '『相馬中村』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7494885699, 37.836359009, 140.9994739189, 37.669697522],
  },
  {
    id: '3504',
    title: '『相川』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.9997044459, 38.16958278, 138.2497149859, 38.002925017],
  },
  {
    id: '3503',
    title: '『村上』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.2495860699, 38.336253492, 139.4995783189, 38.169610461],
  },
  {
    id: '3502',
    title: '『仙台』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7494653579, 38.336297189, 140.9994417359, 38.169647147],
  },
  {
    id: '3501',
    title: '『川崎』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.4994864699, 38.336289339, 140.7494722559, 38.169637314],
  },
  {
    id: '3500',
    title: '『金華山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.4993902449, 38.336323792, 141.7493766749, 38.169675471],
  },
  {
    id: '3499',
    title: '『松島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.9994336749, 38.502953242, 141.2494116079, 38.336297189],
  },
  {
    id: '3498',
    title: '『塩竈』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.9994410699, 38.336308876, 141.2494195389, 38.169660701],
  },
  {
    id: '3509',
    title: '『大津』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7495282839, 36.836473, 140.9995091519, 36.669824786],
  },
  {
    id: '3511',
    title: '『桐生及足利』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.2496730359, 36.503131203, 139.4996554249, 36.336475467],
  },
  {
    id: '3510',
    title: '『高田西部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [137.9997399559, 37.336339703, 138.2497476329, 37.169692319],
  },
  {
    id: '3497',
    title: '『大沢』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.9995040889, 39.002868317, 140.2494880669, 38.836208862],
  },
  {
    id: '3496',
    title: '『釜石』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.7493297859, 39.336206825, 141.9993073259, 39.169561689],
  },
  {
    id: '3495',
    title: '『津谷』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.4993704839, 38.836266158, 141.7493523859, 38.669612405],
  },
  {
    id: '3494',
    title: '『志津川』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.2493926139, 38.836253306, 141.4993782579, 38.669604714],
  },
  {
    id: '3492',
    title: '『五城目』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.9994701559, 40.002751625, 140.2494535559, 39.836093872],
  },
  {
    id: '3493',
    title: '『一関』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.9994098139, 39.002897617, 141.2493926139, 38.836238501],
  },
  {
    id: '3491',
    title: '『大川』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.4993354529, 39.836143742, 141.7493183829, 39.669497197],
  },
  {
    id: '3490',
    title: '『川井』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.4993413719, 39.669504491, 141.7493254579, 39.502846772],
  },
  {
    id: '3489',
    title: '『花巻』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.9993913559, 39.502839875, 141.2493750329, 39.336183331],
  },
  {
    id: '3488',
    title: '『岩館』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7494368319, 40.50268435, 139.9994425359, 40.336030106],
  },
  {
    id: '3486',
    title: '『花輪』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7493849279, 40.336064498, 140.9993710919, 40.169418172],
  },
  {
    id: '3487',
    title: '『羽後浜田』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.7494537739, 40.169396605, 139.9994701559, 40.002739669],
  },
  {
    id: '3485',
    title: '『川原平』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.9994347829, 40.669343422, 140.2494213279, 40.50268435],
  },
  {
    id: '3484',
    title: '『陸奥川内』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7493020959, 41.335952487, 140.9993223109, 41.169301222],
  },
  {
    id: '3483',
    title: '『脇野沢』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7493111989, 41.169309011, 140.9992977299, 41.002651103],
  },
  {
    id: '3482',
    title: '『浅虫』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7493202249, 41.002658866, 140.9993426499, 40.835999645],
  },
  {
    id: '3480',
    title: '『蟹田』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.4993700469, 41.169301222, 140.7493202249, 41.002645883],
  },
  {
    id: '3481',
    title: '『母衣月』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.4993247729, 41.335941306, 140.7493111989, 41.169298094],
  },
  {
    id: '3479',
    title: '『小泊』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.2493565049, 41.169298094, 140.4993774329, 41.002635723],
  },
  {
    id: '3478',
    title: '『野辺地』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.9992977299, 41.00266235, 141.2493233699, 40.836006756],
  },
  {
    id: '3477',
    title: '『臼尻』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7493078699, 42.002544214, 140.9992952809, 41.835891534],
  },
  {
    id: '3476',
    title: '『五稜郭』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7492836569, 41.835898259, 140.9992952809, 41.669241363],
  },
  {
    id: '3475',
    title: '『大間』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7492836569, 41.669249229, 140.9992702549, 41.502591352],
  },
  {
    id: '3474',
    title: '『佐井』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.7492929149, 41.502599193, 140.9993223109, 41.335941306],
  },
  {
    id: '3473',
    title: '『大沼公園』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.4993287309, 42.002544214, 140.7493172639, 41.835883881],
  },
  {
    id: '3472',
    title: '『函館』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.4993064509, 41.835891534, 140.7493172639, 41.669233547],
  },
  {
    id: '3471',
    title: '『館』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.2493490199, 42.002535259, 140.4993389699, 41.835876817],
  },
  {
    id: '3470',
    title: '『木古内』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.2493575609, 41.835883881, 140.4993389699, 41.669233547],
  },
  {
    id: '3469',
    title: '『知内』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.2493653329, 41.669234205, 140.4993156509, 41.502583562],
  },
  {
    id: '3468',
    title: '『渡島福島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.2493475179, 41.502583603, 140.4993247729, 41.335925824],
  },
  {
    id: '3467',
    title: '『大千軒岳』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.9993862279, 41.669234205, 140.2493725249, 41.502577165],
  },
  {
    id: '3466',
    title: '『松前』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [139.9993703309, 41.502583603, 140.2493725249, 41.335918158],
  },
  {
    id: '3465',
    title: '『尻屋崎』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.2492476509, 41.50261502, 141.4992344749, 41.335959659],
  },
  {
    id: '3464',
    title: '『尾札部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.9992420619, 42.002547161, 141.2492288219, 41.835897171],
  },
  {
    id: '3462',
    title: '『浦河』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [142.7490841249, 42.169270316, 142.9991162779, 42.002595993],
  },
  {
    id: '3463',
    title: '『恵山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.9992609319, 41.835898259, 141.2492382759, 41.669249229],
  },
  {
    id: '3461',
    title: '『湧洞沼』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.4989868219, 42.669233386, 143.7489645909, 42.502561533],
  },
  {
    id: '3460',
    title: '『茅沼』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [140.4992299849, 43.169083822, 140.7492543279, 43.002402168],
  },
  {
    id: '3459',
    title: '『札内岳』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [142.7490915949, 42.83585662, 142.9990819419, 42.669205847],
  },
  {
    id: '3458',
    title: '『幌尻岳』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [142.4991147449, 42.835848137, 142.7491017469, 42.66919785],
  },
  {
    id: '3456',
    title: '『高島』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.2490320469, 43.169174227, 143.4990165529, 43.002515295],
  },
  {
    id: '3457',
    title: '『上茶路』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.7489864719, 43.169192072, 143.9989743559, 43.00253185],
  },
  {
    id: '3453',
    title: '『床潭』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.7488549239, 43.002576439, 144.9988825859, 42.835895095],
  },
  {
    id: '3455',
    title: '『然別湖』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [142.9990431839, 43.335808259, 143.2490320469, 43.169159255],
  },
  {
    id: '3454',
    title: '『茶内原野　』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.7488884589, 43.335864915, 144.9988735809, 43.169217511],
  },
  {
    id: '3452',
    title: '『鶴居』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.2489336449, 43.335849242, 144.4989181749, 43.169199502],
  },
  {
    id: '3451',
    title: '『釧路』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.2488990949, 43.002559011, 144.4989257919, 42.835877578],
  },
  {
    id: '3450',
    title: '『徹別』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.9989570109, 43.335838267, 144.2489415169, 43.169192072],
  },
  {
    id: '3448',
    title: '『根室南部』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [145.4987781809, 43.169240958, 145.7487563849, 43.002571961],
  },
  {
    id: '3449',
    title: '『白糠』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.9989212949, 43.002549603, 144.2489516969, 42.835868892],
  },
  {
    id: '3447',
    title: '『本岐』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.7489652859, 43.669134611, 143.9989503499, 43.50247585],
  },
  {
    id: '3446',
    title: '『小利別』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.4989830359, 43.669127733, 143.7489725669, 43.502468328],
  },
  {
    id: '3444',
    title: '『磯分内』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.4989028719, 43.502505964, 144.7488884589, 43.335849242],
  },
  {
    id: '3445',
    title: '『陸別』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.4989915249, 43.50247585, 143.7489767639, 43.335817289],
  },
  {
    id: '3443',
    title: '『藻琴山』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.2489153919, 43.835787559, 144.4988974109, 43.669141108],
  },
  {
    id: '3441',
    title: '『阿寒湖』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [143.9989503499, 43.502491069, 144.2489336449, 43.335833481],
  },
  {
    id: '3442',
    title: '『弟子屈』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.2489308339, 43.502499383, 144.4989109389, 43.335838267],
  },
  {
    id: '3440',
    title: '『三溪』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.7490940559, 44.335656912, 141.9990820639, 44.16900673],
  },
  {
    id: '3439',
    title: '『幌加内』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [141.9990820639, 44.169023714, 142.2490703589, 44.002363303],
  },
  {
    id: '3438',
    title: '『知床岬』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [145.2487085429, 44.335742532, 145.4986980289, 44.169102582],
  },
  {
    id: '3437',
    title: '『岬』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [145.2487320159, 44.169106683, 145.4987097769, 44.00244348],
  },
  {
    id: '739',
    title: '『神戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fs206br6980',
    extent: [135.0001204, 34.83656656, 135.2501013, 34.66991514],
  },
  {
    id: '3436',
    title: '『ルシャ川』五万分一地形圖',
    source_uri: 'http://www.gsi.go.jp/',
    extent: [144.9987309869, 44.335733359, 145.2488143419, 44.16908434],
  },
  {
    id: '787',
    title: '『近江八幡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc418mk6604',
    extent: [136.0000275, 35.16988278, 136.2500038, 35.00322988],
  },
  {
    id: '816',
    title: '『彦根西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yn560bk7442',
    extent: [136.0000275, 35.33653017, 136.2500035, 35.16987655],
  },
  {
    id: '846',
    title: '『竹生島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zt128hp6132',
    extent: [136.0000247, 35.50317859, 136.2500006, 35.3365247],
  },
  {
    id: '866',
    title: '『丹後由良』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xb628rh2819',
    extent: [135.2500847, 35.66981252, 135.5000624, 35.50316416],
  },
  {
    id: '865',
    title: '『宮津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vg287bt4412',
    extent: [135.0001042, 35.66981252, 135.2500875, 35.50315986],
  },
  {
    id: '785',
    title: '『篠山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/th205td8364',
    extent: [135.000116, 35.16987049, 135.250097, 35.00321578],
  },
  {
    id: '1448',
    title: '『西興部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hb301fq3933',
    extent: [142.7490057, 44.33569606, 142.9989949, 44.16903833],
  },
  {
    id: '1373',
    title: '『十勝川上流』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zz189fv4341',
    extent: [142.7490558, 43.5024544, 142.999043, 43.33579602],
  },
  {
    id: '1388',
    title: '『旭岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qj416gs4700',
    extent: [142.7490458, 43.6691028, 142.9990337, 43.50244396],
  },
  {
    id: '1011',
    title: '『大子』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bw201dx8190',
    extent: [140.2495679, 36.8364503, 140.499553, 36.66979599],
  },
  // {"id":"1401","title":"『旭川』五万分一地形圖","source_uri":"http://purl.stanford.edu/vq340zj2486","extent":[142.2458816,43.83573336,142.4958667,43.66907457]},
  {
    id: '1401',
    title: '『旭川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vq340zj2486',
    extent: [142.2490701, 43.83573336, 142.499057, 43.66907457],
  },
  {
    id: '994',
    title: '『常陸大宮』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/np941by5341',
    extent: [140.2495749, 36.66980198, 140.4995583, 36.50314904],
  },
  {
    id: '974',
    title: '『栃木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kq749qd9094',
    extent: [139.4996479, 36.50313682, 139.7496319, 36.33648392],
  },
  {
    id: '992',
    title: '『宇都宮』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gb096nn2129',
    extent: [139.7496177, 36.6697896, 139.9996044, 36.50313682],
  },
  {
    id: '991',
    title: '『鹿沼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kd436mt5258',
    extent: [139.4996435, 36.66978396, 139.7496246, 36.50313123],
  },
  {
    id: '823',
    title: '『満島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vm372fz0294',
    extent: [137.7498529, 35.33657522, 137.9998328, 35.16992182],
  },
  {
    id: '1252',
    title: '『江差』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bc475fy6710',
    extent: [139.9993336, 42.00252749, 140.2493572, 41.83586138],
  },
  {
    id: '819',
    title: '『名古屋北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bh160xh4046',
    extent: [136.749943, 35.33654398, 136.9999258, 35.16989081],
  },
  {
    id: '1251',
    title: '『上ノ国』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tg515yp7196',
    extent: [139.9993428, 41.83588028, 140.2493651, 41.66922478],
  },
  {
    id: '1507',
    title: '『前橋』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pc043ys3215',
    extent: [138.9997104, 36.50311661, 139.2496826, 36.33647501],
  },
  {
    id: '1506',
    title: '『積丹岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hk399qf4067',
    extent: [140.2492432, 43.50240207, 140.4992623, 43.33571925],
  },
  {
    id: '1505',
    title: '『須美寿島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wy350db5629',
    extent: [139.9997883, 31.50370738, 140.2497737, 31.33705225],
  },
  {
    id: '1504',
    title: '『母島南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mp209sq9305',
    extent: [141.999778, 26.67090867, 142.2497638, 26.50425255],
  },
  {
    id: '1503',
    title: '『嫁島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sm559nt8009',
    extent: [141.9997549, 27.50416124, 142.2497407, 27.3375052],
  },
  {
    id: '1502',
    title: '『父島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn966bn5730',
    extent: [141.9997642, 27.17086036, 142.2497501, 27.00420429],
  },
  {
    id: '1501',
    title: '『母島北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dx090qz9203',
    extent: [141.9997734, 26.83755928, 142.2497592, 26.67090318],
  },
  {
    id: '1497',
    title: '『宗谷岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cx422vn9780',
    extent: [141.7490309, 45.66875273, 141.9990096, 45.5021449],
  },
  {
    id: '1499',
    title: '『弟島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xw002zn8557',
    extent: [141.9997596, 27.33751082, 142.2497454, 27.17085477],
  },
  {
    id: '1498',
    title: '『媒島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vb918kn7461',
    extent: [141.9997501, 27.67081162, 142.249736, 27.50415559],
  },
  {
    id: '1500',
    title: '『聟島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mf165zs8333',
    extent: [141.9997453, 27.83746194, 142.2497312, 27.67080594],
  },
  {
    id: '1496',
    title: '『知来別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dy941bm7042',
    extent: [141.9989267, 45.50215359, 142.2489146, 45.33550755],
  },
  {
    id: '1495',
    title: '『宗谷・稚内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bd525qp9440',
    extent: [141.7489507, 45.5021449, 141.9990096, 45.33553707],
  },
  {
    id: '1494',
    title: '『稚内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gc571kz4633',
    extent: [141.4989746, 45.50213625, 141.7490309, 45.33548169],
  },
  {
    id: '1493',
    title: '『礼文島北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rq552hd6282',
    extent: [140.9990229, 45.50211912, 141.2490101, 45.33547317],
  },
  {
    id: '1491',
    title: '『沼川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xj388qq8834',
    extent: [141.7490309, 45.33554518, 141.999019, 45.16889024],
  },
  {
    id: '1492',
    title: '『鬼志別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wr512rp0028',
    extent: [142.2489146, 45.33551627, 142.4989026, 45.16887017],
  },
  {
    id: '1490',
    title: '『抜海』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vb461xw6023',
    extent: [141.4989861, 45.33553707, 141.7490431, 45.16883569],
  },
  {
    id: '1489',
    title: '『利尻島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yw499gp9137',
    extent: [141.2490101, 45.33548169, 141.4989975, 45.16883569],
  },
  {
    id: '1488',
    title: '『礼文島南部・利尻島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xv948np1580',
    extent: [140.9990455, 45.33551152, 141.2490908, 45.16881876],
  },
  {
    id: '1487',
    title: '『目梨泊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vy926bz4283',
    extent: [142.4989026, 45.16887892, 142.7488907, 45.00223276],
  },
  {
    id: '1485',
    title: '『上猿払』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kk548wn9867',
    extent: [141.999019, 45.16890771, 142.2490057, 45.00225178],
  },
  {
    id: '1486',
    title: '『浜頓別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sn565wj3739',
    extent: [142.2489958, 45.16890771, 142.4989823, 45.00225992],
  },
  {
    id: '1484',
    title: '『豊富』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wn604jm6763',
    extent: [141.7490431, 45.16889831, 141.999029, 45.00224402],
  },
  {
    id: '1483',
    title: '『稚咲内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jk153sr9922',
    extent: [141.4989975, 45.16889024, 141.7490522, 45.00218965],
  },
  {
    id: '1481',
    title: '『利尻島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yg404zy4688',
    extent: [140.9990455, 45.16889024, 141.2490908, 45.00218965],
  },
  {
    id: '1482',
    title: '『利尻島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xs555hq7820',
    extent: [141.2490101, 45.16889024, 141.4989975, 45.00218965],
  },
  {
    id: '1479',
    title: '『中頓別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cs054qt7813',
    extent: [142.2490057, 45.00226837, 142.4989941, 44.8356125],
  },
  {
    id: '1480',
    title: '『枝幸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rt246cm2336',
    extent: [142.4989823, 45.00226837, 142.7489022, 44.83558656],
  },
  {
    id: '1478',
    title: '『敏音知』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn722qm7677',
    extent: [141.999029, 45.00225992, 142.2490155, 44.83560467],
  },
  {
    id: '1477',
    title: '『雄信内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vm541xg9382',
    extent: [141.7490522, 45.00225178, 141.99904, 44.83559687],
  },
  {
    id: '1475',
    title: '『内保』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dy974dt5290',
    extent: [146.9985161, 44.83575176, 147.2485068, 44.66909549],
  },
  {
    id: '1476',
    title: '『天塩』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bm287tf8360',
    extent: [141.4990088, 45.00224402, 141.7490625, 44.83554358],
  },
  {
    id: '1473',
    title: '『乙忠部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fg600ph4255',
    extent: [142.4989941, 44.83562222, 142.7489861, 44.6689741],
  },
  {
    id: '1474',
    title: '『音標』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xs148yj3465',
    extent: [142.7489022, 44.83559532, 142.9988904, 44.66894907],
  },
  {
    id: '1472',
    title: '『音威子府』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pz862py0420',
    extent: [142.2490155, 44.83562222, 142.4990059, 44.668965114],
  },
  {
    id: '1469',
    title: '『沢木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gn173yc7489',
    extent: [142.9988904, 44.66895785, 143.2488787, 44.50231154],
  },
  {
    id: '1471',
    title: '『天塩中川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tc475hx3892',
    extent: [141.99904, 44.8356125, 142.2490267, 44.66895568],
  },
  {
    id: '1470',
    title: '『遠別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dv138fz3472',
    extent: [141.7490332, 44.8356125, 141.9990707, 44.66895568],
  },
  {
    id: '1467',
    title: '『仁宇布』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gt791qw9320',
    extent: [142.4990173, 44.6689741, 142.7490057, 44.50231625],
  },
  {
    id: '1468',
    title: '『雄武』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wz108jn6283',
    extent: [142.7489861, 44.66898064, 142.9989741, 44.50233408],
  },
  {
    id: '1466',
    title: '『恩根内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wx690rr4410',
    extent: [142.2490267, 44.6689741, 142.4990173, 44.50231625],
  },
  {
    id: '1465',
    title: '『共和』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jx424pb5108',
    extent: [141.9990514, 44.66896511, 142.2490373, 44.50230773],
  },
  {
    id: '1463',
    title: '『紋別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh561md4470',
    extent: [143.2488787, 44.50232034, 143.498867, 44.33567396],
  },
  {
    id: '1464',
    title: '『初山別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nz723dc3368',
    extent: [141.7490332, 44.66896511, 141.9990707, 44.50230773],
  },
  {
    id: '1462',
    title: '『興部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/km955cm6597',
    extent: [142.9989741, 44.50234234, 143.2489651, 44.33569606],
  },
  {
    id: '1461',
    title: '『上興部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yr360vn7341',
    extent: [142.7489973, 44.50234234, 142.9989845, 44.33568647],
  },
  {
    id: '1460',
    title: '『サンル』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zz193pf6424',
    extent: [142.4990173, 44.50233408, 142.7490057, 44.33567716],
  },
  {
    id: '1459',
    title: '『名寄』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wq547bq0140',
    extent: [142.2490373, 44.50232581, 142.4990263, 44.33566876],
  },
  {
    id: '1457',
    title: '『天塩有明』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hn829vx5167',
    extent: [141.7490332, 44.50230773, 141.9990707, 44.33565088],
  },
  {
    id: '1458',
    title: '『ピッシリ山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qt180bt6568',
    extent: [141.9990616, 44.50231625, 142.2490478, 44.33566032],
  },
  {
    id: '1456',
    title: '『羽幌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vs136sz1185',
    extent: [141.4990421, 44.50226856, 141.7490938, 44.33560517],
  },
  {
    id: '1455',
    title: '『焼尻島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jh185cm6565',
    extent: [141.2490658, 44.50225134, 141.4990531, 44.33559681],
  },
  {
    id: '1454',
    title: '『礼文磯』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zp862kw2830',
    extent: [146.2486193, 44.33578315, 146.4986094, 44.16912709],
  },
  {
    id: '1451',
    title: '『中湧別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vk991tc1398',
    extent: [143.498867, 44.33568279, 143.7489415, 44.16906353],
  },
  {
    id: '1452',
    title: '『中湧別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wd753ff4686',
    extent: [143.7488441, 44.33569167, 143.9988328, 44.16904522],
  },
  {
    id: '1450',
    title: '『上渚滑』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc037kd5747',
    extent: [143.2489651, 44.33570469, 143.4989585, 44.16905546],
  },
  {
    id: '1453',
    title: '『摺鉢山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gh175dc4875',
    extent: [145.7486636, 44.33576446, 145.9986534, 44.16910855],
  },
  {
    id: '1449',
    title: '『滝上』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ft261yx3353',
    extent: [142.9989845, 44.33570469, 143.2489767, 44.16904653],
  },
  {
    id: '1447',
    title: '『下川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fx828qq3836',
    extent: [142.4990263, 44.33568647, 142.7490168, 44.16902895],
  },
  {
    id: '1445',
    title: '『添牛内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rs167hb4962',
    extent: [141.9990707, 44.33566876, 142.249059, 44.16901125],
  },
  {
    id: '1444',
    title: '『苫前』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mn230hw0241',
    extent: [141.4990639, 44.33566876, 141.7491142, 44.16901125],
  },
  {
    id: '1446',
    title: '『士別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pw419ks3920',
    extent: [142.2490478, 44.33567716, 142.499037, 44.1690205],
  },
  {
    id: '1443',
    title: '『古釜布』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jn272gs3319',
    extent: [145.7486756, 44.1691178, 145.9986653, 44.00246187],
  },
  {
    id: '1441',
    title: '『羅臼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mp609jy8941',
    extent: [144.9987425, 44.16910341, 145.2488141, 44.00244359],
  },
  {
    id: '1442',
    title: '『材木岩』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/td541nx4976',
    extent: [145.4986978, 44.16910855, 145.7486874, 44.00245271],
  },
  {
    id: '1440',
    title: '『宇登呂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tq212vd6761',
    extent: [144.7487649, 44.16908112, 144.9988421, 44.00242549],
  },
  {
    id: '1439',
    title: '『網走』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cv223yw9621',
    extent: [144.2488101, 44.16906307, 144.498799, 44.00241652],
  },
  {
    id: '1438',
    title: '『網走』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qd876zd6739',
    extent: [143.9988328, 44.16905412, 144.2489093, 44.00242685],
  },
  {
    id: '1437',
    title: '『サロマ湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zj280bd7331',
    extent: [143.7489415, 44.16906983, 143.9989287, 44.00242065],
  },
  {
    id: '1435',
    title: '『丸瀬布北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xy660hf1402',
    extent: [143.2489767, 44.16906353, 143.4989694, 44.0024072],
  },
  {
    id: '1436',
    title: '『遠軽』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pg771fj4778',
    extent: [143.4989585, 44.16906983, 143.7489497, 44.00241399],
  },
  {
    id: '1431',
    title: '『剣淵』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qd009ct5259',
    extent: [142.249059, 44.16902895, 142.4990477, 44.00237237],
  },
  {
    id: '1429',
    title: '『港町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pb814kz7539',
    extent: [141.4990639, 44.16900346, 141.7491142, 44.00231274],
  },
  {
    id: '1432',
    title: '『岩尾内湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dv359zk3610',
    extent: [142.499037, 44.16903833, 142.7490271, 44.00238102],
  },
  {
    id: '1434',
    title: '『立牛』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nq509ns3097',
    extent: [142.9990059, 44.16904653, 143.248997, 44.00239042],
  },
  {
    id: '1430',
    title: '『達布』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nd924vn8802',
    extent: [141.7491055, 44.16901125, 141.9990926, 44.00235541],
  },
  {
    id: '1433',
    title: '『渚滑岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jg107yb2606',
    extent: [142.7490168, 44.16904653, 142.9990059, 44.00239042],
  },
  {
    id: '1428',
    title: '『東沸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zh951wt8334',
    extent: [145.4987095, 44.00246187, 145.7486991, 43.83580602],
  },
  {
    id: '1426',
    title: '『峰浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bk616hq1578',
    extent: [144.7487765, 44.00245158, 144.9988473, 43.83579858],
  },
  {
    id: '1427',
    title: '『八木浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jc904jt1675',
    extent: [144.9988421, 44.00245158, 145.2487434, 43.83579692],
  },
  {
    id: '1425',
    title: '『斜里』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ks453fg5171',
    extent: [144.4988927, 44.00243292, 144.7488755, 43.83578636],
  },
  {
    id: '1423',
    title: '『女満別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bb557my3594',
    extent: [143.9989369, 44.00242685, 144.2489216, 43.83577383],
  },
  {
    id: '1424',
    title: '『小清水』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tb949sk9876',
    extent: [144.2489093, 44.00243292, 144.4988927, 43.83578636],
  },
  {
    id: '1422',
    title: '『端野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kp217wb3102',
    extent: [143.7489497, 44.00242685, 143.9989369, 43.83577383],
  },
  {
    id: '1421',
    title: '『生田原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sn519fw2715',
    extent: [143.4989694, 44.00242065, 143.7489587, 43.83576534],
  },
  {
    id: '1419',
    title: '『白滝』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ns602nx0395',
    extent: [142.9990059, 44.0024072, 143.248997, 43.83575072],
  },
  {
    id: '1420',
    title: '『丸瀬布南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dd611tc7884',
    extent: [143.2489853, 44.00241399, 143.4989775, 43.83575787],
  },
  {
    id: '1417',
    title: '『愛別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qy602yr2850',
    extent: [142.4990477, 44.00239042, 142.7490358, 43.83573336],
  },
  {
    id: '1418',
    title: '『上川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sf163ph2995',
    extent: [142.7490271, 44.0023986, 142.9990162, 43.8357419],
  },
  {
    id: '1416',
    title: '『比布』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zm115yt2020',
    extent: [142.2490701, 44.00238102, 142.499057, 43.83572371],
  },
  {
    id: '1415',
    title: '『鷹泊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ft438ns7558',
    extent: [141.9990926, 44.00237237, 142.2490816, 43.83571522],
  },
  {
    id: '1414',
    title: '『恵比島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rv108zz9254',
    extent: [141.7491142, 44.00236342, 141.9991017, 43.83570763],
  },
  {
    id: '1413',
    title: '『留萌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bv215mm7252',
    extent: [141.4990746, 44.00235541, 141.7491247, 43.83569991],
  },
  {
    id: '1412',
    title: '『米戸賀』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hc989qx1047',
    extent: [145.2487434, 43.83580602, 145.4987327, 43.66915024],
  },
  {
    id: '1411',
    title: '『薫別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ks156vs1610',
    extent: [144.998853, 43.83580364, 145.2488388, 43.66915105],
  },
  {
    id: '1410',
    title: '『武佐岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vc230qc0458',
    extent: [144.7488688, 43.83580364, 144.998853, 43.66915105],
  },
  {
    id: '1409',
    title: '『斜里岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zw720zq8756',
    extent: [144.4988927, 43.83579858, 144.7488755, 43.66914623],
  },
  {
    id: '1407',
    title: '『北見』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gm548nc1887',
    extent: [143.7489587, 43.83577999, 143.9989444, 43.66912443],
  },
  {
    id: '1408',
    title: '『美幌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yw196gn1627',
    extent: [143.9989369, 43.83578636, 144.2489216, 43.66913136],
  },
  {
    id: '1406',
    title: '『留辺蘂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sv729jg9962',
    extent: [143.4989775, 43.83577383, 143.7489651, 43.66911783],
  },
  {
    id: '1405',
    title: '『大和』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bf035mm2865',
    extent: [143.248997, 43.83576534, 143.4989827, 43.66911039],
  },
  {
    id: '1403',
    title: '『大雪山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mp513gv8304',
    extent: [142.7490358, 43.83575072, 142.9990249, 43.66909318],
  },
  {
    id: '1404',
    title: '『上支湧別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vk864nf9624',
    extent: [142.9990162, 43.83575787, 143.2490018, 43.6691028],
  },
  {
    id: '1400',
    title: '『深川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fs409zn9131',
    extent: [141.9991017, 43.83572371, 142.2490881, 43.66906698],
  },
  {
    id: '1398',
    title: '『国領』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sy953kp6030',
    extent: [141.4991445, 43.83570763, 141.7491335, 43.6690507],
  },
  {
    id: '1399',
    title: '『妹背牛』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tz372zz8872',
    extent: [141.7491247, 43.83571522, 141.9991117, 43.66905814],
  },
  {
    id: '1402',
    title: '『当麻』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nt584cc6369',
    extent: [142.499057, 43.8357419, 142.7490458, 43.6690856],
  },
  {
    id: '1396',
    title: '『野付崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tq565mh3570',
    extent: [145.2487548, 43.6691593, 145.4987442, 43.50251254],
  },
  {
    id: '1397',
    title: '『雄冬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ff922xr7550',
    extent: [141.2491086, 43.83569991, 141.4991549, 43.66901191],
  },
  {
    id: '1395',
    title: '『標津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nz897nd6779',
    extent: [144.998853, 43.6691591, 145.2488388, 43.50251325],
  },
  {
    id: '1394',
    title: '『中標津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vz912rj4614',
    extent: [144.7488755, 43.6691591, 144.9988603, 43.50250603],
  },
  {
    id: '1392',
    title: '『屈斜路湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sd381zq7692',
    extent: [144.2489216, 43.66914623, 144.4989025, 43.50249113],
  },
  {
    id: '1393',
    title: '『摩周湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/np019gh4673',
    extent: [144.4988972, 43.66915105, 144.7488804, 43.50249939],
  },
  {
    id: '1391',
    title: '『上里』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jd063zp3322',
    extent: [143.9989444, 43.66913788, 144.2489304, 43.50248383],
  },
  {
    id: '1389',
    title: '『石狩岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jh326wh7600',
    extent: [142.9990249, 43.66911039, 143.2490112, 43.5024544],
  },
  {
    id: '1390',
    title: '『常元』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qh771mm1777',
    extent: [143.2490018, 43.66911783, 143.4989912, 43.50246098],
  },
  {
    id: '1387',
    title: '『志比内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vt079fg8765',
    extent: [142.4990667, 43.66909318, 142.7490558, 43.50243553],
  },
  {
    id: '1386',
    title: '『美瑛』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pb787th5462',
    extent: [142.2490881, 43.6690856, 142.4990753, 43.50242416],
  },
  {
    id: '1385',
    title: '『赤平』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn687pt1869',
    extent: [141.9991117, 43.66907457, 142.2490955, 43.50241645],
  },
  {
    id: '1384',
    title: '『滝川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cg028df0608',
    extent: [141.7491335, 43.66906698, 141.9991228, 43.50240898],
  },
  {
    id: '1382',
    title: '『浜益』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fp812sb5933',
    extent: [141.2491191, 43.6690507, 141.4991632, 43.5023656],
  },
  {
    id: '1381',
    title: '『納沙布』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gf777px5568',
    extent: [145.7487222, 43.50253076, 145.9987118, 43.33588391],
  },
  {
    id: '1380',
    title: '『根室北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xh534yt6111',
    extent: [145.4987442, 43.50252163, 145.7487987, 43.33586575],
  },
  {
    id: '1383',
    title: '『吉野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tq652gg2776',
    extent: [141.4991549, 43.66905814, 141.7491424, 43.50240207],
  },
  {
    id: '1378',
    title: '『別海』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mn461mr6775',
    extent: [144.9988603, 43.50251923, 145.2488437, 43.33586833],
  },
  {
    id: '1376',
    title: '『上足寄』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gx840fj5065',
    extent: [143.7489765, 43.50246846, 143.9989642, 43.33581167],
  },
  {
    id: '1374',
    title: '『糠平』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/my682qf7398',
    extent: [142.9990337, 43.50246098, 143.2490222, 43.33580498],
  },
  {
    id: '1375',
    title: '『芽登温泉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xm591xf2630',
    extent: [143.2490112, 43.50246846, 143.4990007, 43.33581167],
  },
  {
    id: '1377',
    title: '『計根別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dg771fn5216',
    extent: [144.7488804, 43.50251325, 144.9988669, 43.33586022],
  },
  {
    id: '1372',
    title: '『十勝岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qz496hb1257',
    extent: [142.4990753, 43.50244396, 142.7490643, 43.33578522],
  },
  {
    id: '1371',
    title: '『富良野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bx561dj9658',
    extent: [142.2490955, 43.50243553, 142.4990849, 43.33577827],
  },
  {
    id: '1369',
    title: '『砂川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hx768vg9934',
    extent: [141.7491517, 43.50240898, 141.9991391, 43.33575314],
  },
  {
    id: '1368',
    title: '『月形』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wv378vq3043',
    extent: [141.4991632, 43.50240898, 141.7491517, 43.33575314],
  },
  {
    id: '1370',
    title: '『上芦別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jp783cy0419',
    extent: [141.9991228, 43.50242416, 142.2491102, 43.33576691],
  },
  {
    id: '1367',
    title: '『厚田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sf718sg6263',
    extent: [141.2491295, 43.50240207, 141.4991734, 43.33571925],
  },
  {
    id: '1366',
    title: '『根室南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wq772gb1819',
    extent: [145.4987555, 43.33589014, 145.7487987, 43.16922796],
  },
  {
    id: '1365',
    title: '『厚床』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bt252qb4600',
    extent: [145.2488437, 43.33587574, 145.4988273, 43.16923046],
  },
  {
    id: '1364',
    title: '『姉別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vb038hr7092',
    extent: [144.9988669, 43.33587574, 145.2488506, 43.16922277],
  },
  {
    id: '1363',
    title: '『標茶』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nt411jx2072',
    extent: [144.4989106, 43.33586022, 144.7488957, 43.1692059],
  },
  {
    id: '1379',
    title: '『別海』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py134jm7413',
    extent: [145.2488388, 43.50251923, 145.4987555, 43.33586575],
  },
  {
    id: '1362',
    title: '『ウコタキヌプリ』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jr431yq4417',
    extent: [143.7489765, 43.33583686, 143.9989642, 43.16918141],
  },
  {
    id: '1359',
    title: '『佐幌岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vv105qp3962',
    extent: [142.7490643, 43.33580498, 142.999052, 43.16914662],
  },
  {
    id: '1361',
    title: '『足寄太』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hy867pm7115',
    extent: [143.4990007, 43.33582791, 143.7489863, 43.16917096],
  },
  {
    id: '1358',
    title: '『西達布』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wz728bt5394',
    extent: [142.4990849, 43.33579602, 142.7490717, 43.16913772],
  },
  {
    id: '1360',
    title: '『上士幌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bj776jv8628',
    extent: [143.2490222, 43.33582084, 143.4990063, 43.16916333],
  },
  {
    id: '1357',
    title: '『山部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cc384nd2438',
    extent: [142.2491102, 43.33578522, 142.4990934, 43.16912864],
  },
  {
    id: '1356',
    title: '『幾春別岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rp834zx4717',
    extent: [141.9991362, 43.33577827, 142.2491256, 43.16912034],
  },
  {
    id: '1353',
    title: '『石狩』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hw356hv7926',
    extent: [141.2491398, 43.33575314, 141.4991824, 43.16909576],
  },
  {
    id: '1355',
    title: '『岩見沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wk412nf2957',
    extent: [141.7491517, 43.33576691, 141.9991391, 43.16911274],
  },
  {
    id: '1354',
    title: '『当別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cx143gy5368',
    extent: [141.4991734, 43.33576065, 141.7491613, 43.16910429],
  },
  {
    id: '1352',
    title: '『小樽東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kv323jy3525',
    extent: [140.999163, 43.33571925, 141.2492041, 43.16908825],
  },
  {
    id: '1351',
    title: '『小樽西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wd606ws0671',
    extent: [140.7492435, 43.33572376, 140.9992343, 43.16907306],
  },
  {
    id: '1350',
    title: '『古平』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sq842dx6340',
    extent: [140.4992522, 43.33572376, 140.7492435, 43.16907306],
  },
  {
    id: '1349',
    title: '『余別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vd614sb6922',
    extent: [140.2492432, 43.33572376, 140.4992623, 43.16907306],
  },
  {
    id: '1348',
    title: '『落石岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bg266px5594',
    extent: [145.2487998, 43.16923773, 145.4988273, 43.00256311],
  },
  {
    id: '1346',
    title: '『厚岸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ch508vw8100',
    extent: [144.7488804, 43.16921428, 144.9988669, 43.00255912],
  },
  {
    id: '1347',
    title: '『霧多布』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jv873fx6370',
    extent: [144.9988734, 43.16923046, 145.2488506, 43.00256311],
  },
  {
    id: '1345',
    title: '『尾幌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bf521rj9095',
    extent: [144.4989179, 43.16921428, 144.7488957, 43.00255912],
  },
  {
    id: '1344',
    title: '『大楽毛』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ky299cf5346',
    extent: [144.2489413, 43.1692059, 144.4989255, 43.0025497],
  },
  {
    id: '1343',
    title: '『阿寒』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wg393yn4261',
    extent: [143.9989642, 43.16919631, 144.2489514, 43.00254178],
  },
  {
    id: '1342',
    title: '『本別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yh267qw3290',
    extent: [143.4990063, 43.16918141, 143.7489962, 43.0025242],
  },
  {
    id: '1341',
    title: '『中士幌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mq905sd7415',
    extent: [142.999052, 43.16916333, 143.2490401, 43.00250746],
  },
  {
    id: '1340',
    title: '『新得』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tb462cc5639',
    extent: [142.7490717, 43.16915603, 142.9990609, 43.00249816],
  },
  {
    id: '1339',
    title: '『落合』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hn424kr6627',
    extent: [142.4990934, 43.16914662, 142.7490805, 43.0024897],
  },
  {
    id: '1338',
    title: '『石狩金山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sp940mt8807',
    extent: [142.2491256, 43.16913772, 142.4991043, 43.00248206],
  },
  {
    id: '1337',
    title: '『石狩鹿島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gq081mq0241',
    extent: [141.9991362, 43.16912864, 142.2491276, 43.00247191],
  },
  {
    id: '1336',
    title: '『夕張』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cx337vv9099',
    extent: [141.7491613, 43.16912034, 141.9991461, 43.00246409],
  },
  {
    id: '1335',
    title: '『江別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pk212rr1176',
    extent: [141.4991824, 43.16911274, 141.749169, 43.00245601],
  },
  {
    id: '1334',
    title: '『札幌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xj296tg8907',
    extent: [141.2492041, 43.16910429, 141.4991915, 43.00244929],
  },
  {
    id: '1333',
    title: '『銭函』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ws202nh2045',
    extent: [140.9992265, 43.16909576, 141.2492136, 43.00244119],
  },
  {
    id: '1332',
    title: '『仁木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gg326xf0393',
    extent: [140.7492435, 43.16908825, 140.9992343, 43.00243192],
  },
  {
    id: '1331',
    title: '『神恵内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cf455dg4393',
    extent: [140.2492432, 43.16907306, 140.4992623, 43.00239429],
  },
  {
    id: '1329',
    title: '『音別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jz913np7995',
    extent: [143.7489962, 43.00254178, 143.9989741, 42.83587232],
  },
  {
    id: '1330',
    title: '『昆布森』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sk001gh2258',
    extent: [144.4988767, 43.00256168, 144.7488909, 42.83588974],
  },
  {
    id: '1328',
    title: '『常室』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ty880wq8682',
    extent: [143.4990163, 43.00253194, 143.7490071, 42.83587729],
  },
  {
    id: '1327',
    title: '『十勝池田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hz197pz8951',
    extent: [143.2490401, 43.0025242, 143.4990251, 42.83586951],
  },
  {
    id: '1326',
    title: '『帯広』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nv409zx0920',
    extent: [142.9990609, 43.00251535, 143.2490492, 42.83586004],
  },
  {
    id: '1325',
    title: '『御影』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vp260rp3728',
    extent: [142.7490805, 43.00250746, 142.9990708, 42.83585156],
  },
  {
    id: '1324',
    title: '『千栄』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gj412cv0636',
    extent: [142.4991043, 43.00249816, 142.7490913, 42.83584332],
  },
  {
    id: '1323',
    title: '『日高』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ws630wb3843',
    extent: [142.2491276, 43.0024897, 142.4991145, 42.83583386],
  },
  {
    id: '1322',
    title: '『紅葉山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bp230ng0408',
    extent: [141.9991461, 43.00248206, 142.2491355, 42.835826],
  },
  {
    id: '1321',
    title: '『追分』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bm220tc0473',
    extent: [141.749169, 43.00247191, 141.9991564, 42.835818],
  },
  {
    id: '1320',
    title: '『恵庭』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gq325rd4323',
    extent: [141.4991915, 43.00246409, 141.7491774, 42.83580807],
  },
  {
    id: '1319',
    title: '『石山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ct580jc6541',
    extent: [141.2492136, 43.00245601, 141.499202, 42.83580057],
  },
  {
    id: '1317',
    title: '『倶知安』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py949bw6898',
    extent: [140.7492541, 43.00244119, 140.9992427, 42.83578381],
  },
  {
    id: '1318',
    title: '『定山渓』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hv049td1033',
    extent: [140.9992343, 43.00244929, 141.2492231, 42.83579156],
  },
  {
    id: '1316',
    title: '『岩内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rm830hx3210',
    extent: [140.4992401, 43.00243192, 140.749264, 42.83577693],
  },
  {
    id: '1315',
    title: '『島古丹』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dx890wh1783',
    extent: [140.2492531, 43.00240764, 140.499285, 42.83574794],
  },
  {
    id: '1314',
    title: '『厚内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dz131vn4639',
    extent: [143.7489539, 42.83588558, 143.9989317, 42.66921695],
  },
  {
    id: '1313',
    title: '『浦幌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rx893jp3821',
    extent: [143.4990251, 42.83588558, 143.7490071, 42.66921695],
  },
  {
    id: '1312',
    title: '『糠内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kj582nv9093',
    extent: [143.2490492, 42.83587729, 143.4990387, 42.66922002],
  },
  {
    id: '1311',
    title: '『大正』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kr124rp0015',
    extent: [142.9990708, 42.83586951, 143.2490586, 42.6692112],
  },
  {
    id: '1310',
    title: '『岩知志』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py079hb0288',
    extent: [142.2491355, 42.83584332, 142.499123, 42.66918697],
  },
  {
    id: '1309',
    title: '『穂別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ts752nm3363',
    extent: [141.9991564, 42.83583386, 142.2491454, 42.66917725],
  },
  {
    id: '1308',
    title: '『早来』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tn163ch4063',
    extent: [141.7491774, 42.835826, 141.9991669, 42.6691698],
  },
  {
    id: '1305',
    title: '『双葉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn538vx4532',
    extent: [140.9992427, 42.83580057, 141.2492335, 42.66914361],
  },
  {
    id: '1307',
    title: '『千歳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rp293sn5184',
    extent: [141.4991915, 42.835818, 141.749169, 42.66915071],
  },
  {
    id: '1303',
    title: '『ニセコ』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xm969vd7626',
    extent: [140.499285, 42.83578381, 140.7492723, 42.66912871],
  },
  {
    id: '1304',
    title: '『留寿都』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bs659ff3817',
    extent: [140.749264, 42.83579156, 140.9992512, 42.66913551],
  },
  {
    id: '1306',
    title: '『樽前山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yr749rh9869',
    extent: [141.2492231, 42.83580807, 141.4992156, 42.66915071],
  },
  {
    id: '1302',
    title: '『歌棄』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ty772gg4081',
    extent: [140.2492629, 42.83577693, 140.4992944, 42.66912294],
  },
  {
    id: '1300',
    title: '『原歌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tc192qz6527',
    extent: [139.7493096, 42.83574005, 139.9993353, 42.66908588],
  },
  {
    id: '1298',
    title: '『上札内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tr780kv5299',
    extent: [142.9990817, 42.66922002, 143.2490684, 42.50256274],
  },
  {
    id: '1299',
    title: '『忠類』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fk351yv1204',
    extent: [143.2490586, 42.66923017, 143.4990387, 42.50256163],
  },
  {
    id: '1297',
    title: '『札内川上流』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vc316sh0555',
    extent: [142.7491015, 42.6692112, 142.999093, 42.50255474],
  },
  {
    id: '1301',
    title: '『寿都』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dk361jr7644',
    extent: [139.9992862, 42.83574794, 140.2493141, 42.66911648],
  },
  {
    id: '1296',
    title: '『イドンナップ岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vw260hn9554',
    extent: [142.499123, 42.66920262, 142.7491127, 42.50254622],
  },
  {
    id: '1295',
    title: '『新和』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hp749wh3170',
    extent: [142.2491454, 42.66919466, 142.4991325, 42.50253844],
  },
  {
    id: '1294',
    title: '『富川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/df532qn4698',
    extent: [141.9991669, 42.66918697, 142.2491536, 42.50253019],
  },
  {
    id: '1292',
    title: '『苫小牧』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gg525kb3689',
    extent: [141.4991915, 42.66915071, 141.749169, 42.50249511],
  },
  {
    id: '1291',
    title: '『白老』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gc656yb9866',
    extent: [141.2492335, 42.66915994, 141.4992156, 42.50249511],
  },
  {
    id: '1293',
    title: '『鵡川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mg596wk9770',
    extent: [141.7491442, 42.66917725, 141.9991769, 42.50250325],
  },
  {
    id: '1290',
    title: '『徳舜瞥山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wg860qc9421',
    extent: [140.9992512, 42.66915071, 141.2492397, 42.50249818],
  },
  {
    id: '1288',
    title: '『豊浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh744gc9157',
    extent: [140.499259, 42.66913551, 140.7492723, 42.50246304],
  },
  {
    id: '1287',
    title: '『長万部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ps291sf2151',
    extent: [140.2493141, 42.66912871, 140.4992944, 42.50246304],
  },
  {
    id: '1289',
    title: '『虻田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc549wg0859',
    extent: [140.7492359, 42.66914361, 140.9992586, 42.50247098],
  },
  {
    id: '1286',
    title: '『大平山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cj422fk7676',
    extent: [139.9993353, 42.66912294, 140.2493221, 42.50246727],
  },
  {
    id: '1285',
    title: '『狩場山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cg144rh3894',
    extent: [139.7493192, 42.66911648, 139.9993422, 42.50243951],
  },
  {
    id: '1284',
    title: '『大樹』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gc449gx7180',
    extent: [143.2490684, 42.50257127, 143.4989969, 42.33591484],
  },
  {
    id: '1283',
    title: '『上豊似』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wj252dn6880',
    extent: [142.999093, 42.50257127, 143.2490782, 42.33591466],
  },
  {
    id: '1282',
    title: '『神威岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sr082bp9988',
    extent: [142.7491127, 42.50256274, 142.9991038, 42.33590601],
  },
  {
    id: '1280',
    title: '『静内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xs078mk0557',
    extent: [142.2491089, 42.50254622, 142.4991434, 42.33587303],
  },
  {
    id: '1281',
    title: '『農屋』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qd981ns4770',
    extent: [142.4991325, 42.50255474, 142.7491257, 42.33589693],
  },
  {
    id: '1279',
    title: '『門別』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rt334gs5040',
    extent: [141.9991315, 42.50253844, 142.2491536, 42.33586481],
  },
  {
    id: '1278',
    title: '『登別温泉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tq896wh6400',
    extent: [140.9992586, 42.50250241, 141.2492397, 42.33584046],
  },
  {
    id: '1276',
    title: '『国縫』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cj670pf1177',
    extent: [140.2493221, 42.50247515, 140.4992686, 42.33581656],
  },
  {
    id: '1275',
    title: '『今金』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kw025wf3758',
    extent: [139.9993422, 42.50247515, 140.249331, 42.33581741],
  },
  {
    id: '1273',
    title: '『広尾』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hc778jb8244',
    extent: [143.2490782, 42.33592397, 143.4990071, 42.16926803],
  },
  {
    id: '1274',
    title: '『瀬棚』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jv264cr9624',
    extent: [139.7493287, 42.50246727, 139.9993498, 42.33579665],
  },
  {
    id: '1277',
    title: '『伊達』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ry093tf6718',
    extent: [140.7492359, 42.50249818, 140.9992682, 42.33582447],
  },
  {
    id: '1272',
    title: '『楽古岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dh293zj9719',
    extent: [142.9991038, 42.33592397, 143.2490917, 42.1692671],
  },
  {
    id: '1269',
    title: '『東静内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bd534br4474',
    extent: [142.2491089, 42.33589693, 142.4991434, 42.16922634],
  },
  {
    id: '1271',
    title: '『西舎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hy599vn6155',
    extent: [142.7491257, 42.33591466, 142.999116, 42.16925652],
  },
  {
    id: '1268',
    title: '『室蘭』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rr083kf0955',
    extent: [140.7492456, 42.33584685, 140.9992682, 42.16917795],
  },
  {
    id: '1270',
    title: '『三石』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tv980hm6236',
    extent: [142.4990963, 42.33590601, 142.7491379, 42.16923458],
  },
  {
    id: '1267',
    title: '『八雲』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cz998dn0802',
    extent: [140.249331, 42.33582678, 140.4992781, 42.16917005],
  },
  {
    id: '1266',
    title: '『遊楽部岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zp845gc7145',
    extent: [139.9993498, 42.33582678, 140.249341, 42.16916878],
  },
  {
    id: '1265',
    title: '『久遠』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dk314vm7779',
    extent: [139.7493455, 42.33581741, 139.9993608, 42.16914668],
  },
  {
    id: '1263',
    title: '『奥尻島北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ns533sh2523',
    extent: [139.2493848, 42.33578539, 139.4994032, 42.16913135],
  },
  {
    id: '1264',
    title: '『奥尻島北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qc254pr7921',
    extent: [139.4993614, 42.33579665, 139.7493475, 42.16914668],
  },
  {
    id: '1262',
    title: '『庶野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pk272qj5434',
    extent: [143.2490917, 42.16927665, 143.4990173, 42.00262116],
  },
  {
    id: '1260',
    title: '『鹿部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wn422jc0584',
    extent: [140.7492552, 42.16918589, 140.9992418, 42.00253929],
  },
  {
    id: '1261',
    title: '『えりも』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hr248zq2387',
    extent: [142.9990616, 42.16927665, 143.2491039, 42.0026044],
  },
  {
    id: '1259',
    title: '『駒ヶ岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dp987tm2672',
    extent: [140.4992781, 42.16917795, 140.7493077, 42.00253535],
  },
  {
    id: '1256',
    title: '『熊石』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sp895qb5096',
    extent: [139.7493475, 42.16916878, 139.9993608, 42.0025002],
  },
  {
    id: '1257',
    title: '『相沼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wy188xq7356',
    extent: [139.9993336, 42.16917594, 140.2493488, 42.00250792],
  },
  {
    id: '1258',
    title: '『濁川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sx915mp3253',
    extent: [140.249341, 42.16917594, 140.4993284, 42.00252749],
  },
  {
    id: '1255',
    title: '『奥尻島南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vc391bq0493',
    extent: [139.4993799, 42.16915263, 139.7493567, 42.00249254],
  },
  {
    id: '1254',
    title: '『奥尻西南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tv495qj7973',
    extent: [139.249394, 42.16915263, 139.4994032, 42.00248492],
  },
  {
    id: '1249',
    title: '『近川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ch247vx7501',
    extent: [141.2492659, 41.33596832, 141.4992435, 41.16931361],
  },
  {
    id: '1250',
    title: '『大畑』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yf903fb6617',
    extent: [140.99927, 41.50260717, 141.2493019, 41.33595587],
  },
  {
    id: '1253',
    title: '『襟裳岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rk272mh3465',
    extent: [142.9990616, 42.00263026, 143.2491039, 41.83595756],
  },
  {
    id: '1248',
    title: '『むつ』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ts241qt7878',
    extent: [140.9992884, 41.33596308, 141.2493019, 41.16930577],
  },
  {
    id: '1247',
    title: '『陸奥横浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jk746vc9948',
    extent: [141.2492659, 41.1693215, 141.4992527, 41.00266238],
  },
  {
    id: '1246',
    title: '『平沼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mq476jd7459',
    extent: [141.2493165, 41.00267463, 141.4992618, 40.836016],
  },
  {
    id: '1245',
    title: '『油川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fz005wh2138',
    extent: [140.4993772, 41.00265119, 140.749364, 40.83599686],
  },
  {
    id: '1242',
    title: '『七戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xz446tr5065',
    extent: [140.9993424, 40.836016, 141.2493293, 40.6693621],
  },
  {
    id: '1243',
    title: '『三沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gh320pt3686',
    extent: [141.2493232, 40.83602773, 141.4992709, 40.66936787],
  },
  {
    id: '1241',
    title: '『青森東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kc798mf1081',
    extent: [140.749364, 40.83601016, 140.9993502, 40.66935495],
  },
  {
    id: '1244',
    title: '『金木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bk474pr1090',
    extent: [140.2493652, 41.00264595, 140.4993839, 40.83598938],
  },
  {
    id: '1240',
    title: '『青森西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hk968xp6833',
    extent: [140.4993839, 40.83600303, 140.749371, 40.66934741],
  },
  {
    id: '1239',
    title: '『五所川原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ps894tm2957',
    extent: [140.2493812, 40.83599686, 140.4993909, 40.66934013],
  },
  {
    id: '1238',
    title: '『鰺ヶ沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mv665mn8921',
    extent: [139.9993966, 40.83598938, 140.2494109, 40.66933289],
  },
  {
    id: '1237',
    title: '『驫木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gm497vj2125',
    extent: [139.7494194, 40.83598145, 139.9994345, 40.66932715],
  },
  {
    id: '1236',
    title: '『八戸東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yw324jk0627',
    extent: [141.4992709, 40.66938865, 141.7492577, 40.5027266],
  },
  {
    id: '1235',
    title: '『八戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vh117gw5588',
    extent: [141.2493293, 40.6693808, 141.4993115, 40.5027205],
  },
  {
    id: '1234',
    title: '『十和田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pb426mk7540',
    extent: [140.9993502, 40.66936787, 141.2493348, 40.50271449],
  },
  {
    id: '1232',
    title: '『黒石』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yn060jf2829',
    extent: [140.4993909, 40.66935495, 140.7493772, 40.50270065],
  },
  {
    id: '1233',
    title: '『八甲田山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wc926bq3228',
    extent: [140.749371, 40.6693621, 140.9993567, 40.50270869],
  },
  {
    id: '1230',
    title: '『深浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zg682bq6104',
    extent: [139.749428, 40.66933289, 139.9994423, 40.50268036],
  },
  {
    id: '1231',
    title: '『弘前』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pp034hs6992',
    extent: [140.2494109, 40.66934741, 140.4993988, 40.50269337],
  },
  {
    id: '1229',
    title: '『階上岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fn681yy4919',
    extent: [141.7492577, 40.50274953, 141.9992447, 40.33608818],
  },
  {
    id: '1228',
    title: '『階上岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nh084fb4022',
    extent: [141.4993115, 40.50274165, 141.7492932, 40.33608113],
  },
  {
    id: '1227',
    title: '『三戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hc520cg7913',
    extent: [141.2493348, 40.5027266, 141.4993177, 40.33607475],
  },
  {
    id: '1226',
    title: '『田子』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fp214tk0767',
    extent: [140.9993567, 40.5027205, 141.2493421, 40.3360679],
  },
  {
    id: '1225',
    title: '『十和田湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qj658wc2891',
    extent: [140.7493772, 40.50271449, 140.9993643, 40.33606047],
  },
  {
    id: '1224',
    title: '『碇ヶ関』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qq174rs8653',
    extent: [140.4993988, 40.50270869, 140.7493848, 40.3360534],
  },
  {
    id: '1222',
    title: '『中浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zt926mp2020',
    extent: [139.9994226, 40.50269337, 140.249429, 40.33604099],
  },
  {
    id: '1223',
    title: '『田代岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bz237rq0572',
    extent: [140.249421, 40.50270065, 140.4994075, 40.33604645],
  },
  {
    id: '1221',
    title: '『久慈』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rc261fk6432',
    extent: [141.7492932, 40.33610246, 141.9992536, 40.16943965],
  },
  {
    id: '1219',
    title: '『一戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hp697dv0694',
    extent: [141.2493421, 40.33608113, 141.4993238, 40.16942837],
  },
  {
    id: '1220',
    title: '『陸中大野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gz075hk1539',
    extent: [141.4993177, 40.33608818, 141.7493013, 40.16943445],
  },
  {
    id: '1218',
    title: '『浄法寺』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nt825bk5787',
    extent: [140.9993643, 40.33607475, 141.2493468, 40.16942152],
  },
  {
    id: '1216',
    title: '『鷹巣』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zx949pq9528',
    extent: [140.249429, 40.3360534, 140.4994154, 40.1694004],
  },
  {
    id: '1217',
    title: '『大館』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yd639hn9787',
    extent: [140.4994075, 40.33606047, 140.7493913, 40.16940638],
  },
  {
    id: '1215',
    title: '『能代』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hw539rp3933',
    extent: [139.9994226, 40.33604645, 140.2494376, 40.16939337],
  },
  {
    id: '1214',
    title: '『陸中野田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/np772hr1929',
    extent: [141.7493013, 40.16945537, 141.9992624, 40.00279415],
  },
  {
    id: '1213',
    title: '『陸中関』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zp748vz9274',
    extent: [141.4993238, 40.16943965, 141.7493086, 40.00278801],
  },
  {
    id: '1212',
    title: '『葛巻』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py076zd0669',
    extent: [141.2493468, 40.16943445, 141.4993296, 40.00278155],
  },
  {
    id: '1211',
    title: '『荒屋』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yb424vs0558',
    extent: [140.9993708, 40.16942837, 141.249351, 40.00277405],
  },
  {
    id: '1210',
    title: '『田山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hh236wr1686',
    extent: [140.7493913, 40.16942152, 140.999377, 40.00276568],
  },
  {
    id: '1209',
    title: '『大葛』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bb610rn9916',
    extent: [140.4994154, 40.16941493, 140.7493998, 40.00275944],
  },
  {
    id: '1207',
    title: '『森岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ss018bw2455',
    extent: [139.9994616, 40.1694004, 140.2494455, 40.00274559],
  },
  {
    id: '1208',
    title: '『米内沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tk552pz7557',
    extent: [140.2494376, 40.16940638, 140.4994231, 40.00275169],
  },
  {
    id: '1206',
    title: '『岩泉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dr618gr2072',
    extent: [141.7493086, 40.00280822, 141.9992868, 39.83614717],
  },
  {
    id: '1205',
    title: '『門』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gd769jz4952',
    extent: [141.4993296, 40.00279415, 141.7493129, 39.83614108],
  },
  {
    id: '1204',
    title: '『藪川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fy268ms8725',
    extent: [141.249351, 40.00278801, 141.4993352, 39.83613523],
  },
  {
    id: '1203',
    title: '『沼宮内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cz899gh9732',
    extent: [140.999377, 40.00278155, 141.2493564, 39.83612722],
  },
  {
    id: '1202',
    title: '『八幡平』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mc601vd5724',
    extent: [140.7493998, 40.00277405, 140.99938, 39.83611871],
  },
  {
    id: '1201',
    title: '『森吉山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rx428cc0233',
    extent: [140.4994231, 40.00276568, 140.7494078, 39.83611101],
  },
  {
    id: '1200',
    title: '『阿仁合』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fw650vc0097',
    extent: [140.2494455, 40.00275944, 140.4994312, 39.83610354],
  },
  {
    id: '1198',
    title: '『戸賀』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pk908wr5559',
    extent: [139.4995169, 40.00274559, 139.7495027, 39.83609281],
  },
  {
    id: '1199',
    title: '『船川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fs463gs0397',
    extent: [139.7494619, 40.00274559, 139.9994729, 39.83609281],
  },
  {
    id: '1197',
    title: '『田老』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hx474kc9906',
    extent: [141.7493129, 39.83615474, 141.999292, 39.6695012],
  },
  {
    id: '1196',
    title: '『外山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mj029ph5156',
    extent: [141.2493564, 39.83614108, 141.4993411, 39.66948687],
  },
  {
    id: '1195',
    title: '『盛岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dc268zt2002',
    extent: [140.99938, 39.83613523, 141.2493617, 39.66947929],
  },
  {
    id: '1194',
    title: '『雫石』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rn152qs5815',
    extent: [140.7494078, 39.83612722, 140.9993853, 39.66947105],
  },
  {
    id: '1193',
    title: '『田沢湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wp724cd4772',
    extent: [140.4994312, 39.83611871, 140.7494111, 39.66946259],
  },
  {
    id: '1192',
    title: '『太平山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fx428bn1290',
    extent: [140.2494679, 39.83611101, 140.4994452, 39.66946259],
  },
  {
    id: '1191',
    title: '『秋田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ck394yd1365',
    extent: [139.9994561, 39.83610354, 140.2494611, 39.6694532],
  },
  {
    id: '1190',
    title: '『魹崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fj251ph3384',
    extent: [141.999292, 39.66952163, 142.2492669, 39.50285877],
  },
  {
    id: '4266',
    title: '『宮古』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zz473nh9056',
    extent: [141.7493181, 39.66950771, 141.9993031, 39.50285262],
  },
  {
    id: '1188',
    title: '『早池峰山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xx311ys3713',
    extent: [141.2493617, 39.66949395, 141.499346, 39.50283994],
  },
  {
    id: '1186',
    title: '『鶯宿』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zf694xd7563',
    extent: [140.7494111, 39.66947929, 140.9993911, 39.50282319],
  },
  {
    id: '1187',
    title: '『日詰』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ym132np1127',
    extent: [140.9993853, 39.66948687, 141.2493681, 39.50283269],
  },
  {
    id: '1185',
    title: '『角館』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ss686hg9899',
    extent: [140.4994386, 39.66947105, 140.749417, 39.50281815],
  },
  {
    id: '1182',
    title: '『霞露岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jm091qy9409',
    extent: [141.9993031, 39.50287434, 142.2492755, 39.33621233],
  },
  {
    id: '1183',
    title: '『羽後和田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/px665jq1821',
    extent: [139.9994561, 39.66945653, 140.2494679, 39.50280616],
  },
  {
    id: '1184',
    title: '『刈和野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dh583bw5229',
    extent: [140.2494611, 39.66946259, 140.4994452, 39.50281127],
  },
  {
    id: '1180',
    title: '『土淵』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zr108wb8770',
    extent: [141.499346, 39.50285262, 141.7493295, 39.33619884],
  },
  {
    id: '1181',
    title: '『大槌』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xq791tq0846',
    extent: [141.7493252, 39.50285877, 141.9993048, 39.33620506],
  },
  {
    id: '1178',
    title: '『新町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cq918mr2233',
    extent: [140.749417, 39.50283269, 140.9993961, 39.33617856],
  },
  {
    id: '1179',
    title: '『大迫』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mr152pc8632',
    extent: [141.2493681, 39.50284679, 141.4993528, 39.33619232],
  },
  {
    id: '1177',
    title: '『六郷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yc675sy2797',
    extent: [140.4994452, 39.50282319, 140.7494213, 39.33617077],
  },
  {
    id: '1176',
    title: '『大曲』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cn662mb2746',
    extent: [140.2494679, 39.50281815, 140.4994516, 39.3361657],
  },
  {
    id: '1175',
    title: '『本荘』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vj870sh4198',
    extent: [139.9994643, 39.50281127, 140.2494758, 39.33615906],
  },
  {
    id: '1174',
    title: '『遠野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yj955pw5941',
    extent: [141.4993528, 39.33620506, 141.7493368, 39.16955119],
  },
  {
    id: '1173',
    title: '『人首』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vy114wv0302',
    extent: [141.2493748, 39.33619884, 141.4993584, 39.16954479],
  },
  {
    id: '1172',
    title: '『北上』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nj835pk8809',
    extent: [140.9993961, 39.33619232, 141.2493798, 39.16953786],
  },
  {
    id: '1171',
    title: '『川尻』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qh269yy5828',
    extent: [140.7494213, 39.33618676, 140.9994018, 39.16953075],
  },
  {
    id: '1170',
    title: '『横手』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/db518qp0542',
    extent: [140.4994516, 39.33617856, 140.7494271, 39.16952281],
  },
  {
    id: '1168',
    title: '『矢島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yr250xn6433',
    extent: [139.999495, 39.3361657, 140.2494787, 39.16950926],
  },
  {
    id: '1169',
    title: '『浅舞』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wp653qg5885',
    extent: [140.2494758, 39.33617077, 140.4994572, 39.16951572],
  },
  {
    id: '1167',
    title: '『象潟』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc709fb0092',
    extent: [139.7494947, 39.33615906, 139.9994992, 39.16950468],
  },
  {
    id: '1166',
    title: '『飛島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rt633vh9343',
    extent: [139.4995169, 39.33615176, 139.7495027, 39.16949744],
  },
  {
    id: '1165',
    title: '『綾里』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bj649kx2258',
    extent: [141.7493368, 39.16957196, 141.999314, 39.00291241],
  },
  {
    id: '1164',
    title: '『盛』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jv364tt0942',
    extent: [141.4993584, 39.16955845, 141.7493411, 39.0029037],
  },
  {
    id: '1163',
    title: '『陸中大原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vh427dj3936',
    extent: [141.2493798, 39.16955119, 141.4993639, 39.00289771],
  },
  {
    id: '1162',
    title: '『水沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zh578hv6677',
    extent: [140.9994018, 39.16954479, 141.2493864, 39.00288976],
  },
  {
    id: '1161',
    title: '『焼石岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vt261fz2780',
    extent: [140.7494271, 39.16953786, 140.9994096, 39.00288126],
  },
  {
    id: '1160',
    title: '『稲庭』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nx717qz0295',
    extent: [140.4994572, 39.16953075, 140.7494349, 39.00287425],
  },
  {
    id: '1159',
    title: '『湯沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dh828tc1188',
    extent: [140.2494787, 39.16952281, 140.4994596, 39.00286834],
  },
  {
    id: '1158',
    title: '『鳥海山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gk727by9852',
    extent: [139.9994992, 39.16951572, 140.2494812, 39.00286092],
  },
  {
    id: '1157',
    title: '『吹浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rr211zs2303',
    extent: [139.7495027, 39.16950926, 139.9995038, 39.00285755],
  },
  {
    id: '1156',
    title: '『気仙沼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qp708jw5499',
    extent: [141.4993639, 39.00291241, 141.7493439, 38.83625672],
  },
  {
    id: '1155',
    title: '『千厩』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nz493ys3646',
    extent: [141.2493864, 39.0029037, 141.4993703, 38.83624955],
  },
  {
    id: '1154',
    title: '『栗駒山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gm861kc3221',
    extent: [140.7494349, 39.00288976, 140.9994164, 38.83623459],
  },
  {
    id: '1153',
    title: '『秋ノ宮』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kx650yk4750',
    extent: [140.4994596, 39.00288126, 140.7494426, 38.83622681],
  },
  {
    id: '1152',
    title: '『羽前金山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh981bh5933',
    extent: [140.2494812, 39.00287425, 140.4994657, 38.83621945],
  },
  {
    id: '1150',
    title: '『若柳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fr911ph8448',
    extent: [140.9994249, 38.83624193, 141.2494068, 38.66958822],
  },
  {
    id: '1151',
    title: '『酒田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vs939kf7443',
    extent: [139.7495106, 39.00286092, 139.9995116, 38.83621038],
  },
  {
    id: '1149',
    title: '『岩ヶ崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/st609qm9161',
    extent: [140.7494426, 38.83624193, 140.9994249, 38.66958822],
  },
  {
    id: '1147',
    title: '『新庄』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kn284mg4922',
    extent: [140.2494878, 38.83622681, 140.4994735, 38.66957297],
  },
  {
    id: '1148',
    title: '『鳴子』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xj107my8241',
    extent: [140.4994657, 38.83623459, 140.7494505, 38.66957933],
  },
  {
    id: '1146',
    title: '『清川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jd722my6076',
    extent: [139.9995116, 38.83621945, 140.2494931, 38.66956616],
  },
  {
    id: '1144',
    title: '『三瀬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xb632tb4869',
    extent: [139.4995407, 38.83621038, 139.749538, 38.66955602],
  },
  {
    id: '1145',
    title: '『鶴岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ty095jb8760',
    extent: [139.7495185, 38.83621229, 139.9995171, 38.6695602],
  },
  {
    id: '1141',
    title: '『涌谷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fm352vv6659',
    extent: [140.9994249, 38.66960149, 141.2494068, 38.50294764],
  },
  {
    id: '1143',
    title: '『大須』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yj029nn9049',
    extent: [141.499378, 38.66962217, 141.7493603, 38.50296231],
  },
  {
    id: '1142',
    title: '『登米』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mf555jj1389',
    extent: [141.2493997, 38.66960918, 141.4993837, 38.50295335],
  },
  {
    id: '1140',
    title: '『古川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vs715qv6056',
    extent: [140.7494505, 38.66959509, 140.9994332, 38.50294003],
  },
  {
    id: '1138',
    title: '『尾花沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wp104wh4810',
    extent: [140.2494931, 38.66957933, 140.4994818, 38.5029302],
  },
  {
    id: '1139',
    title: '『薬莢山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bm243ms1445',
    extent: [140.4994735, 38.66958822, 140.749458, 38.50293231],
  },
  {
    id: '1137',
    title: '『月山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gn683ty3190',
    extent: [139.9995171, 38.66957297, 140.2495015, 38.50291788],
  },
  {
    id: '1136',
    title: '『湯殿山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/by576bt1014',
    extent: [139.749538, 38.66956616, 139.9995207, 38.50291242],
  },
  {
    id: '1135',
    title: '『温海』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bh692nf2306',
    extent: [139.4995484, 38.6695602, 139.7495419, 38.50290846],
  },
  {
    id: '1134',
    title: '『寄磯』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mw755by2307',
    extent: [141.4993837, 38.50297471, 141.7493684, 38.3363149],
  },
  {
    id: '1133',
    title: '『石巻』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zk931jc9644',
    extent: [141.2494068, 38.50296231, 141.49939, 38.33631229],
  },
  {
    id: '1132',
    title: '『吉岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dj691wp1760',
    extent: [140.749458, 38.50294764, 140.9994415, 38.33629286],
  },
  {
    id: '1131',
    title: '『関山峠』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rd751tw1694',
    extent: [140.4994818, 38.50294003, 140.7494652, 38.33628454],
  },
  {
    id: '1129',
    title: '『左沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ck075jn0950',
    extent: [139.9995207, 38.5029302, 140.2495089, 38.33626895],
  },
  {
    id: '1130',
    title: '『楯岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xm932hx4461',
    extent: [140.2495015, 38.50293231, 140.4994862, 38.33627895],
  },
  {
    id: '1128',
    title: '『大鳥池』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bb163bz4133',
    extent: [139.7495419, 38.50291788, 139.9995266, 38.33626388],
  },
  {
    id: '1127',
    title: '『勝木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hm504hc8563',
    extent: [139.4995571, 38.50291242, 139.7495481, 38.33625687],
  },
  {
    id: '1126',
    title: '『笹川・粟島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xk168rq9311',
    extent: [139.2495782, 38.50290846, 139.4995652, 38.33625447],
  },
  {
    id: '1125',
    title: '『粟島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qh673zb8594',
    extent: [138.9996004, 38.50290171, 139.2495858, 38.33624746],
  },
  {
    id: '1124',
    title: '『金華山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hd912yz8732',
    extent: [141.2494068, 38.33628454, 141.49939, 38.16962811],
  },
  {
    id: '1121',
    title: '『朝日岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ys855dp0405',
    extent: [139.7495481, 38.33626895, 139.9995348, 38.16961462],
  },
  {
    id: '1123',
    title: '『山形』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vm294ps3608',
    extent: [140.2495089, 38.33628454, 140.4994919, 38.16962811],
  },
  {
    id: '1122',
    title: '『荒砥』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kg937wz9230',
    extent: [139.9995266, 38.33627895, 140.2495129, 38.16962138],
  },
  {
    id: '1120',
    title: '『塩野町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bp358zr6881',
    extent: [139.4995652, 38.33626388, 139.7495568, 38.16960866],
  },
  {
    id: '1119',
    title: '『鷲崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ds190yw8484',
    extent: [138.2496746, 38.33622669, 138.4996789, 38.16957953],
  },
  {
    id: '1118',
    title: '『岩沼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cd377rd2504',
    extent: [140.749472, 38.16965746, 140.9994487, 38.00299224],
  },
  {
    id: '1117',
    title: '『白石』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pf216pp2113',
    extent: [140.4994919, 38.16964392, 140.7494796, 38.00298548],
  },
  {
    id: '1115',
    title: '『赤湯』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vy498pq1754',
    extent: [139.9995348, 38.16962811, 140.2495224, 38.00297274],
  },
  {
    id: '1116',
    title: '『上山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sm974jg6508',
    extent: [140.2495129, 38.16963409, 140.4995008, 38.00297813],
  },
  {
    id: '1114',
    title: '『手ノ子』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gh751bf4143',
    extent: [139.7495568, 38.16962138, 139.9995433, 38.00296701],
  },
  {
    id: '1113',
    title: '『小国』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nc305wj4314',
    extent: [139.499578, 38.16961462, 139.7495667, 38.00296192],
  },
  {
    id: '1112',
    title: '『中条』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nc255rw0684',
    extent: [139.2495934, 38.16960866, 139.4995884, 38.00295366],
  },
  {
    id: '1111',
    title: '『両津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jw207hm2155',
    extent: [138.4996597, 38.16959328, 138.7496449, 38.002932],
  },
  {
    id: '1109',
    title: '『角田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wf099nb8607',
    extent: [140.7494796, 38.00300996, 140.9994564, 37.83634442],
  },
  {
    id: '1110',
    title: '『相川・両津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kv531jd8993',
    extent: [138.2496819, 38.16958638, 138.4996926, 38.00292513],
  },
  {
    id: '1108',
    title: '『桑折』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rv533pb3757',
    extent: [140.4995008, 38.00299224, 140.7494883, 37.83633707],
  },
  {
    id: '1107',
    title: '『関』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zj694yh1390',
    extent: [140.2495224, 38.00298548, 140.4995068, 37.83633106],
  },
  {
    id: '1105',
    title: '『玉庭』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/km504sk3655',
    extent: [139.7495667, 38.00297274, 139.9995524, 37.83631903],
  },
  {
    id: '1106',
    title: '『米沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pp271gx3079',
    extent: [139.9995433, 38.00297813, 140.2495298, 37.83632252],
  },
  {
    id: '1104',
    title: '『飯豊山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jj265xp8093',
    extent: [139.4995884, 38.00296701, 139.749576, 37.83631585],
  },
  {
    id: '1103',
    title: '『新発田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pp142sf3121',
    extent: [139.2496161, 38.00296192, 139.499599, 37.836306],
  },
  {
    id: '1102',
    title: '『新潟』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wj924qj1386',
    extent: [138.9996228, 38.00295366, 139.249625, 37.83630001],
  },
  {
    id: '1101',
    title: '『内野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dk620sj4730',
    extent: [138.7496449, 38.00295294, 138.9996482, 37.83629872],
  },
  {
    id: '1100',
    title: '『赤泊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jg233fk9210',
    extent: [138.4996743, 38.00294602, 138.7496522, 37.83629187],
  },
  {
    id: '1099',
    title: '『河原田・赤泊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cj653rq7512',
    extent: [138.2497148, 38.002932, 138.4996926, 37.83627737],
  },
  {
    id: '1097',
    title: '『保原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jc924rf0932',
    extent: [140.4995068, 37.83634442, 140.7494937, 37.66968816],
  },
  {
    id: '1098',
    title: '『舳倉島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sn317zs6633',
    extent: [136.7498235, 38.00289891, 136.9998079, 37.83624527],
  },
  {
    id: '1096',
    title: '『福島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qx872nd9964',
    extent: [140.2495298, 37.83633707, 140.499513, 37.66968164],
  },
  {
    id: '1095',
    title: '『吾妻山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qb940md1743',
    extent: [139.9995524, 37.83633106, 140.2495372, 37.66967512],
  },
  {
    id: '1094',
    title: '『熱塩』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fj844wc3197',
    extent: [139.749576, 37.83632252, 139.99956, 37.66966779],
  },
  {
    id: '1093',
    title: '『大日岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yp930ky2847',
    extent: [139.499599, 37.83631903, 139.7495837, 37.66966407],
  },
  {
    id: '1092',
    title: '『津川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rh528vx3938',
    extent: [139.249625, 37.83631585, 139.4996098, 37.66965843],
  },
  {
    id: '1091',
    title: '『新津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bb701zt4027',
    extent: [138.9996482, 37.836306, 139.2496305, 37.66965336],
  },
  {
    id: '1090',
    title: '『弥彦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fk820kw2643',
    extent: [138.7496522, 37.83630001, 138.9996552, 37.66965139],
  },
  {
    id: '1089',
    title: '『小木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nk417vh3166',
    extent: [138.2497035, 37.83629187, 138.4996815, 37.6696378],
  },
  {
    id: '1088',
    title: '『小木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rw525yd6834',
    extent: [137.9997186, 37.83627832, 138.2497239, 37.66963107],
  },
  {
    id: '1085',
    title: '『川俣』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mv093nf9955',
    extent: [140.499513, 37.66969427, 140.7494994, 37.50304],
  },
  {
    id: '1086',
    title: '『原町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pz927dp7994',
    extent: [140.7494937, 37.66970455, 140.9994789, 37.50304508],
  },
  {
    id: '1087',
    title: '『大甕』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gf430zy7982',
    extent: [140.9994738, 37.66972215, 141.2494504, 37.50305139],
  },
  {
    id: '1084',
    title: '『二本松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wg061mk5758',
    extent: [140.2495372, 37.66968816, 140.49952, 37.50303355],
  },
  {
    id: '1083',
    title: '『磐梯山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nx334jz7737',
    extent: [139.99956, 37.66968164, 140.2495421, 37.50302709],
  },
  {
    id: '1081',
    title: '『野沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nx529ss0225',
    extent: [139.4996098, 37.66966779, 139.7495907, 37.50301404],
  },
  {
    id: '1079',
    title: '『三条』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zx896kk5583',
    extent: [138.7496594, 37.66965336, 138.9996612, 37.50299985],
  },
  {
    id: '1080',
    title: '『御神楽岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rg898ny0033',
    extent: [139.2496442, 37.66966407, 139.4996145, 37.50301404],
  },
  {
    id: '1082',
    title: '『喜多方』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qt900nx9960',
    extent: [139.7495837, 37.66967512, 139.9995671, 37.50302103],
  },
  {
    id: '1078',
    title: '『出雲崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cn155wy0239',
    extent: [138.4996815, 37.66965139, 138.7496878, 37.50299722],
  },
  {
    id: '1077',
    title: '『珠洲岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fn282fm3821',
    extent: [137.2497925, 37.66961776, 137.4997771, 37.50295524],
  },
  {
    id: '1075',
    title: '『七ツ島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gr186rh7096',
    extent: [136.7498373, 37.66960463, 136.9998217, 37.50295097],
  },
  {
    id: '1076',
    title: '『馬緤』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gk642mh4116',
    extent: [136.9998148, 37.66961117, 137.2498341, 37.50295524],
  },
  {
    id: '1073',
    title: '『浪江』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hk324mz7917',
    extent: [140.7494994, 37.50305139, 140.9994821, 37.33639721],
  },
  {
    id: '1074',
    title: '『磐城富岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zk555ym1201',
    extent: [140.9994789, 37.50307451, 141.249458, 37.33640378],
  },
  {
    id: '1072',
    title: '『常葉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qx563ws1410',
    extent: [140.49952, 37.50304508, 140.7495061, 37.33639173],
  },
  {
    id: '1071',
    title: '『郡山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fy801wt5686',
    extent: [140.2495421, 37.50304, 140.4995272, 37.33638498],
  },
  {
    id: '1069',
    title: '『若松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dq152bx3663',
    extent: [139.7495907, 37.50302709, 139.9995719, 37.33637258],
  },
  {
    id: '1067',
    title: '『只見』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zg841tw3478',
    extent: [139.2496389, 37.50301404, 139.499621, 37.33636117],
  },
  {
    id: '1070',
    title: '『猪苗代湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qt353zm8191',
    extent: [139.9995671, 37.50303355, 140.24955, 37.33638005],
  },
  {
    id: '1068',
    title: '『宮下』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hz956sc1000',
    extent: [139.4996145, 37.50302103, 139.7495952, 37.33636623],
  },
  {
    id: '1066',
    title: '『守門岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rc160vt7511',
    extent: [138.9996612, 37.50300988, 139.2496442, 37.33635766],
  },
  {
    id: '1065',
    title: '『長岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cv833tr9999',
    extent: [138.7496878, 37.5030054, 138.9996698, 37.33635518],
  },
  {
    id: '1064',
    title: '『柏崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rf860vq9128',
    extent: [138.4996886, 37.50299985, 138.7496953, 37.3363494],
  },
  {
    id: '1063',
    title: '『柏崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gd129fx2136',
    extent: [138.2497106, 37.50299722, 138.4997171, 37.33634311],
  },
  {
    id: '1061',
    title: '『宝立山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fz942ns0484',
    extent: [136.9998217, 37.50295743, 137.2498407, 37.33630135],
  },
  {
    id: '1062',
    title: '『能登飯田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jd893mj7750',
    extent: [137.2498341, 37.50297051, 137.499784, 37.33630951],
  },
  {
    id: '1060',
    title: '『輪島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bg454sy0545',
    extent: [136.7498441, 37.50295743, 136.9998641, 37.33629421],
  },
  {
    id: '1059',
    title: '『井出』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fw691ht3752',
    extent: [140.9994821, 37.33642683, 141.2494655, 37.16975861],
  },
  {
    id: '1058',
    title: '『川前』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cb723hn2041',
    extent: [140.7495061, 37.33640378, 140.9994857, 37.16975146],
  },
  {
    id: '1056',
    title: '『須賀川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qy334qp5355',
    extent: [140.24955, 37.33639173, 140.4995349, 37.1697382],
  },
  {
    id: '1055',
    title: '『長沼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vn742jh9841',
    extent: [139.9995719, 37.33638498, 140.2495576, 37.16973253],
  },
  {
    id: '1057',
    title: '『小野新町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qp065jb0652',
    extent: [140.4995272, 37.33639721, 140.7495108, 37.16974404],
  },
  {
    id: '1054',
    title: '『田島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mz328ws1177',
    extent: [139.7495952, 37.33638005, 139.9995802, 37.16972617],
  },
  {
    id: '1053',
    title: '『針生』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dw890wp4476',
    extent: [139.499621, 37.33637258, 139.7496023, 37.16971989],
  },
  {
    id: '1049',
    title: '『岡野町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cx207yb7695',
    extent: [138.4997171, 37.33635518, 138.749701, 37.16970212],
  },
  {
    id: '1052',
    title: '『小林』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mp517fg3871',
    extent: [139.2496442, 37.33636623, 139.4996262, 37.16971491],
  },
  {
    id: '1051',
    title: '『須原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yp608fm4885',
    extent: [138.9996698, 37.33636117, 139.2496504, 37.16971098],
  },
  {
    id: '1050',
    title: '『小千谷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fz182kk4336',
    extent: [138.7496953, 37.33635766, 138.9996756, 37.16970648],
  },
  {
    id: '1048',
    title: '『柿崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ch992kw0049',
    extent: [138.2497177, 37.3363494, 138.4997228, 37.16969503],
  },
  {
    id: '1047',
    title: '『宇出津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hz354zw7757',
    extent: [136.9998632, 37.33630951, 137.2498407, 37.16965642],
  },
  {
    id: '1046',
    title: '『穴水』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kh897jj0449',
    extent: [136.7498856, 37.33630135, 136.9998641, 37.16964631],
  },
  {
    id: '1045',
    title: '『剱地』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hr356qc8131',
    extent: [136.4998732, 37.33629736, 136.7498953, 37.16964631],
  },
  {
    id: '1044',
    title: '『平』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rk296kb8706',
    extent: [140.7495108, 37.16975861, 140.9994942, 37.0031039],
  },
  {
    id: '1043',
    title: '『竹貫』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wx789tx1024',
    extent: [140.4995349, 37.16975146, 140.7495197, 37.00309774],
  },
  {
    id: '1042',
    title: '『棚倉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kh043jz8936',
    extent: [140.2495576, 37.16974404, 140.4995406, 37.00309111],
  },
  {
    id: '1041',
    title: '『白河』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cq343gm6128',
    extent: [139.9995802, 37.1697382, 140.2495635, 37.00308593],
  },
  {
    id: '1039',
    title: '『糸沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yk359pv4727',
    extent: [139.4996262, 37.16972617, 139.7496089, 37.00307426],
  },
  {
    id: '1040',
    title: '『那須岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hw392xm8188',
    extent: [139.7496023, 37.16973253, 139.9995837, 37.00307843],
  },
  {
    id: '1037',
    title: '『八海山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vv106sx7359',
    extent: [138.9996756, 37.16971491, 139.2496551, 37.00306428],
  },
  {
    id: '1038',
    title: '『檜枝岐』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pw731sy9652',
    extent: [139.2496504, 37.16971989, 139.4996316, 37.00306954],
  },
  {
    id: '1036',
    title: '『十日町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/df748ws2788',
    extent: [138.749701, 37.16971098, 138.9996821, 37.00306001],
  },
  {
    id: '1035',
    title: '『松之山温泉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sg202mf2661',
    extent: [138.4997228, 37.16970648, 138.7497056, 37.00305502],
  },
  {
    id: '1034',
    title: '『高田東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mb450gb7296',
    extent: [138.2497474, 37.16970212, 138.4997281, 37.00304801],
  },
  {
    id: '1032',
    title: '『糸魚川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dd976ss7074',
    extent: [137.7497687, 37.16968907, 137.9997792, 37.00303539],
  },
  {
    id: '1033',
    title: '『高田西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jm604pp0444',
    extent: [137.9997466, 37.16969503, 138.2497541, 37.00304201],
  },
  {
    id: '1031',
    title: '『小口瀬戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pn890rz0484',
    extent: [136.9998632, 37.16966939, 137.2498197, 37.00300699],
  },
  {
    id: '1030',
    title: '『七尾』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cy693bj0646',
    extent: [136.7498953, 37.16965642, 136.9998797, 37.00299965],
  },
  {
    id: '1029',
    title: '『富来』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bj118ky1425',
    extent: [136.4998798, 37.16965014, 136.7499046, 37.00299965],
  },
  {
    id: '1027',
    title: '『塙』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zv061nj8431',
    extent: [140.2495749, 37.00309774, 140.4995468, 36.83644386],
  },
  {
    id: '1028',
    title: '『小名浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gj152dr4939',
    extent: [140.7495197, 37.00312418, 140.9994942, 36.83645702],
  },
  {
    id: '1026',
    title: '『大田原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kp465pj2615',
    extent: [139.9995837, 37.00309111, 140.2495679, 36.83643692],
  },
  {
    id: '1025',
    title: '『塩原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ny951cs9847',
    extent: [139.7496089, 37.00308593, 139.9995891, 36.83643117],
  },
  {
    id: '1024',
    title: '『川治』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fp382jv8644',
    extent: [139.4996316, 37.00307843, 139.7496123, 36.83642449],
  },
  {
    id: '1022',
    title: '『藤原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kw217kb0117',
    extent: [138.9996821, 37.00306954, 139.2496597, 36.83641751],
  },
  {
    id: '1023',
    title: '『燧ヶ岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gn892pg8908',
    extent: [139.2496551, 37.00307426, 139.4996376, 36.83642177],
  },
  {
    id: '1019',
    title: '『飯山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nz986zd9554',
    extent: [138.2497541, 37.00305502, 138.4997325, 36.83640176],
  },
  {
    id: '1021',
    title: '『越後湯沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ht255fy4816',
    extent: [138.7497056, 37.00306428, 138.9996862, 36.83641182],
  },
  {
    id: '1020',
    title: '『苗場山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qp866jp7483',
    extent: [138.4997281, 37.00306001, 138.7497091, 36.83640669],
  },
  {
    id: '1018',
    title: '『妙高山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hf580kr4088',
    extent: [137.9997792, 37.00304801, 138.2497584, 36.83639268],
  },
  {
    id: '1017',
    title: '『小滝』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rz174ys2889',
    extent: [137.7497982, 37.00304201, 137.9997812, 36.83638402],
  },
  {
    id: '1014',
    title: '『虻ｶﾞ島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fb668cr7175',
    extent: [136.9998797, 37.00302205, 137.2498264, 36.83636221],
  },
  {
    id: '1015',
    title: '『三日市』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bs416tf9373',
    extent: [137.2498197, 37.00302854, 137.4998362, 36.83637467],
  },
  {
    id: '1016',
    title: '『泊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wb331cc0063',
    extent: [137.4997976, 37.00303539, 137.7498064, 36.83637722],
  },
  {
    id: '1013',
    title: '『氷見』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zp462mf5577',
    extent: [136.7499046, 37.00300699, 136.9998846, 36.83635591],
  },
  {
    id: '1012',
    title: '『高萩』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fw418gr7506',
    extent: [140.4995468, 36.83645702, 140.7495301, 36.66980198],
  },
  {
    id: '1010',
    title: '『喜連川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tf484pd0233',
    extent: [139.9995891, 36.83644386, 140.2495749, 36.6697896],
  },
  {
    id: '1009',
    title: '『矢板』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fv491fk8275',
    extent: [139.7496123, 36.83643692, 139.9995972, 36.66978396],
  },
  {
    id: '1007',
    title: '『男体山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bb692xt6448',
    extent: [139.2496597, 36.83642449, 139.4996435, 36.66977363],
  },
  {
    id: '1006',
    title: '『追貝』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jk954dr2479',
    extent: [138.9996862, 36.83642177, 139.2496684, 36.66976982],
  },
  {
    id: '1008',
    title: '『日光』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xp022yj9130',
    extent: [139.4996376, 36.83643117, 139.7496177, 36.66977854],
  },
  {
    id: '1005',
    title: '『四万』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn498nz3406',
    extent: [138.7497091, 36.83641751, 138.9996914, 36.66976484],
  },
  {
    id: '1003',
    title: '『中野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yz519fk8421',
    extent: [138.2497584, 36.83640669, 138.499737, 36.66975317],
  },
  {
    id: '1001',
    title: '『白馬岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hd738fx5911',
    extent: [137.7498064, 36.83639268, 137.999786, 36.66973668],
  },
  {
    id: '1000',
    title: '『黒部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kx984wc1797',
    extent: [137.4998362, 36.83638402, 137.7498115, 36.66972931],
  },
  {
    id: '1002',
    title: '『戸隠』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hq525gb0412',
    extent: [137.9997812, 36.83640176, 138.2497625, 36.66974528],
  },
  {
    id: '1004',
    title: '『岩菅山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rd548yk1807',
    extent: [138.4997325, 36.83641182, 138.7497146, 36.66975889],
  },
  {
    id: '999',
    title: '『魚津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qy043dm1027',
    extent: [137.2498264, 36.83637722, 137.4998411, 36.66972255],
  },
  {
    id: '998',
    title: '『富山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ck241rf1089',
    extent: [136.9998846, 36.83637467, 137.2498656, 36.66971698],
  },
  {
    id: '997',
    title: '『石動』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ct262jx5192',
    extent: [136.7499129, 36.83636221, 136.9998926, 36.66971038],
  },
  {
    id: '996',
    title: '『津幡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pm974mv1165',
    extent: [136.4998929, 36.83635591, 136.7499172, 36.66970823],
  },
  {
    id: '995',
    title: '『日立』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gq731tm4631',
    extent: [140.499553, 36.66982154, 140.7495373, 36.50315496],
  },
  {
    id: '993',
    title: '『烏山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wv089cv4271',
    extent: [139.9995972, 36.66979599, 140.2495817, 36.50314341],
  },
  {
    id: '990',
    title: '『足尾』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xt277cd7769',
    extent: [139.2496684, 36.66977854, 139.4996479, 36.50312589],
  },
  {
    id: '989',
    title: '『沼田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ty939fy7186',
    extent: [138.9996914, 36.66977363, 139.2496727, 36.5031216],
  },
  {
    id: '986',
    title: '『須坂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zf700ff6633',
    extent: [138.2497625, 36.66975889, 138.4997429, 36.50310598],
  },
  {
    id: '987',
    title: '『草津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ts682bh2068',
    extent: [138.499737, 36.66976484, 138.7497202, 36.5031106],
  },
  {
    id: '988',
    title: '『中之条』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xs633kf2023',
    extent: [138.7497146, 36.66976982, 138.9996973, 36.50311661],
  },
  {
    id: '985',
    title: '『長野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ng836hs1293',
    extent: [137.999786, 36.66975317, 138.2497652, 36.5030977],
  },
  {
    id: '984',
    title: '『大町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ym982jf8029',
    extent: [137.7498115, 36.66974528, 137.9997903, 36.50308886],
  },
  {
    id: '983',
    title: '『立山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qh062ms9900',
    extent: [137.4998411, 36.66973668, 137.7498149, 36.50308195],
  },
  {
    id: '982',
    title: '『五百石』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vf201hr2572',
    extent: [137.2498656, 36.66972931, 137.499842, 36.50307569],
  },
  {
    id: '979',
    title: '『金沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sx424rh8152',
    extent: [136.4998994, 36.66971038, 136.749921, 36.50305715],
  },
  {
    id: '980',
    title: '『城端』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hr728jy8864',
    extent: [136.7499172, 36.66971698, 136.999897, 36.50306541],
  },
  {
    id: '981',
    title: '『八尾』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pr872wp1794',
    extent: [136.9998926, 36.66972255, 137.2498698, 36.50307265],
  },
  {
    id: '978',
    title: '『ひたちなか』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ws785xg5624',
    extent: [140.4995583, 36.50317371, 140.7495445, 36.33650646],
  },
  {
    id: '976',
    title: '『真岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bx767md7446',
    extent: [139.9996086, 36.50314904, 140.2495929, 36.33649582],
  },
  {
    id: '977',
    title: '『水戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jg430nr1311',
    extent: [140.2495817, 36.50315496, 140.4995638, 36.33650234],
  },
  {
    id: '975',
    title: '『壬生』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vx846qf6525',
    extent: [139.7496246, 36.50314341, 139.9996044, 36.33649582],
  },
  {
    id: '973',
    title: '『榛名山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dt979dd4393',
    extent: [138.7497202, 36.5031216, 138.9997034, 36.33646978],
  },
  {
    id: '972',
    title: '『軽井沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qz931hx7571',
    extent: [138.4997429, 36.50311661, 138.7497267, 36.33646386],
  },
  {
    id: '971',
    title: '『上田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nn426rc8849',
    extent: [138.2497652, 36.5031106, 138.4997508, 36.33645758],
  },
  {
    id: '968',
    title: '『槍ヶ岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dq464sh1860',
    extent: [137.499842, 36.50308886, 137.7498176, 36.33643662],
  },
  {
    id: '967',
    title: '『有峰湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dz310kg0525',
    extent: [137.2498698, 36.50308195, 137.4998437, 36.33643074],
  },
  {
    id: '966',
    title: '『白木峰』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kv564ys8672',
    extent: [136.999897, 36.50307569, 137.2498703, 36.33642556],
  },
  {
    id: '970',
    title: '『坂城』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wt920dc1935',
    extent: [137.9997903, 36.50310598, 138.2497722, 36.33645208],
  },
  {
    id: '969',
    title: '『信濃池田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tb605gk5346',
    extent: [137.7498149, 36.5030977, 137.999794, 36.33644379],
  },
  {
    id: '965',
    title: '『下梨』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hd139qd1654',
    extent: [136.749921, 36.50307265, 136.9998998, 36.33641929],
  },
  {
    id: '962',
    title: '『磯浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ww769zc7068',
    extent: [140.4995638, 36.33652585, 140.7495515, 36.16985999],
  },
  {
    id: '963',
    title: '『小松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yw497kz3659',
    extent: [136.249928, 36.50305715, 136.4999486, 36.33640721],
  },
  {
    id: '961',
    title: '『石岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vx877cr6310',
    extent: [140.2495929, 36.33650234, 140.4995703, 36.16985999],
  },
  {
    id: '964',
    title: '『鶴来』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gh922ny8922',
    extent: [136.4999447, 36.50306541, 136.7499243, 36.33641402],
  },
  {
    id: '960',
    title: '『真壁』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tb318ym3123',
    extent: [139.9996086, 36.33650234, 140.2495929, 36.16984859],
  },
  {
    id: '959',
    title: '『深谷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yk838ht9709',
    extent: [139.2496768, 36.33648392, 139.4996614, 36.16982887],
  },
  {
    id: '958',
    title: '『高崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vf815pm8071',
    extent: [138.9997104, 36.33647501, 139.2496826, 36.16982411],
  },
  {
    id: '957',
    title: '『富岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bw120gv1914',
    extent: [138.7497267, 36.33647501, 138.9997104, 36.16982159],
  },
  {
    id: '955',
    title: '『小諸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yn523fm8495',
    extent: [138.2497722, 36.33646386, 138.499755, 36.16981116],
  },
  {
    id: '956',
    title: '『御代田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mc150qq7024',
    extent: [138.4997508, 36.33646978, 138.7497353, 36.16981611],
  },
  {
    id: '954',
    title: '『和田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cc429tj0796',
    extent: [137.9998008, 36.33645208, 138.2497848, 36.16979869],
  },
  {
    id: '953',
    title: '『松本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ms639md2746',
    extent: [137.7498176, 36.33645208, 137.9998008, 36.16979869],
  },
  {
    id: '952',
    title: '『上高地』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sk396cb2262',
    extent: [137.4998437, 36.33644379, 137.7498214, 36.16979082],
  },
  {
    id: '950',
    title: '『飛騨古川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sw130fw3979',
    extent: [136.9998991, 36.33643074, 137.2498724, 36.16977866],
  },
  {
    id: '951',
    title: '『船津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wq885xj4668',
    extent: [137.2498724, 36.33643074, 137.4998516, 36.16977866],
  },
  {
    id: '949',
    title: '『白川村』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qp402vg8555',
    extent: [136.7499243, 36.33642556, 136.9998998, 36.1697745],
  },
  {
    id: '948',
    title: '『白峰』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fk038tc9364',
    extent: [136.4999486, 36.33641929, 136.7499282, 36.16976587],
  },
  {
    id: '947',
    title: '『大聖寺』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bz687jx2553',
    extent: [136.2499344, 36.33641402, 136.4999524, 36.16976058],
  },
  {
    id: '946',
    title: '『三国』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cd060pb3062',
    extent: [135.9999566, 36.33640721, 136.2499802, 36.16975365],
  },
  {
    id: '944',
    title: '『北方』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fw997fv6578',
    extent: [133.0002274, 36.33636917, 133.2502398, 36.16968371],
  },
  {
    id: '945',
    title: '『西郷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jv432cw8456',
    extent: [133.2502343, 36.33636917, 133.5001875, 36.1696949],
  },
  {
    id: '943',
    title: '『鉾田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jy802sh2669',
    extent: [140.4995703, 36.16987795, 140.7495586, 36.00321392],
  },
  {
    id: '941',
    title: '『土浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fs467xd0676',
    extent: [139.9996161, 36.16985467, 140.2495991, 36.00320109],
  },
  {
    id: '942',
    title: '『玉造』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kb005kq5878',
    extent: [140.2495929, 36.16985999, 140.4995765, 36.00320736],
  },
  {
    id: '940',
    title: '『水海道』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rz193pb0424',
    extent: [139.7496379, 36.16984859, 139.9996223, 36.00319483],
  },
  {
    id: '938',
    title: '『寄居』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wt129ny0041',
    extent: [138.9997104, 36.16982887, 139.249692, 36.00318047],
  },
  {
    id: '939',
    title: '『熊谷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ck949ty1294',
    extent: [139.2496826, 36.1698358, 139.4996677, 36.00318272],
  },
  {
    id: '937',
    title: '『万場』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bm366yg6675',
    extent: [138.7497353, 36.16982411, 138.9997164, 36.00317272],
  },
  {
    id: '935',
    title: '『蓼科山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cs341vb1896',
    extent: [138.2497781, 36.16981611, 138.4997619, 36.0031656],
  },
  {
    id: '936',
    title: '『十石峠』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cb633vy8884',
    extent: [138.499755, 36.16982159, 138.7497426, 36.00316867],
  },
  {
    id: '934',
    title: '『諏訪』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pk581zf2718',
    extent: [137.9998008, 36.16981116, 138.2497848, 36.00316006],
  },
  {
    id: '933',
    title: '『塩尻』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gc015jy5170',
    extent: [137.7498214, 36.16980512, 137.9998062, 36.00315365],
  },
  {
    id: '932',
    title: '『乗鞍岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dc389vr9612',
    extent: [137.4998471, 36.16979869, 137.7498264, 36.00314645],
  },
  {
    id: '931',
    title: '『高山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pj696jc4434',
    extent: [137.2498724, 36.16979082, 137.4998516, 36.00313924],
  },
  {
    id: '930',
    title: '『三日町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dg571gg6822',
    extent: [136.9998991, 36.16978409, 137.2498754, 36.00313414],
  },
  {
    id: '929',
    title: '『白山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wj221tg8596',
    extent: [136.7499269, 36.16977866, 136.9999025, 36.0031283],
  },
  {
    id: '928',
    title: '『越前勝山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cm343wn3964',
    extent: [136.4999524, 36.1697745, 136.7499282, 36.00311939],
  },
  {
    id: '927',
    title: '『永平寺』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pn550zq4438',
    extent: [136.2499802, 36.16976587, 136.4999592, 36.00311432],
  },
  {
    id: '926',
    title: '『福井』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn040hw7417',
    extent: [135.9999628, 36.16976058, 136.2499857, 36.00310871],
  },
  {
    id: '925',
    title: '『下岬村』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vz023qx5454',
    extent: [135.749985, 36.16975365, 136.0000111, 36.00310013],
  },
  {
    id: '924',
    title: '『浦郷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rj131rt2133',
    extent: [133.0002331, 36.16972476, 133.2502398, 36.00304208],
  },
  {
    id: '923',
    title: '『浦郷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mq852yv2136',
    extent: [132.7502559, 36.16968371, 133.0002671, 36.00303103],
  },
  {
    id: '922',
    title: '『潮来』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zb273ww8057',
    extent: [140.4995765, 36.00323, 140.7495586, 35.8365676],
  },
  {
    id: '920',
    title: '『龍ヶ崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tt557hx7716',
    extent: [139.9996223, 36.00320736, 140.2496044, 35.83655574],
  },
  {
    id: '921',
    title: '『佐原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mw329kc1250',
    extent: [140.2495991, 36.00321392, 140.4995803, 35.83656164],
  },
  {
    id: '919',
    title: '『野田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kt422vr8937',
    extent: [139.7496446, 36.00320109, 139.9996285, 35.83654969],
  },
  {
    id: '918',
    title: '『大宮』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gp003yv0389',
    extent: [139.4996677, 36.00319483, 139.7496514, 35.83654511],
  },
  {
    id: '917',
    title: '『川越』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cn237bd0391',
    extent: [139.2496953, 36.00318842, 139.4996727, 35.83654511],
  },
  {
    id: '915',
    title: '『三峰』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jn819vp4068',
    extent: [138.7497426, 36.00318047, 138.9997237, 35.83652807],
  },
  {
    id: '916',
    title: '『秩父』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kd477pp1888',
    extent: [138.9997164, 36.00318272, 139.2496953, 35.83653159],
  },
  {
    id: '914',
    title: '『金峰山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xr810yc9364',
    extent: [138.4997619, 36.00317272, 138.7497478, 35.836523],
  },
  {
    id: '913',
    title: '『八ヶ岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wv684jn8400',
    extent: [138.2497848, 36.00316867, 138.49977, 35.83652015],
  },
  {
    id: '912',
    title: '『高遠』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zs982mh8480',
    extent: [137.9998062, 36.0031656, 138.2497922, 35.83651348],
  },
  {
    id: '911',
    title: '『伊那』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xr342fs3833',
    extent: [137.7498264, 36.00316006, 137.9998116, 35.83650677],
  },
  {
    id: '909',
    title: '『御嶽山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qj721cy2808',
    extent: [137.2498754, 36.00314645, 137.4998582, 35.83649437],
  },
  {
    id: '908',
    title: '『白鳥』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nd713bg1718',
    extent: [136.7499269, 36.00313414, 136.999905, 35.83648125],
  },
  {
    id: '907',
    title: '『荒島岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dy180pj3311',
    extent: [136.4999592, 36.0031283, 136.7499306, 35.83647421],
  },
  {
    id: '910',
    title: '『木曽福島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yw111gw9264',
    extent: [137.4998516, 36.00315365, 137.749834, 35.8365016],
  },
  {
    id: '906',
    title: '『大野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pn621rv0849',
    extent: [136.2499857, 36.00311939, 136.4999634, 35.83647036],
  },
  {
    id: '905',
    title: '『鯖江』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dg766rv2757',
    extent: [135.9999751, 36.00311432, 136.2499878, 35.8364587],
  },
  {
    id: '901',
    title: '『佐倉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ck169zr2896',
    extent: [139.9996285, 35.83656164, 140.2496098, 35.66990839],
  },
  {
    id: '903',
    title: '『銚子』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sy724rk6270',
    extent: [140.749557, 35.83658895, 140.9995516, 35.669934],
  },
  {
    id: '900',
    title: '『東京東北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vn542zm4027',
    extent: [139.7496514, 35.83655574, 139.9996365, 35.66990482],
  },
  {
    id: '902',
    title: '『八日市場』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yd187rb7789',
    extent: [140.4995803, 35.8365746, 140.7495725, 35.66992229],
  },
  {
    id: '904',
    title: '『梅浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cm182jc3470',
    extent: [135.7499912, 36.00310871, 136.0000111, 35.83645266],
  },
  {
    id: '899',
    title: '『青梅』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/df436tv8596',
    extent: [139.2496953, 35.83654511, 139.4996784, 35.66989247],
  },
  {
    id: '898',
    title: '『五日市』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/td632xm1921',
    extent: [138.9997237, 35.83653959, 139.2497, 35.6698888],
  },
  {
    id: '896',
    title: '『御岳昇仙峡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/df876mt6710',
    extent: [138.49977, 35.83652807, 138.7497539, 35.66987693],
  },
  {
    id: '897',
    title: '『丹波』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nf409vf7651',
    extent: [138.7497478, 35.83653159, 138.9997256, 35.6698852],
  },
  {
    id: '895',
    title: '『韮崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vt887rk9696',
    extent: [138.2497986, 35.83652015, 138.4997785, 35.6698664],
  },
  {
    id: '893',
    title: '『上松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ky878pz8975',
    extent: [137.4998582, 35.83650677, 137.7498395, 35.66985486],
  },
  {
    id: '894',
    title: '『市野瀬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kf504vn7080',
    extent: [137.9998116, 35.83652015, 138.2497986, 35.6698664],
  },
  {
    id: '889',
    title: '『能郷白山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bc023xr9239',
    extent: [136.4999634, 35.83648125, 136.7499331, 35.66982741],
  },
  {
    id: '891',
    title: '『下呂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sc298ry9801',
    extent: [136.999905, 35.83649437, 137.2498847, 35.66983836],
  },
  {
    id: '887',
    title: '『今庄』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qt864tk4204',
    extent: [135.9999751, 35.83647036, 136.2499923, 35.66982046],
  },
  {
    id: '892',
    title: '『加子母』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qz521xd3351',
    extent: [137.2498785, 35.8365016, 137.4998648, 35.6698477],
  },
  {
    id: '890',
    title: '『八幡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mg113wd8181',
    extent: [136.7499306, 35.8364871, 136.9999092, 35.66983205],
  },
  {
    id: '888',
    title: '『冠山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cq616pt6575',
    extent: [136.2499878, 35.83647421, 136.4999642, 35.66982444],
  },
  {
    id: '886',
    title: '『竹波』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dh915ch4781',
    extent: [135.7499972, 35.8364587, 136.0000242, 35.66980516],
  },
  {
    id: '882',
    title: '『千葉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ck275xz3653',
    extent: [139.9996365, 35.66991537, 140.2496189, 35.50326482],
  },
  {
    id: '883',
    title: '『東金』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sc727bp2875',
    extent: [140.2496098, 35.66992229, 140.4996003, 35.50326581],
  },
  {
    id: '884',
    title: '『木戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dr147yq6632',
    extent: [140.4995874, 35.669934, 140.7495793, 35.50327909],
  },
  {
    id: '885',
    title: '『塩江』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nx724rb4831',
    extent: [134.7500863, 35.83643483, 135.0001042, 35.66980449],
  },
  {
    id: '881',
    title: '『東京西南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vz909jc0494',
    extent: [139.4996784, 35.66990482, 139.7496644, 35.50325607],
  },
  {
    id: '880',
    title: '『八王子』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nf686tq3814',
    extent: [139.2497, 35.66989856, 139.4996859, 35.50325225],
  },
  {
    id: '879',
    title: '『上野原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jw864cs2674',
    extent: [138.9997256, 35.66989247, 139.2497057, 35.50324423],
  },
  {
    id: '878',
    title: '『都留』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xk025mw5665',
    extent: [138.7497539, 35.6698888, 138.9997308, 35.50323772],
  },
  {
    id: '877',
    title: '『甲府』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rj371rx6813',
    extent: [138.4997754, 35.6698852, 138.7497558, 35.50323128],
  },
  {
    id: '876',
    title: '『鰍沢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zt940jh1771',
    extent: [138.2497986, 35.66987693, 138.4997785, 35.5032274],
  },
  {
    id: '875',
    title: '『大河原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vk701wy1624',
    extent: [137.9998188, 35.66987242, 138.2498017, 35.50322299],
  },
  {
    id: '874',
    title: '『飯田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zc467vv5272',
    extent: [137.7498395, 35.6698664, 137.9998241, 35.50321629],
  },
  {
    id: '873',
    title: '『妻籠』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kg791bq8888',
    extent: [137.4998648, 35.6698608, 137.7498465, 35.50320903],
  },
  {
    id: '872',
    title: '『付知』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bp009wz1315',
    extent: [137.2498847, 35.66985486, 137.4998698, 35.50320125],
  },
  {
    id: '871',
    title: '『金山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mb887tc8363',
    extent: [136.9999092, 35.6698477, 137.2498892, 35.50319287],
  },
  {
    id: '870',
    title: '『美濃』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sf919dg7038',
    extent: [136.7499331, 35.66983836, 136.999915, 35.50318352],
  },
  {
    id: '869',
    title: '『横山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xx646hw7351',
    extent: [136.2499923, 35.66982741, 136.4999694, 35.50317859],
  },
  {
    id: '868',
    title: '『敦賀』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/th209hc5581',
    extent: [136.0000242, 35.66982444, 136.2500006, 35.50317418],
  },
  {
    id: '864',
    title: '『城崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ft491cv6405',
    extent: [134.7501266, 35.66980822, 135.0001077, 35.50315563],
  },
  {
    id: '862',
    title: '『浜坂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tp684wn6728',
    extent: [134.2501369, 35.66980077, 134.5001521, 35.50314846],
  },
  {
    id: '861',
    title: '『鳥取北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jh427dn0162',
    extent: [134.0001594, 35.66977005, 134.2501734, 35.50314291],
  },
  {
    id: '867',
    title: '『西津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vv532dq6695',
    extent: [135.7500032, 35.66982046, 136.0000247, 35.50316994],
  },
  {
    id: '863',
    title: '『香住』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mt118jq3371',
    extent: [134.5001488, 35.66980449, 134.7501308, 35.50315253],
  },
  {
    id: '859',
    title: '『境港』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jy408vd0789',
    extent: [133.0002497, 35.66974757, 133.2502606, 35.50312321],
  },
  {
    id: '857',
    title: '『姉崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xg903pq8363',
    extent: [139.9996421, 35.50326581, 140.2496233, 35.33661862],
  },
  {
    id: '858',
    title: '『茂原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dn551mr2616',
    extent: [140.2496189, 35.50327909, 140.499607, 35.33662245],
  },
  {
    id: '855',
    title: '『山中湖』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cf772gh9023',
    extent: [138.7497558, 35.50324423, 138.9997342, 35.33659148],
  },
  {
    id: '856',
    title: '『横浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pp860cp5236',
    extent: [139.4996859, 35.50325932, 139.74967, 35.33661084],
  },
  {
    id: '860',
    title: '『美保関』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wv448db3683',
    extent: [133.2502271, 35.66975312, 133.5002392, 35.50313037],
  },
  {
    id: '854',
    title: '『富士山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hk361pn3204',
    extent: [138.4997785, 35.50323772, 138.7497596, 35.33658706],
  },
  {
    id: '850',
    title: '『美濃加茂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rp898dz6537',
    extent: [136.999915, 35.50320125, 137.2498957, 35.33654398],
  },
  {
    id: '853',
    title: '『赤石岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fm603bw4761',
    extent: [137.9998241, 35.5032274, 138.2498071, 35.33657522],
  },
  {
    id: '852',
    title: '『中津川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/np480jz0401',
    extent: [137.4998698, 35.50321629, 137.7498529, 35.33656192],
  },
  {
    id: '851',
    title: '『恵那』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/td952zq0668',
    extent: [137.2498892, 35.50320903, 137.4998725, 35.33655397],
  },
  {
    id: '849',
    title: '『岐阜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yn543zk5438',
    extent: [136.7499384, 35.50319287, 136.9999183, 35.33653917],
  },
  {
    id: '848',
    title: '『大垣』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bj788gq3550',
    extent: [136.4999694, 35.50318352, 136.749943, 35.3365346],
  },
  {
    id: '847',
    title: '『長浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kx361cx5845',
    extent: [136.2499994, 35.5031809, 136.4999733, 35.33653017],
  },
  {
    id: '844',
    title: '『小浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bt775bn2308',
    extent: [135.5000624, 35.50316994, 135.750048, 35.33651947],
  },
  {
    id: '845',
    title: '『熊川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cb173fj2995',
    extent: [135.7500466, 35.50317418, 136.0000276, 35.33652189],
  },
  {
    id: '843',
    title: '『舞鶴』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fm710xw1713',
    extent: [135.2500875, 35.50316878, 135.500066, 35.33651626],
  },
  {
    id: '842',
    title: '『大江山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cs626kq2282',
    extent: [135.0001077, 35.50316416, 135.2500898, 35.33651244],
  },
  {
    id: '841',
    title: '『出石』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sv190mt2894',
    extent: [134.7501308, 35.50315986, 135.0001122, 35.33650862],
  },
  {
    id: '838',
    title: '『鳥取南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bq186zg8148',
    extent: [134.0001957, 35.50314846, 134.2501775, 35.33649533],
  },
  {
    id: '837',
    title: '『倉吉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yv902gc9509',
    extent: [133.7502187, 35.50314291, 134.0002003, 35.3364923],
  },
  {
    id: '839',
    title: '『若桜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dc807zg3973',
    extent: [134.2501734, 35.50315253, 134.5001553, 35.33650212],
  },
  {
    id: '836',
    title: '『大山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qf772gd6247',
    extent: [133.5002392, 35.5031387, 133.7502217, 35.33648686],
  },
  {
    id: '840',
    title: '『村岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mz409nt6371',
    extent: [134.5001521, 35.50315563, 134.7501349, 35.33650391],
  },
  {
    id: '835',
    title: '『米子』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jq554mk2910',
    extent: [133.2502606, 35.5031374, 133.5002447, 35.33648154],
  },
  {
    id: '834',
    title: '『松江』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vc897sh7997',
    extent: [133.0002846, 35.50313037, 133.2502657, 35.33647387],
  },
  {
    id: '833',
    title: '『今市』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ch382nd7855',
    extent: [132.7502779, 35.50312321, 133.000287, 35.33646896],
  },
  {
    id: '832',
    title: '『大社』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nt741dp9336',
    extent: [132.5003006, 35.50308934, 132.7503127, 35.33643666],
  },
  {
    id: '830',
    title: '『大多喜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tg665zz8391',
    extent: [139.9996438, 35.33662245, 140.249626, 35.16997639],
  },
  {
    id: '831',
    title: '『上総大原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bp720jh6401',
    extent: [140.2496233, 35.33663101, 140.4996137, 35.16997756],
  },
  {
    id: '829',
    title: '『平塚』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qb752yr3134',
    extent: [139.2497073, 35.33661179, 139.4996977, 35.16994964],
  },
  {
    id: '828',
    title: '『小田原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ck166ps4212',
    extent: [138.9997342, 35.33660567, 139.2497189, 35.16994964],
  },
  {
    id: '827',
    title: '『御殿場』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pv082jb9338',
    extent: [138.7497596, 35.33659558, 138.9997404, 35.1699451],
  },
  {
    id: '826',
    title: '『富士宮』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yc380xx0693',
    extent: [138.4997832, 35.33659148, 138.7497624, 35.16993951],
  },
  {
    id: '825',
    title: '『南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pm537bn3221',
    extent: [138.2498071, 35.33658706, 138.499786, 35.16993364],
  },
  {
    id: '824',
    title: '『井川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wr114kd5874',
    extent: [137.999829, 35.33658194, 138.2498091, 35.16992899],
  },
  {
    id: '821',
    title: '『明智』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kr284tq3360',
    extent: [137.2498957, 35.33656192, 137.499877, 35.16990632],
  },
  {
    id: '822',
    title: '『根羽』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jh641ws3216',
    extent: [137.4998725, 35.33656941, 137.749856, 35.16991351],
  },
  {
    id: '818',
    title: '『津島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sv153wm8904',
    extent: [136.4999733, 35.33653917, 136.7499492, 35.16988789],
  },
  {
    id: '820',
    title: '『瀬戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zc857my1503',
    extent: [136.9999183, 35.33655397, 137.2498992, 35.1698977],
  },
  {
    id: '815',
    title: '『北小松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hf547qg6944',
    extent: [135.750048, 35.3365247, 136.0000276, 35.16987433],
  },
  {
    id: '817',
    title: '『彦根東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ry668yd4924',
    extent: [136.2499994, 35.3365346, 136.4999757, 35.16988278],
  },
  {
    id: '813',
    title: '『綾部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yk313dm7589',
    extent: [135.2500898, 35.33651947, 135.5000704, 35.16987049],
  },
  {
    id: '812',
    title: '『福知山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rb776dk6462',
    extent: [135.0001122, 35.33651626, 135.250093, 35.16986623],
  },
  {
    id: '811',
    title: '『但馬竹田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zj806bh8066',
    extent: [134.7501349, 35.33651244, 135.000116, 35.16985824],
  },
  {
    id: '814',
    title: '『四ッ谷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sg892mr4720',
    extent: [135.500066, 35.33652189, 135.7500509, 35.16987244],
  },
  {
    id: '810',
    title: '『大屋市場』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zw528cw0255',
    extent: [134.5001553, 35.33650862, 134.7501362, 35.16985401],
  },
  {
    id: '809',
    title: '『坂根』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wg657sq2218',
    extent: [134.2501775, 35.33650391, 134.5001609, 35.16985091],
  },
  {
    id: '807',
    title: '『奥津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zs133tg5022',
    extent: [133.7502217, 35.33649533, 134.0002067, 35.16984174],
  },
  {
    id: '804',
    title: '『横田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tj474jb4293',
    extent: [133.000287, 35.33648154, 133.250271, 35.16982972],
  },
  {
    id: '806',
    title: '『湯本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rd927tt0717',
    extent: [133.5002447, 35.3364923, 133.7502277, 35.16983766],
  },
  {
    id: '805',
    title: '『根雨』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bt040fv6866',
    extent: [133.2502657, 35.33648686, 133.5002494, 35.16983379],
  },
  {
    id: '808',
    title: '『智頭』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xk285tz6479',
    extent: [134.0002003, 35.33650212, 134.2501831, 35.16984536],
  },
  {
    id: '803',
    title: '『木次』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gs798rc6519',
    extent: [132.7503127, 35.33647387, 133.0002908, 35.16982406],
  },
  {
    id: '802',
    title: '『石見大田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hp140jz4071',
    extent: [132.5003059, 35.33646896, 132.7503189, 35.16982233],
  },
  {
    id: '800',
    title: '『鴨川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fz902wj8449',
    extent: [139.9996464, 35.16997756, 140.2496413, 35.00332135],
  },
  {
    id: '801',
    title: '『勝浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mw591zt0312',
    extent: [140.249626, 35.16998289, 140.4996204, 35.00332802],
  },
  {
    id: '798',
    title: '『沼津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nk210gr7602',
    extent: [138.7497624, 35.16995189, 138.9997434, 35.00328867],
  },
  {
    id: '799',
    title: '『熱海』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fg106xz0738',
    extent: [138.9997342, 35.16995189, 139.2497189, 35.00328867],
  },
  {
    id: '797',
    title: '『吉原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gg659gx7521',
    extent: [138.4997902, 35.16993951, 138.7497715, 35.00328841],
  },
  {
    id: '796',
    title: '『清水』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gg085vx9443',
    extent: [138.2498091, 35.16993951, 138.4997902, 35.00328841],
  },
  {
    id: '795',
    title: '『千頭』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vr693ms0104',
    extent: [137.9998328, 35.16993364, 138.2498153, 35.00328274],
  },
  {
    id: '794',
    title: '『佐久間』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cb749dc6792',
    extent: [137.749856, 35.16992899, 137.9998373, 35.00327527],
  },
  {
    id: '792',
    title: '『足助』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zk805dj2626',
    extent: [137.2498992, 35.16991351, 137.4998806, 35.00325878],
  },
  {
    id: '793',
    title: '『田口』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yg302nv6274',
    extent: [137.499877, 35.16992182, 137.7498592, 35.00326665],
  },
  {
    id: '791',
    title: '『豊田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hh507xx6546',
    extent: [136.9999318, 35.1698977, 137.2499147, 35.00323866],
  },
  {
    id: '789',
    title: '『桑名』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn191rh9807',
    extent: [136.4999757, 35.16989081, 136.7499492, 35.00323864],
  },
  {
    id: '790',
    title: '『名古屋南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ms429pw9037',
    extent: [136.7499396, 35.1698977, 136.999929, 35.00323866],
  },
  {
    id: '788',
    title: '『御在所山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/by756hs7089',
    extent: [136.2500035, 35.16988789, 136.4999775, 35.00323191],
  },
  {
    id: '786',
    title: '『園部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yy609kc2650',
    extent: [135.250093, 35.16987244, 135.500074, 35.0032199],
  },
  {
    id: '784',
    title: '『生野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tz282tc3591',
    extent: [134.7501362, 35.16986623, 135.0001186, 35.00321019],
  },
  {
    id: '783',
    title: '『山崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zv152kz0251',
    extent: [134.5001609, 35.16985824, 134.7501421, 35.00320589],
  },
  {
    id: '782',
    title: '『佐用』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hn415by9118',
    extent: [134.2501831, 35.16985401, 134.5001656, 35.00320156],
  },
  {
    id: '781',
    title: '『津山東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vr576gg5634',
    extent: [134.0002067, 35.16985091, 134.2501881, 35.00319674],
  },
  {
    id: '780',
    title: '『津山西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zf246my7285',
    extent: [133.7502277, 35.16984536, 134.0002119, 35.00319257],
  },
  {
    id: '779',
    title: '『勝山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jq359ng8927',
    extent: [133.5002494, 35.16984174, 133.7502313, 35.00318848],
  },
  {
    id: '777',
    title: '『多里』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ns002np3897',
    extent: [133.0002908, 35.16983379, 133.2502764, 35.00317862],
  },
  {
    id: '778',
    title: '『上石見』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sr323mw4866',
    extent: [133.250271, 35.16983766, 133.5002558, 35.00318552],
  },
  {
    id: '776',
    title: '『頓原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vj585jf4607',
    extent: [132.7503189, 35.16982972, 133.000299, 35.00317862],
  },
  {
    id: '775',
    title: '『三瓶山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hy602cp2224',
    extent: [132.5003449, 35.16982406, 132.7503262, 35.00317595],
  },
  {
    id: '774',
    title: '『江津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py585yc4025',
    extent: [132.0003566, 35.16978404, 132.250372, 35.00313146],
  },
  {
    id: '773',
    title: '『館山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qz007xq5897',
    extent: [139.7496832, 35.00332135, 139.9996687, 34.8366666],
  },
  {
    id: '772',
    title: '『修善寺』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tw994vx6275',
    extent: [138.7497677, 35.00330451, 138.9997478, 34.8366429],
  },
  {
    id: '771',
    title: '『駒越』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nz139dd1008',
    extent: [138.4997902, 35.00329427, 138.7497715, 34.83663427],
  },
  {
    id: '770',
    title: '『静岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py419jt2498',
    extent: [138.2498178, 35.00329427, 138.4998014, 34.83663427],
  },
  {
    id: '768',
    title: '『御油』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mn218px2291',
    extent: [137.2499038, 35.00326665, 137.4998862, 34.83661075],
  },
  {
    id: '769',
    title: '『三河大野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xn287wg9930',
    extent: [137.4998806, 35.00327527, 137.749863, 34.83661958],
  },
  {
    id: '766',
    title: '『半田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fr012yv8846',
    extent: [136.7499396, 35.00323866, 136.999929, 34.83658896],
  },
  {
    id: '767',
    title: '『岡崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kr585qy0167',
    extent: [136.9999318, 35.00326665, 137.2499147, 34.83661075],
  },
  {
    id: '765',
    title: '『四日市』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xn676ww3069',
    extent: [136.4999775, 35.00323866, 136.7499455, 34.83658896],
  },
  {
    id: '764',
    title: '『亀山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hb231kv2990',
    extent: [136.2500038, 35.00323864, 136.4999801, 34.83658606],
  },
  {
    id: '763',
    title: '『水口』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wd257hg3275',
    extent: [136.0000291, 35.00323191, 136.2500104, 34.83657848],
  },
  {
    id: '762',
    title: '『三田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bh342dt9740',
    extent: [135.0001186, 35.0032199, 135.2500976, 34.83656423],
  },
  {
    id: '760',
    title: '『龍野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sm861sy0340',
    extent: [134.5001656, 35.00321019, 134.7501451, 34.83655845],
  },
  {
    id: '761',
    title: '『北条』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mn364wg3445',
    extent: [134.7501421, 35.00321578, 135.0001204, 34.83656096],
  },
  {
    id: '759',
    title: '『上郡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wn566zw2311',
    extent: [134.2501881, 35.00320589, 134.5001704, 34.83655257],
  },
  {
    id: '758',
    title: '『周匝』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rx020vy8442',
    extent: [134.0002119, 35.00320156, 134.2501917, 34.83654799],
  },
  {
    id: '757',
    title: '『福渡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jk730js9540',
    extent: [133.7502313, 35.00319674, 134.0002167, 34.83654427],
  },
  {
    id: '756',
    title: '『呰部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wr869qt1970',
    extent: [133.5002558, 35.00319257, 133.750237, 34.83654029],
  },
  {
    id: '755',
    title: '『新見』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xb778gc1649',
    extent: [133.2502764, 35.00318848, 133.5002603, 34.83653576],
  },
  {
    id: '754',
    title: '『庄原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kw482mf6962',
    extent: [133.000299, 35.00318552, 133.2502815, 34.83653358],
  },
  {
    id: '753',
    title: '『上布野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yv728kq0255',
    extent: [132.7503262, 35.00317939, 133.0003041, 34.83653025],
  },
  {
    id: '5201',
    title: '『赤名』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fd867ny9894',
    extent: [132.5003509, 35.00317939, 132.7503304, 34.83652839],
  },
  {
    id: '751',
    title: '『川本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cv415gr4257',
    extent: [132.250372, 35.00317595, 132.5003558, 34.83652408],
  },
  {
    id: '750',
    title: '『浜田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mc048yw8722',
    extent: [132.0003618, 35.00317359, 132.2503753, 34.8365211],
  },
  {
    id: '749',
    title: '『下田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gr879kq7122',
    extent: [138.7497715, 34.83665155, 138.9997528, 34.66999362],
  },
  {
    id: '748',
    title: '『住吉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gt070wq3953',
    extent: [138.2498178, 34.83664199, 138.4998014, 34.66997994],
  },
  {
    id: '747',
    title: '『掛川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wt474xd1980',
    extent: [137.9998444, 34.83664199, 138.2498288, 34.66997994],
  },
  {
    id: '746',
    title: '『浜松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xg014nx9989',
    extent: [137.4998806, 34.83661958, 137.749863, 34.66996566],
  },
  {
    id: '745',
    title: '『豊橋』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ff799jk1386',
    extent: [137.2499067, 34.83661958, 137.4998933, 34.66996566],
  },
  {
    id: '744',
    title: '『蒲郡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jc807hk6099',
    extent: [136.9999318, 34.83661075, 137.2499147, 34.66995394],
  },
  {
    id: '742',
    title: '『津東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tq571dz3457',
    extent: [136.4999801, 34.83659085, 136.7499514, 34.66994287],
  },
  {
    id: '743',
    title: '『師崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dy796dh5293',
    extent: [136.7499455, 34.83660356, 136.9999402, 34.66994301],
  },
  {
    id: '741',
    title: '『津西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hv645yr5295',
    extent: [136.2500104, 34.83658896, 136.4999863, 34.66993548],
  },
  {
    id: '740',
    title: '『上野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hv165pd0277',
    extent: [136.0000329, 34.83658606, 136.2500152, 34.6699303],
  },
  {
    id: '737',
    title: '『姫路』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yh500hw9410',
    extent: [134.5001704, 34.83656096, 134.7501451, 34.66989625],
  },
  {
    id: '738',
    title: '『高砂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hq276sg8904',
    extent: [134.7501262, 34.83656423, 135.0001222, 34.66989625],
  },
  {
    id: '736',
    title: '『播州赤穂』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hm312rs6022',
    extent: [134.2501917, 34.83655845, 134.5001772, 34.66990445],
  },
  {
    id: '735',
    title: '『和気』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gm798jh2535',
    extent: [134.0002167, 34.83655257, 134.2501983, 34.66989831],
  },
  {
    id: '734',
    title: '『岡山北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fm307cb5529',
    extent: [133.750237, 34.83654799, 134.000221, 34.66989304],
  },
  {
    id: '733',
    title: '『高梁』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tr178gz6698',
    extent: [133.5002603, 34.83654427, 133.7502423, 34.66989304],
  },
  {
    id: '731',
    title: '『上下』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jq994gr3905',
    extent: [133.0003041, 34.83653576, 133.2502863, 34.66988568],
  },
  {
    id: '732',
    title: '『油木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fq215kp3181',
    extent: [133.2502815, 34.83654029, 133.5002643, 34.66988983],
  },
  {
    id: '729',
    title: '『八重』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bh620nj4829',
    extent: [132.5003558, 34.83653025, 132.7503367, 34.66988003],
  },
  {
    id: '728',
    title: '『大朝』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nh911ws5697',
    extent: [132.2503753, 34.83652839, 132.5003609, 34.66987566],
  },
  {
    id: '730',
    title: '『三次』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qj804hg4646',
    extent: [132.7503304, 34.83653358, 133.0003114, 34.66988229],
  },
  {
    id: '727',
    title: '『木都賀』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nf185hs3085',
    extent: [132.000396, 34.83652408, 132.2503796, 34.66987067],
  },
  {
    id: '725',
    title: '『飯浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hp782kb4522',
    extent: [131.5004123, 34.83647893, 131.7504213, 34.66982647],
  },
  {
    id: '726',
    title: '『益田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xh912vh6330',
    extent: [131.7503895, 34.8365211, 132.0004009, 34.66986532],
  },
  {
    id: '724',
    title: '『見島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xq579gv7298',
    extent: [131.0004579, 34.83646876, 131.25044, 34.66981642],
  },
  {
    id: '722',
    title: '『神子元島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bb284df4131',
    extent: [138.7497781, 34.66999962, 138.9997653, 34.5033445],
  },
  {
    id: '723',
    title: '『泉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gm644vm5550',
    extent: [129.2506189, 34.83643461, 129.5006073, 34.66978275],
  },
  {
    id: '721',
    title: '『御前崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sr504yp5720',
    extent: [137.9998444, 34.66998958, 138.2498288, 34.50332565],
  },
  {
    id: '720',
    title: '『掛塚』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hb141xt5954',
    extent: [137.7498695, 34.66998958, 137.9998501, 34.50331946],
  },
  {
    id: '719',
    title: '『田原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tm638ys7585',
    extent: [137.2499142, 34.66997294, 137.4998933, 34.5033072],
  },
  {
    id: '718',
    title: '『伊良湖岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gn373xz2968',
    extent: [136.9999357, 34.66996566, 137.2499147, 34.50330113],
  },
  {
    id: '716',
    title: '『松阪』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jn453wt5268',
    extent: [136.4999863, 34.66994301, 136.7499676, 34.50329514],
  },
  {
    id: '717',
    title: '『答志』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sk527vg4072',
    extent: [136.7499514, 34.66995394, 136.9999402, 34.50330113],
  },
  {
    id: '715',
    title: '『二本木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tz061mv2882',
    extent: [136.2500152, 34.66994287, 136.499992, 34.50328873],
  },
  {
    id: '714',
    title: '『名張』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yc725fb6183',
    extent: [136.0000357, 34.66993548, 136.2500182, 34.50328319],
  },
  {
    id: '713',
    title: '『寒霞溪』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qw620qn7503',
    extent: [134.2501983, 34.66990908, 134.5001772, 34.50324293],
  },
  {
    id: '712',
    title: '『西大寺』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pr138wc0512',
    extent: [134.000221, 34.66990445, 134.2502024, 34.50325116],
  },
  {
    id: '711',
    title: '『岡山南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wp680hb0798',
    extent: [133.7502423, 34.66989831, 134.0002271, 34.50324492],
  },
  {
    id: '710',
    title: '『玉島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fk724yf3779',
    extent: [133.5002643, 34.66989378, 133.7502457, 34.50324389],
  },
  {
    id: '709',
    title: '『井原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cb396yk4396',
    extent: [133.2502863, 34.66989378, 133.5002687, 34.50324248],
  },
  {
    id: '708',
    title: '『府中』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nw775hk5356',
    extent: [133.0003114, 34.66988983, 133.2502905, 34.5032391],
  },
  {
    id: '707',
    title: '『乃美』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jy188yz0449',
    extent: [132.7503367, 34.66988568, 133.0003134, 34.50323599],
  },
  {
    id: '706',
    title: '『可部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qk048gy1833',
    extent: [132.5003609, 34.66988229, 132.7503393, 34.50323286],
  },
  {
    id: '704',
    title: '『三段峡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nr363dg6028',
    extent: [132.0004009, 34.66987566, 132.2503821, 34.50322123],
  },
  {
    id: '705',
    title: '『加計』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bz893tj4019',
    extent: [132.2503796, 34.66988003, 132.5003621, 34.50322753],
  },
  {
    id: '703',
    title: '『日原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh968gg9235',
    extent: [131.7504213, 34.66987067, 132.0004055, 34.50321879],
  },
  {
    id: '701',
    title: '『相島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pj737fs4055',
    extent: [131.25044, 34.66982647, 131.500447, 34.50318247],
  },
  {
    id: '702',
    title: '『須佐』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cx250qw4471',
    extent: [131.5004172, 34.66986532, 131.7504254, 34.50321547],
  },
  {
    id: '700',
    title: '『佐須奈・三根』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fp266ws7681',
    extent: [129.2506235, 34.66981698, 129.5006073, 34.50313553],
  },
  {
    id: '699',
    title: '『鳥羽』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rg923dm4940',
    extent: [136.7499676, 34.5033017, 136.9999416, 34.33665317],
  },
  {
    id: '698',
    title: '『伊勢』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hp452sf7379',
    extent: [136.499992, 34.5033017, 136.7499735, 34.33664838],
  },
  {
    id: '697',
    title: '『丹生』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ky890ww0919',
    extent: [136.2500182, 34.50329514, 136.4999958, 34.33664343],
  },
  {
    id: '696',
    title: '『高見山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mv462wr8279',
    extent: [136.0000417, 34.50328873, 136.2500199, 34.3366361],
  },
  {
    id: '695',
    title: '『尾崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cp082fw2198',
    extent: [135.0001152, 34.5032646, 135.2501084, 34.33660645],
  },
  {
    id: '694',
    title: '『洲本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sy260xs1642',
    extent: [134.7501317, 34.5032646, 135.0001219, 34.33660645],
  },
  {
    id: '693',
    title: '『草壁』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sj109pm7457',
    extent: [134.2502024, 34.50325393, 134.5001591, 34.33659522],
  },
  {
    id: '692',
    title: '『高松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc320nd6540',
    extent: [134.0002267, 34.50325393, 134.250205, 34.33660381],
  },
  {
    id: '691',
    title: '『玉野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jz771kc5841',
    extent: [133.7502254, 34.50325116, 134.0002271, 34.3365787],
  },
  {
    id: '690',
    title: '『寄島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kg387mv8230',
    extent: [133.5002687, 34.50324492, 133.7502457, 34.3365787],
  },
  {
    id: '689',
    title: '『福山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ch529pv2312',
    extent: [133.2502905, 34.50324389, 133.5002732, 34.33659527],
  },
  {
    id: '688',
    title: '『尾道』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nr715jf1168',
    extent: [133.0003134, 34.50324248, 133.2502967, 34.33659204],
  },
  {
    id: '687',
    title: '『竹原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xb918gr2543',
    extent: [132.7503393, 34.5032391, 133.0003157, 34.33658986],
  },
  {
    id: '686',
    title: '『海田市』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pc233kq4590',
    extent: [132.5003621, 34.50323599, 132.7503453, 34.33658441],
  },
  {
    id: '685',
    title: '『広島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tc849qk5117',
    extent: [132.2503821, 34.50323286, 132.5003683, 34.33657973],
  },
  {
    id: '683',
    title: '『津和野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ts051jw6546',
    extent: [131.7504254, 34.50322123, 132.0004084, 34.33656959],
  },
  {
    id: '684',
    title: '『津田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ht453ym9138',
    extent: [132.0004055, 34.50322753, 132.2503873, 34.33657502],
  },
  {
    id: '682',
    title: '『徳佐中』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nr035js7372',
    extent: [131.500447, 34.50321879, 131.7504301, 34.33656635],
  },
  {
    id: '681',
    title: '『萩』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zr497wh6869',
    extent: [131.2504494, 34.50321547, 131.5004519, 34.33656047],
  },
  {
    id: '680',
    title: '『仙崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wb288mx8494',
    extent: [131.0004676, 34.50318247, 131.2504732, 34.3365557],
  },
  {
    id: '679',
    title: '『三根・仁位』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sd811vm1689',
    extent: [129.250628, 34.50314018, 129.5006095, 34.33648827],
  },
  {
    id: '678',
    title: '『神津島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tz478wq4263',
    extent: [138.9997653, 34.33664343, 139.249775, 34.1700737],
  },
  {
    id: '676',
    title: '『由良』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mf128yc2094',
    extent: [134.7501426, 34.33661562, 135.0001207, 34.16995304],
  },
  {
    id: '677',
    title: '『大台ヶ原山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nq708ty2205',
    extent: [136.0000442, 34.33664343, 136.2500212, 34.16998686],
  },
  {
    id: '675',
    title: '『三本松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qh748sk5173',
    extent: [134.2502037, 34.33660952, 134.5001835, 34.16996384],
  },
  {
    id: '674',
    title: '『高松南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kh151pm7941',
    extent: [134.0002267, 34.33660952, 134.250205, 34.16995856],
  },
  {
    id: '673',
    title: '『丸亀』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ns594cf3404',
    extent: [133.7502254, 34.33660381, 134.000234, 34.16995505],
  },
  {
    id: '672',
    title: '『仁尾』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rz472fc3327',
    extent: [133.5002529, 34.33660009, 133.7502548, 34.16992564],
  },
  {
    id: '671',
    title: '『魚島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qh077wz3526',
    extent: [133.2502751, 34.33660009, 133.5002732, 34.16992029],
  },
  {
    id: '670',
    title: '『土生』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sb883sp1598',
    extent: [133.0003032, 34.33659527, 133.2502967, 34.16992029],
  },
  {
    id: '669',
    title: '『三津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dh696gr6979',
    extent: [132.7503453, 34.33659204, 133.0003157, 34.16992324],
  },
  {
    id: '668',
    title: '『呉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cr849mt4398',
    extent: [132.5003683, 34.33658986, 132.7503488, 34.16993642],
  },
  {
    id: '667',
    title: '『厳島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ht634yt7907',
    extent: [132.2503873, 34.33658441, 132.5003703, 34.16993093],
  },
  {
    id: '666',
    title: '『大竹』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jn665qt1277',
    extent: [132.0004084, 34.33657973, 132.2503923, 34.16992783],
  },
  {
    id: '665',
    title: '『鹿野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pm157zg9222',
    extent: [131.7504301, 34.33657502, 132.0004118, 34.16992223],
  },
  {
    id: '664',
    title: '『長門峡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wm138my5304',
    extent: [131.5004519, 34.33656959, 131.750434, 34.16991616],
  },
  {
    id: '663',
    title: '『山口』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pw848gp7784',
    extent: [131.2504732, 34.33656635, 131.5004541, 34.16991166],
  },
  {
    id: '662',
    title: '『小串』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wf092qs1325',
    extent: [130.7504951, 34.3365557, 131.0004957, 34.16986933],
  },
  {
    id: '661',
    title: '『沖島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mf036js1377',
    extent: [130.0005636, 34.33650706, 130.2505453, 34.16985494],
  },
  {
    id: '660',
    title: '『仁位・厳原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dw111bp8366',
    extent: [129.2506325, 34.33649289, 129.5006139, 34.16984558],
  },
  {
    id: '659',
    title: '『厳原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rt220rs8653',
    extent: [129.0006555, 34.33648827, 129.250635, 34.16983641],
  },
  {
    id: '658',
    title: '『三宅島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kv658gg8766',
    extent: [139.4997358, 34.1700737, 139.7497212, 34.00341895],
  },
  {
    id: '657',
    title: '『三宅島西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fn026xh1192',
    extent: [139.249775, 34.1700737, 139.4997602, 34.00341895],
  },
  {
    id: '656',
    title: '『島勝浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vd339xd2901',
    extent: [136.2500212, 34.16999329, 136.499996, 34.00334353],
  },
  {
    id: '655',
    title: '『海南』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fm207tv8865',
    extent: [135.0001207, 34.16997598, 135.2501142, 34.00331082],
  },
  {
    id: '654',
    title: '『川島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gk682zw1950',
    extent: [134.2502037, 34.16996651, 134.5001846, 34.00331609],
  },
  {
    id: '653',
    title: '『脇町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kq800sx4969',
    extent: [134.0002311, 34.16996384, 134.2502086, 34.0033127],
  },
  {
    id: '652',
    title: '『池田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sm762sy4211',
    extent: [133.7502548, 34.16995856, 134.000234, 34.00330924],
  },
  {
    id: '651',
    title: '『観音寺』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/df979dk7295',
    extent: [133.5002529, 34.16995505, 133.7502588, 34.00327793],
  },
  {
    id: '650',
    title: '『股島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zn547kg3314',
    extent: [133.2502751, 34.16992564, 133.500258, 34.00327261],
  },
  {
    id: '649',
    title: '『今治東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dx515ys8232',
    extent: [133.0003032, 34.16992324, 133.2502802, 34.00327261],
  },
  {
    id: '647',
    title: '『倉橋島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rf724qt0024',
    extent: [132.500354, 34.16994276, 132.7503488, 34.00326375],
  },
  {
    id: '648',
    title: '『今治西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qs976ys7785',
    extent: [132.750331, 34.16992324, 133.0003296, 34.00327261],
  },
  {
    id: '646',
    title: '『柱島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rd169tz2278',
    extent: [132.2503923, 34.16993642, 132.5003703, 34.00326375],
  },
  {
    id: '645',
    title: '『岩国』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dt241rp8216',
    extent: [132.0004118, 34.16993093, 132.2503967, 34.00327931],
  },
  {
    id: '644',
    title: '『徳山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mk276yp6521',
    extent: [131.7504142, 34.16992783, 132.0004167, 34.00324162],
  },
  {
    id: '643',
    title: '『防府』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vn274cj7071',
    extent: [131.5004541, 34.16992223, 131.750434, 34.00324162],
  },
  {
    id: '642',
    title: '『小郡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gc985qm5164',
    extent: [131.2504781, 34.16991616, 131.5004604, 34.00326166],
  },
  {
    id: '641',
    title: '『久和』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tt234py1601',
    extent: [129.250635, 34.16987315, 129.5006184, 34.00319363],
  },
  {
    id: '640',
    title: '『厳原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nm091sc5933',
    extent: [129.0006599, 34.16987315, 129.2506413, 34.00318909],
  },
  {
    id: '639',
    title: '『木本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nz086xv6429',
    extent: [136.2500212, 34.00331082, 136.499996, 33.83666293],
  },
  {
    id: '638',
    title: '『伊島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tc967wq6930',
    extent: [134.7501479, 34.00331082, 135.0001315, 33.83666293],
  },
  {
    id: '637',
    title: '『阿波富岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mk762zm1375',
    extent: [134.5001846, 34.00331773, 134.7501607, 33.83667327],
  },
  {
    id: '636',
    title: '『雲早山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vx372tw0177',
    extent: [134.2502086, 34.00331773, 134.5001857, 33.8366719],
  },
  {
    id: '634',
    title: '『川口』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yk438hm3351',
    extent: [133.7502588, 34.0033127, 134.0002364, 33.83666528],
  },
  {
    id: '635',
    title: '『剣山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pz249fk8360',
    extent: [134.0002311, 34.00331609, 134.2502127, 33.83666865],
  },
  {
    id: '633',
    title: '『伊予三島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/th608pv6340',
    extent: [133.500258, 34.00330924, 133.750259, 33.83666123],
  },
  {
    id: '632',
    title: '『新居浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fv486qn4671',
    extent: [133.2502802, 34.00327793, 133.5002829, 33.83665752],
  },
  {
    id: '631',
    title: '『西条』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rf536dm7773',
    extent: [133.0003278, 34.00330031, 133.2503058, 33.83665037],
  },
  {
    id: '628',
    title: '『宇部東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nk151st9760',
    extent: [131.2504781, 34.00327931, 131.5004604, 33.83659403],
  },
  {
    id: '629',
    title: '『光』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh761pz0866',
    extent: [131.7504142, 34.00327931, 132.0004167, 33.83659403],
  },
  {
    id: '630',
    title: '『松山北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mk321dw7190',
    extent: [132.750331, 34.00330031, 133.0003296, 33.83664564],
  },
  {
    id: '627',
    title: '『神湊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vd959jj3019',
    extent: [130.2505499, 34.00321705, 130.500546, 33.83656481],
  },
  {
    id: '626',
    title: '『勝本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fn134dh3479',
    extent: [129.5006228, 34.00321705, 129.7506044, 33.83656481],
  },
  {
    id: '625',
    title: '『日和佐』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cm756hk3982',
    extent: [134.5001804, 33.83667488, 134.7501607, 33.67000397],
  },
  {
    id: '624',
    title: '『桜谷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ft434wf7214',
    extent: [134.2502125, 33.83667327, 134.5001857, 33.67000397],
  },
  {
    id: '621',
    title: '『本山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bn334tq8341',
    extent: [133.5002829, 33.83666528, 133.7502598, 33.6700152],
  },
  {
    id: '622',
    title: '『大栃』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gw681bj5672',
    extent: [133.750259, 33.83666865, 134.0002364, 33.67002158],
  },
  {
    id: '623',
    title: '『北川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rv016dr9614',
    extent: [134.0002342, 33.8366719, 134.2502127, 33.67002612],
  },
  {
    id: '620',
    title: '『日比原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tf152xb2058',
    extent: [133.2503058, 33.83666123, 133.5002841, 33.67000993],
  },
  {
    id: '619',
    title: '『石鎚山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cd627hc8769',
    extent: [133.0003291, 33.83665752, 133.2503073, 33.67000568],
  },
  {
    id: '615',
    title: '『光』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gn994sd6325',
    extent: [131.750419, 33.83659906, 132.0004014, 33.66994641],
  },
  {
    id: '617',
    title: '『郡中』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kc437hn2950',
    extent: [132.5003519, 33.83664564, 132.7503553, 33.66996157],
  },
  {
    id: '618',
    title: '『松山南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gh183vg1700',
    extent: [132.750354, 33.83665037, 133.0003296, 33.66999809],
  },
  {
    id: '616',
    title: '『青島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gg907bj1315',
    extent: [132.2503742, 33.83660925, 132.5003568, 33.66995647],
  },
  {
    id: '614',
    title: '『姫島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mb170qd9385',
    extent: [131.5004415, 33.83659403, 131.7504238, 33.66994641],
  },
  {
    id: '613',
    title: '『勝本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vh864ws4779',
    extent: [129.7506034, 33.83658434, 130.0005817, 33.66990798],
  },
  {
    id: '611',
    title: '『藺灘波島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vb910sy6901',
    extent: [139.249775, 33.67012222, 139.4997602, 33.5034675],
  },
  {
    id: '612',
    title: '『勝本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sh825sk5009',
    extent: [129.5006228, 33.83658434, 129.7506044, 33.66990338],
  },
  {
    id: '608',
    title: '『馬路』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pk772mb6492',
    extent: [134.0002342, 33.67002753, 134.2502125, 33.5033802],
  },
  {
    id: '610',
    title: '『周参見』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xp912ry0126',
    extent: [135.2501151, 33.67003819, 135.5000988, 33.50337261],
  },
  {
    id: '609',
    title: '『甲浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xk804dv4811',
    extent: [134.2502113, 33.67002753, 134.5001856, 33.50335605],
  },
  {
    id: '607',
    title: '『手結』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc881vc8289',
    extent: [133.7502513, 33.67002612, 134.0002345, 33.50333988],
  },
  {
    id: '606',
    title: '『高知』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kt574kg1764',
    extent: [133.5002841, 33.67002158, 133.7502598, 33.50333988],
  },
  {
    id: '601',
    title: '『伊予長浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dy815pf0341',
    extent: [132.2503791, 33.66996157, 132.5003822, 33.50330876],
  },
  {
    id: '603',
    title: '『久万』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vc192kw6218',
    extent: [132.7503553, 33.67000568, 133.0003343, 33.503352],
  },
  {
    id: '602',
    title: '『大洲』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zk850wh7864',
    extent: [132.5003568, 33.66999809, 132.7503584, 33.50334539],
  },
  {
    id: '605',
    title: '『伊野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ts185hd1186',
    extent: [133.2503073, 33.6700152, 133.5002854, 33.50336427],
  },
  {
    id: '604',
    title: '『上土居』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hz080ty2250',
    extent: [133.0003291, 33.67000993, 133.2503079, 33.50335771],
  },
  {
    id: '600',
    title: '『鶴川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc081pc2550',
    extent: [131.5004658, 33.66997147, 131.7504466, 33.50332028],
  },
  {
    id: '598',
    title: '『中津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gn664hn9288',
    extent: [131.0005086, 33.6699599, 131.2504905, 33.50330987],
  },
  {
    id: '596',
    title: '『太宰府』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yg959ng1802',
    extent: [130.5005487, 33.66995527, 130.7505335, 33.50330192],
  },
  {
    id: '595',
    title: '『福岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pd143yg6807',
    extent: [130.250559, 33.6699508, 130.5005522, 33.50329747],
  },
  {
    id: '597',
    title: '『田川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xc588bx6283',
    extent: [130.7505297, 33.6699599, 131.0005128, 33.50330567],
  },
  {
    id: '599',
    title: '『宇佐』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xf384qv4312',
    extent: [131.2504687, 33.66997147, 131.5004708, 33.50331644],
  },
  {
    id: '594',
    title: '『二神島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ns269cv9086',
    extent: [129.5006272, 33.66990798, 129.7506088, 33.50326048],
  },
  {
    id: '591',
    title: '『土佐長浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mj419xx5288',
    extent: [133.5002782, 33.50336921, 133.7502563, 33.33668672],
  },
  {
    id: '588',
    title: '『卯之町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xb337qj2953',
    extent: [132.5003822, 33.503352, 132.7503616, 33.33669774],
  },
  {
    id: '590',
    title: '『須崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gp504bm0782',
    extent: [133.2503079, 33.50336921, 133.5002854, 33.33668672],
  },
  {
    id: '592',
    title: '『安芸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rh866tp1958',
    extent: [133.7502513, 33.5033802, 134.0002345, 33.33669199],
  },
  {
    id: '589',
    title: '『新田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tm325pd1757',
    extent: [133.0003343, 33.50336427, 133.2503102, 33.3367116],
  },
  {
    id: '593',
    title: '『奈半利』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rj182gy5789',
    extent: [134.0002344, 33.50338079, 134.2502125, 33.33669731],
  },
  {
    id: '587',
    title: '『八幡浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kh334rm6419',
    extent: [132.2503887, 33.50330876, 132.5003891, 33.336661],
  },
  {
    id: '586',
    title: '『伊予三崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py479js2630',
    extent: [132.0004062, 33.50330876, 132.2503887, 33.336661],
  },
  {
    id: '585',
    title: '『豊後杵築』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yk316wx6106',
    extent: [131.5004708, 33.50332128, 131.7504466, 33.33665103],
  },
  {
    id: '584',
    title: '『豊岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nf479nb1236',
    extent: [131.2504905, 33.50332128, 131.5004716, 33.33666464],
  },
  {
    id: '583',
    title: '『耶馬溪』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kx859pz0291',
    extent: [131.0005128, 33.50331644, 131.2504952, 33.3366624],
  },
  {
    id: '582',
    title: '『吉井』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh756fj5956',
    extent: [130.7505335, 33.50330987, 131.0005159, 33.33665578],
  },
  {
    id: '581',
    title: '『甘木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/st141rt0255',
    extent: [130.5005522, 33.50330567, 130.7505366, 33.33665122],
  },
  {
    id: '580',
    title: '『脊振山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wj962fq4768',
    extent: [130.2505729, 33.50330192, 130.5005581, 33.33664697],
  },
  {
    id: '579',
    title: '『浜崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wt392ks3119',
    extent: [130.0005861, 33.50329747, 130.2505784, 33.33664286],
  },
  {
    id: '577',
    title: '『生月』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dw364cq1965',
    extent: [129.2506543, 33.50326133, 129.5006407, 33.33660386],
  },
  {
    id: '578',
    title: '『平戸』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zb514rh2538',
    extent: [129.5006319, 33.50326133, 129.750619, 33.33663086],
  },
  {
    id: '576',
    title: '『室戸岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cx900nx8035',
    extent: [134.0002344, 33.33670268, 134.2502176, 33.17004937],
  },
  {
    id: '575',
    title: '『一子碆』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pq363np2665',
    extent: [133.2503051, 33.33671835, 133.5002832, 33.17003361],
  },
  {
    id: '574',
    title: '『窪川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jk267xq2796',
    extent: [133.0003366, 33.33671835, 133.2503102, 33.17003361],
  },
  {
    id: '573',
    title: '『田野々』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cd838ff6497',
    extent: [132.7503616, 33.3367116, 133.000341, 33.17005672],
  },
  {
    id: '572',
    title: '『宇和島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jz326fh4144',
    extent: [132.5003859, 33.33670506, 132.7503633, 33.17004981],
  },
  {
    id: '570',
    title: '『佐賀関』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gd768hw1348',
    extent: [131.7504332, 33.33666261, 132.0004306, 33.17002698],
  },
  {
    id: '571',
    title: '『伊予高山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sw890br0330',
    extent: [132.2503887, 33.33669774, 132.5003891, 33.17002028],
  },
  {
    id: '568',
    title: '『別府』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kf004rh9026',
    extent: [131.2504952, 33.3366681, 131.500477, 33.17001576],
  },
  {
    id: '569',
    title: '『大分』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sk712hb2764',
    extent: [131.5004716, 33.33666464, 131.7504564, 33.17001876],
  },
  {
    id: '567',
    title: '『森』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jc668yw2909',
    extent: [131.0005159, 33.3366681, 131.2505006, 33.17001362],
  },
  {
    id: '566',
    title: '『日田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sn081pt1382',
    extent: [130.7505366, 33.3366624, 131.0005221, 33.1700046],
  },
  {
    id: '564',
    title: '『佐賀』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pt331jg1774',
    extent: [130.2505748, 33.33664697, 130.5005646, 33.16997947],
  },
  {
    id: '565',
    title: '『久留米』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mz024xw7858',
    extent: [130.5005522, 33.33664697, 130.7505366, 33.16997947],
  },
  {
    id: '561',
    title: '『志々伎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dd396cx7334',
    extent: [129.2506543, 33.33664697, 129.5006407, 33.16997947],
  },
  {
    id: '562',
    title: '『佐世保』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tt933zv7497',
    extent: [129.5006527, 33.33664697, 129.7506351, 33.16997947],
  },
  {
    id: '563',
    title: '『武雄』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xg366fh8572',
    extent: [130.0005987, 33.33664697, 130.2505784, 33.16997947],
  },
  {
    id: '560',
    title: '『小値賀島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sk046fd8562',
    extent: [129.0006928, 33.33664697, 129.2506543, 33.16997947],
  },
  {
    id: '559',
    title: '『肥前赤島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qw472hz0816',
    extent: [128.7507083, 33.33664697, 129.0006864, 33.16997947],
  },
  {
    id: '558',
    title: '『八丈島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xx013fh8315',
    extent: [139.7497515, 33.1701894, 139.9997369, 33.00353449],
  },
  {
    id: '557',
    title: '『土佐佐賀』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zc089kv5918',
    extent: [133.000341, 33.17006593, 133.25031, 33.00338568],
  },
  {
    id: '556',
    title: '『岩松』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dp550mn6891',
    extent: [132.5003891, 33.17005672, 132.7503704, 33.00340228],
  },
  {
    id: '555',
    title: '『魚神山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sh248xs3251',
    extent: [132.2503981, 33.17005672, 132.5003928, 33.00340228],
  },
  {
    id: '554',
    title: '『保戸島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jw276cc9711',
    extent: [132.0004203, 33.17002842, 132.2503981, 33.00336041],
  },
  {
    id: '552',
    title: '『久住』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fx540yy3714',
    extent: [131.2505006, 33.17001876, 131.500481, 33.00336263],
  },
  {
    id: '553',
    title: '『犬飼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tt188hg1408',
    extent: [131.500481, 33.17001876, 131.7504663, 33.00336263],
  },
  {
    id: '548',
    title: '『鹿島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ws632tw6500',
    extent: [130.000602, 33.16999152, 130.2505767, 33.0033269],
  },
  {
    id: '551',
    title: '『宮原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mr794wr9218',
    extent: [131.0005221, 33.17001576, 131.2505034, 33.00335679],
  },
  {
    id: '549',
    title: '『大牟田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ds127xw0869',
    extent: [130.2505748, 33.17000135, 130.5005646, 33.0033269],
  },
  {
    id: '550',
    title: '『八方ヶ岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ny016km4027',
    extent: [130.7505413, 33.17001362, 131.000526, 33.00335495],
  },
  {
    id: '547',
    title: '『早岐』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hs656vv7569',
    extent: [129.7506236, 33.16999152, 130.0006077, 33.00333519],
  },
  {
    id: '546',
    title: '『佐世保南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qx064bv2699',
    extent: [129.5006527, 33.16999152, 129.7506351, 33.00333519],
  },
  {
    id: '540',
    title: '『佐伯』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/md155mp7573',
    extent: [131.75046, 33.00337762, 132.0004442, 32.83672796],
  },
  {
    id: '544',
    title: '『立串』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rj729mg4908',
    extent: [129.0006928, 33.16997, 129.2506543, 33.00329994],
  },
  {
    id: '545',
    title: '『肥前江島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dt074vm2716',
    extent: [129.2506543, 33.16997, 129.5006407, 33.00329994],
  },
  {
    id: '543',
    title: '『肥前平島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bd799xb6405',
    extent: [128.7507083, 33.16997, 129.0006864, 33.00329994],
  },
  {
    id: '542',
    title: '『宿毛』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qx197rw0921',
    extent: [132.5003807, 33.00340228, 132.7503739, 32.8367175],
  },
  {
    id: '541',
    title: '『伊予鹿島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/th329vy2027',
    extent: [132.2503981, 33.00340228, 132.5003928, 32.8367175],
  },
  {
    id: '539',
    title: '『三重町』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xc320wz4170',
    extent: [131.500481, 33.00337762, 131.7504663, 32.83672077],
  },
  {
    id: '537',
    title: '『阿蘇山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kb486tc6639',
    extent: [131.000526, 33.00336263, 131.2505095, 32.83670725],
  },
  {
    id: '538',
    title: '『竹田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xn340mq1056',
    extent: [131.2505034, 33.00336917, 131.5004849, 32.83671152],
  },
  {
    id: '536',
    title: '『菊池』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sg925xn5866',
    extent: [130.7505455, 33.00335679, 131.000529, 32.83670293],
  },
  {
    id: '535',
    title: '『玉名』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/md502yd7566',
    extent: [130.5005586, 33.00335495, 130.7505501, 32.83668383],
  },
  {
    id: '534',
    title: '『荒尾』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qj166dy5299',
    extent: [130.2505767, 33.00335131, 130.5005646, 32.83668383],
  },
  {
    id: '531',
    title: '『神浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fv996dd2130',
    extent: [129.5006527, 33.00334175, 129.7506351, 32.83668544],
  },
  {
    id: '532',
    title: '『大村』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kk882hr1890',
    extent: [129.7506271, 33.00334175, 130.0006128, 32.83668544],
  },
  {
    id: '533',
    title: '『諫早』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fw884rn0462',
    extent: [130.0006077, 33.00334175, 130.2505914, 32.83668995],
  },
  {
    id: '530',
    title: '『有川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vq005cz5381',
    extent: [129.0006928, 33.00332135, 129.2506543, 32.83665235],
  },
  {
    id: '529',
    title: '『漁生浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qt627mq9670',
    extent: [128.7507124, 33.00332135, 129.0006928, 32.83665235],
  },
  {
    id: '528',
    title: '『土佐清水』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kk508sd7300',
    extent: [133.0003368, 32.83673771, 133.2503196, 32.67008461],
  },
  {
    id: '527',
    title: '『土佐清水』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xv324bq8642',
    extent: [132.7503634, 32.83676068, 133.0003415, 32.67007956],
  },
  {
    id: '526',
    title: '『柏島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dv276bc1584',
    extent: [132.5003807, 32.83676068, 132.7503739, 32.67007455],
  },
  {
    id: '525',
    title: '『熊田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wx097qz9675',
    extent: [131.5004849, 32.83672796, 131.7504707, 32.67006916],
  },
  {
    id: '524',
    title: '『三田井』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zg017np1499',
    extent: [131.2505095, 32.83672077, 131.5004935, 32.67006007],
  },
  {
    id: '522',
    title: '『御船』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qw807kd6455',
    extent: [130.7505501, 32.83670725, 131.0005349, 32.67005157],
  },
  {
    id: '523',
    title: '『高森』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fr032dq2588',
    extent: [131.000529, 32.83671152, 131.2505124, 32.67005705],
  },
  {
    id: '521',
    title: '『熊本』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zq417gz0982',
    extent: [130.5005629, 32.83670725, 130.750562, 32.67005157],
  },
  {
    id: '520',
    title: '『島原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cc394qj9218',
    extent: [130.2505914, 32.83669453, 130.5005629, 32.67003607],
  },
  {
    id: '519',
    title: '『肥前小浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pb266xq1374',
    extent: [130.0006077, 32.83669453, 130.2505975, 32.67002689],
  },
  {
    id: '517',
    title: '『長崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bx547qd9913',
    extent: [129.5006527, 32.83668995, 129.7506351, 32.67002689],
  },
  {
    id: '518',
    title: '『長崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xg215xf0137',
    extent: [129.7506315, 32.83668995, 130.0006128, 32.67002689],
  },
  {
    id: '516',
    title: '『福江』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nr039bd9918',
    extent: [128.7507124, 32.83667116, 129.0006864, 32.67002689],
  },
  {
    id: '515',
    title: '『延岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sx494pq8019',
    extent: [131.5004935, 32.67007839, 131.7504707, 32.50341187],
  },
  {
    id: '514',
    title: '『諸塚山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ky748fh3940',
    extent: [131.2505124, 32.67006916, 131.5004981, 32.50341137],
  },
  {
    id: '513',
    title: '『鞍岡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gr432xg0526',
    extent: [131.0005349, 32.67006007, 131.2505208, 32.50340748],
  },
  {
    id: '511',
    title: '『三角』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mf580yz8854',
    extent: [130.2505896, 32.67004132, 130.5005672, 32.50338366],
  },
  {
    id: '512',
    title: '『八代』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qn696wj8411',
    extent: [130.5005629, 32.67005157, 130.750562, 32.50338826],
  },
  {
    id: '510',
    title: '『口之津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zp882nc2572',
    extent: [130.0006077, 32.67004132, 130.2505975, 32.50337912],
  },
  {
    id: '509',
    title: '『野母崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sh039dd3025',
    extent: [129.7506351, 32.67003337, 130.0006128, 32.50337462],
  },
  {
    id: '505',
    title: '『日向』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wb891nx4009',
    extent: [131.5004981, 32.50341681, 131.7504606, 32.33676391],
  },
  {
    id: '507',
    title: '『富江』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tn717qh1998',
    extent: [128.7507124, 32.67002689, 129.0006864, 32.50337016],
  },
  {
    id: '506',
    title: '『青ヶ島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fs538jv6645',
    extent: [139.7497749, 32.50359468, 139.9997602, 32.33693971],
  },
  {
    id: '508',
    title: '『野母崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vv800vq6977',
    extent: [129.5006527, 32.67003337, 129.7506351, 32.50337016],
  },
  {
    id: '504',
    title: '『神門』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cn949pt2161',
    extent: [131.2505208, 32.50341681, 131.5005025, 32.33676279],
  },
  {
    id: '503',
    title: '『椎葉村』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bt957tm9201',
    extent: [131.0005386, 32.50341137, 131.2505269, 32.33675621],
  },
  {
    id: '502',
    title: '『頭地』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zc982sr3493',
    extent: [130.750562, 32.50340748, 131.0005491, 32.3367496],
  },
  {
    id: '501',
    title: '『日奈久』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jz729fx3710',
    extent: [130.5005672, 32.50340179, 130.7505674, 32.33674335],
  },
  {
    id: '500',
    title: '『本渡』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sn868ts7051',
    extent: [130.0006119, 32.50338366, 130.2505938, 32.33673351],
  },
  {
    id: '499',
    title: '『高浜』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fh984kr1630',
    extent: [129.7506344, 32.50337912, 130.0006249, 32.33672683],
  },
  {
    id: '498',
    title: '『都農』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gh579yg7336',
    extent: [131.5005025, 32.33676895, 131.750465, 32.17011592],
  },
  {
    id: '497',
    title: '『尾鈴山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kg897jv2642',
    extent: [131.2505269, 32.33676895, 131.5005112, 32.17011309],
  },
  {
    id: '495',
    title: '『人吉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kv451hv0065',
    extent: [130.7505674, 32.33675621, 131.0005524, 32.17009979],
  },
  {
    id: '496',
    title: '『村所』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ws583yp5464',
    extent: [131.0005491, 32.33676279, 131.2505307, 32.17010563],
  },
  {
    id: '494',
    title: '『佐敷』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kk135yg0170',
    extent: [130.5005869, 32.3367496, 130.7505726, 32.1700947],
  },
  {
    id: '493',
    title: '『水俣』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cx198hw6628',
    extent: [130.2505938, 32.33674335, 130.500593, 32.1700896],
  },
  {
    id: '492',
    title: '『牛深』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yw010hy3955',
    extent: [130.000623, 32.33673583, 130.2506109, 32.17008299],
  },
  {
    id: '491',
    title: '『魚貫崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ng613ms8905',
    extent: [129.7506385, 32.33673351, 130.0006249, 32.170079],
  },
  {
    id: '490',
    title: '『肥前鳥島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rh352vn8573',
    extent: [128.0007965, 32.33670088, 128.2507776, 32.17004902],
  },
  {
    id: '489',
    title: '『高鍋』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rx315fn4857',
    extent: [131.5005112, 32.17011851, 131.7504694, 32.00346787],
  },
  {
    id: '487',
    title: '『須木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ws325wr0199',
    extent: [131.0005524, 32.17011309, 131.2505366, 32.00345555],
  },
  {
    id: '488',
    title: '『妻』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dr054zr5417',
    extent: [131.2505307, 32.17011851, 131.5005132, 32.00346257],
  },
  {
    id: '486',
    title: '『加久藤』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gy028fk1191',
    extent: [130.7505726, 32.17010563, 131.0005571, 32.0034521],
  },
  {
    id: '485',
    title: '『大口』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vk623dr7656',
    extent: [130.500593, 32.17009979, 130.7505806, 32.00344472],
  },
  {
    id: '481',
    title: '『男島及女島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qc523gd5233',
    extent: [128.2507776, 32.17005737, 128.5007589, 32.00340542],
  },
  {
    id: '484',
    title: '『出水』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kj336nh8750',
    extent: [130.2506109, 32.1700947, 130.5005996, 32.00344031],
  },
  {
    id: '483',
    title: '『阿久根』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kq741wk9448',
    extent: [130.000623, 32.1700896, 130.2506178, 32.00343557],
  },
  {
    id: '482',
    title: '『片島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh188dk8506',
    extent: [129.7506426, 32.17008299, 130.0006244, 32.00343113],
  },
  {
    id: '480',
    title: '『宮崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sw175tz5944',
    extent: [131.2505366, 32.00346832, 131.5005132, 31.83681101],
  },
  {
    id: '479',
    title: '『野尻』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tp100bz6619',
    extent: [131.0005571, 32.00346257, 131.2505448, 31.83680612],
  },
  {
    id: '478',
    title: '『霧島山』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gw986xh2826',
    extent: [130.7505806, 32.00345555, 131.0005638, 31.83679999],
  },
  {
    id: '477',
    title: '『栗野』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qp456gj4008',
    extent: [130.5005996, 32.0034521, 130.7505859, 31.83679597],
  },
  {
    id: '476',
    title: '『宮之城』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vb946jq6084',
    extent: [130.2506178, 32.00344472, 130.5006054, 31.83679101],
  },
  {
    id: '475',
    title: '『西方』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xw039np9324',
    extent: [130.0006244, 32.00344031, 130.2506266, 31.83678763],
  },
  {
    id: '474',
    title: '『中甑』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vm817td8667',
    extent: [129.7506467, 32.00343557, 130.0006285, 31.83678321],
  },
  {
    id: '473',
    title: '『男女群島南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xr546xx2851',
    extent: [128.2507815, 32.00340959, 128.5007627, 31.83675762],
  },
  {
    id: '472',
    title: '『日向青島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pr727gk1392',
    extent: [131.2505448, 31.83681506, 131.5005, 31.67015951],
  },
  {
    id: '470',
    title: '『国分』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hj587qb2191',
    extent: [130.7505661, 31.83680612, 131.0005716, 31.67015312],
  },
  {
    id: '471',
    title: '『都城』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vs914db5108',
    extent: [131.0005638, 31.83681101, 131.250551, 31.67015512],
  },
  {
    id: '468',
    title: '『川内』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bs445zj3498',
    extent: [130.2506103, 31.83679597, 130.5006142, 31.67014411],
  },
  {
    id: '469',
    title: '『加治木』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nh479mb0291',
    extent: [130.5006054, 31.83679999, 130.7505859, 31.67014497],
  },
  {
    id: '467',
    title: '『羽島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cs737tb1378',
    extent: [130.0006285, 31.83679101, 130.2506266, 31.67013966],
  },
  {
    id: '466',
    title: '『中甑』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/py659kw8652',
    extent: [129.7506507, 31.83678321, 130.0006325, 31.67013526],
  },
  {
    id: '464',
    title: '『飫肥』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kb538gn9888',
    extent: [131.250551, 31.67016697, 131.5005043, 31.50351209],
  },
  {
    id: '465',
    title: '『手打』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vb937nz2270',
    extent: [129.5006731, 31.83678321, 129.7506547, 31.67013091],
  },
  {
    id: '462',
    title: '『岩川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bd076tc0298',
    extent: [130.7505661, 31.67015512, 131.0005788, 31.50349902],
  },
  {
    id: '463',
    title: '『末吉』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ws561yn9597',
    extent: [131.0005716, 31.67015951, 131.2505561, 31.5035083],
  },
  {
    id: '461',
    title: '『鹿児島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xb080fh8320',
    extent: [130.5006142, 31.67015312, 130.7505981, 31.50349524],
  },
  {
    id: '459',
    title: '『手打』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qj546sn2401',
    extent: [129.500677, 31.67013526, 129.7506587, 31.50348293],
  },
  {
    id: '460',
    title: '『伊集院』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vt648fk3015',
    extent: [130.2506103, 31.67014497, 130.5006209, 31.50349524],
  },
  {
    id: '458',
    title: '『都井岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xt994dv1395',
    extent: [131.2505304, 31.50351882, 131.5005085, 31.33686601],
  },
  {
    id: '457',
    title: '『志布志』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gv306vh3285',
    extent: [131.0005788, 31.50351209, 131.2505561, 31.33685728],
  },
  {
    id: '456',
    title: '『鹿屋』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gd795yk1227',
    extent: [130.7505743, 31.5035083, 131.0005857, 31.33685691],
  },
  {
    id: '455',
    title: '『垂水』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vs313hw6981',
    extent: [130.5006209, 31.50349902, 130.7505981, 31.33684887],
  },
  {
    id: '453',
    title: '『野間岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vg035sz9311',
    extent: [130.0006365, 31.50349606, 130.2506487, 31.3368418],
  },
  {
    id: '454',
    title: '『加世田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cb449nn6254',
    extent: [130.2506144, 31.50349606, 130.5006242, 31.3368418],
  },
  {
    id: '452',
    title: '『内之浦』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rr692vw9381',
    extent: [131.0005829, 31.33686601, 131.2505345, 31.17021076],
  },
  {
    id: '451',
    title: '『大根占』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yk015sg2155',
    extent: [130.7505743, 31.33685728, 131.0005857, 31.17020327],
  },
  {
    id: '450',
    title: '『開聞岳』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc613fr0605',
    extent: [130.5006242, 31.33685691, 130.7506111, 31.17019835],
  },
  {
    id: '449',
    title: '『枕崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yf232wp9182',
    extent: [130.2506224, 31.33684887, 130.5006297, 31.17019835],
  },
  {
    id: '448',
    title: '『坊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vy146qm4988',
    extent: [130.0006405, 31.33684358, 130.2506487, 31.17019548],
  },
  {
    id: '447',
    title: '『辺塚』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pc939sb4521',
    extent: [130.7505824, 31.17021076, 131.0005829, 31.00356054],
  },
  {
    id: '446',
    title: '『佐多岬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zy137xp9883',
    extent: [130.5006043, 31.17020327, 130.7506111, 31.00355609],
  },
  {
    id: '445',
    title: '『国上』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/cz212fz0454',
    extent: [131.0005645, 30.83692125, 131.2505467, 30.67026192],
  },
  {
    id: '444',
    title: '『種子島北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hq532pz2291',
    extent: [130.7505864, 30.83691675, 131.000612, 30.67026192],
  },
  {
    id: '443',
    title: '『古田』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vt525bq0826',
    extent: [131.0005725, 30.67027292, 131.2505507, 30.50362008],
  },
  {
    id: '442',
    title: '『種子島中部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/kq205sv4014',
    extent: [130.7505903, 30.670264, 131.000612, 30.50361565],
  },
  {
    id: '440',
    title: '『諏訪之瀬島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tg272qf7632',
    extent: [129.5007149, 30.00365337, 129.7506967, 29.83700082],
  },
  {
    id: '441',
    title: '『屋久島東北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ft528vv5105',
    extent: [130.5006161, 30.50361565, 130.7505982, 30.33694509],
  },
  {
    id: '438',
    title: '『宝島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/rp622km2040',
    extent: [129.250751, 29.33705534, 129.5007327, 29.17040276],
  },
  {
    id: '439',
    title: '『諏訪之瀬島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hx450wp2516',
    extent: [129.5007185, 29.83700494, 129.7507318, 29.67033282],
  },
  {
    id: '437',
    title: '『宝島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mc047qv8214',
    extent: [129.0007762, 29.17040276, 129.2507579, 29.00375022],
  },
  {
    id: '436',
    title: '『笠利崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vr639qk0236',
    extent: [129.500743, 28.67046475, 129.7507248, 28.50381201],
  },
  {
    id: '435',
    title: '『名瀬』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jx151dp8705',
    extent: [129.250768, 28.50381201, 129.5008106, 28.33711036],
  },
  {
    id: '434',
    title: '『喜界島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fc275bp1442',
    extent: [129.7507282, 28.33716714, 130.0007817, 28.17051829],
  },
  {
    id: '432',
    title: '『西古見』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jq796vt2845',
    extent: [129.000793, 28.3371593, 129.2508328, 28.17045017],
  },
  {
    id: '433',
    title: '『小湊』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pt232ny4527',
    extent: [129.5007531, 28.33716714, 129.7507316, 28.17051437],
  },
  {
    id: '431',
    title: '『古仁屋』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/hp111gs7027',
    extent: [129.2508328, 28.17051437, 129.5007564, 28.00379628],
  },
  {
    id: '430',
    title: '『請島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dw736kj0912',
    extent: [129.0007962, 28.17050665, 129.250841, 28.00379628],
  },
  {
    id: '428',
    title: '『沖永良部島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ps660fn8789',
    extent: [128.500852, 27.50390727, 128.7508335, 27.3372546],
  },
  {
    id: '429',
    title: '『亀津』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/bj513rz6780',
    extent: [128.7508242, 27.8372089, 129.0008554, 27.67050135],
  },
  {
    id: '426',
    title: '『伊平屋後島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wh259wk1947',
    extent: [127.7509227, 27.17059842, 128.0009041, 27.00394588],
  },
  {
    id: '427',
    title: '『田名崎』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ms114ff9645',
    extent: [128.0009011, 27.17060198, 128.2508826, 27.00394938],
  },
  {
    id: '424',
    title: '『伊平屋前島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/jb358cy7315',
    extent: [127.7509256, 27.00394938, 128.000907, 26.83729681],
  },
  {
    id: '425',
    title: '『奥』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ry529fz2101',
    extent: [128.2508826, 27.0039565, 128.5008641, 26.8372119],
  },
  {
    id: '423',
    title: '『安波』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vd420js0307',
    extent: [128.2509641, 26.83730738, 128.500867, 26.67056152],
  },
  {
    id: '422',
    title: '『辺土名』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nr369fm8489',
    extent: [128.000907, 26.8373003, 128.2509704, 26.67055399],
  },
  {
    id: '420',
    title: '『新川』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gy024nh9204',
    extent: [128.2508913, 26.67065822, 128.5008699, 26.50400548],
  },
  {
    id: '421',
    title: '『伊江島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mz023zs1192',
    extent: [127.7509285, 26.8373003, 128.0009892, 26.67055399],
  },
  {
    id: '418',
    title: '『名護』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/yf761pm1174',
    extent: [127.7509314, 26.67064771, 128.0009943, 26.50390178],
  },
  {
    id: '419',
    title: '『中尾次』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nh074mg3020',
    extent: [128.0009892, 26.67056152, 128.2509704, 26.50390178],
  },
  {
    id: '417',
    title: '『嘉手納』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/xs204pr2939',
    extent: [127.7509342, 26.50399856, 128.0009943, 26.33724442],
  },
  {
    id: '416',
    title: '『座喜味』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/vn744qg7716',
    extent: [127.5009557, 26.50399856, 127.7510198, 26.33724442],
  },
  {
    id: '415',
    title: '『渡名喜島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/dd234gg4786',
    extent: [127.0009988, 26.50399179, 127.25098, 26.33733932],
  },
  {
    id: '414',
    title: '『久米島東部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gx447nv1382',
    extent: [126.7510204, 26.50398846, 127.0010015, 26.33721753],
  },
  {
    id: '413',
    title: '『久米島西部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/nt903sp1078',
    extent: [126.5010421, 26.50398517, 126.7511007, 26.33721753],
  },
  {
    id: '412',
    title: '『与那原』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wx843rc4982',
    extent: [127.7510198, 26.33735278, 128.0009184, 26.17059325],
  },
  {
    id: '411',
    title: '『那覇』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/tw196tn3980',
    extent: [127.5009612, 26.33724442, 127.7510277, 26.17059325],
  },
  {
    id: '410',
    title: '『古場島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/gx341rd2962',
    extent: [127.0010015, 26.33734263, 127.2510459, 26.17060643],
  },
  {
    id: '408',
    title: '『慶良間列島南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sf845jg4164',
    extent: [127.2509854, 26.17069676, 127.500964, 26.00404418],
  },
  {
    id: '409',
    title: '『久米島南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ff719wt4741',
    extent: [126.7510258, 26.33733932, 127.0010042, 26.17068689],
  },
  {
    id: '406',
    title: '『赤尾嶼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/zv410nb2638',
    extent: [124.5012236, 26.00401314, 124.7512042, 25.83736115],
  },
  {
    id: '407',
    title: '『南大東島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/fy996dk0689',
    extent: [131.0006709, 25.83744806, 131.2558802, 25.67079841],
  },
  {
    id: '405',
    title: '『黄尾嶼』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/mk997gg8525',
    extent: [123.5013112, 26.00400178, 123.7512915, 25.83735],
  },
  {
    id: '404',
    title: '『魚釣島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/pn471xx3268',
    extent: [123.5013134, 25.83735273, 123.7512937, 25.67070094],
  },
  {
    id: '403',
    title: '『北硫黄島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sc758qq3548',
    extent: [141.2498646, 25.50433736, 141.4998501, 25.33768132],
  },
  {
    id: '402',
    title: '『硫黄島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ww637df6344',
    extent: [141.249881, 24.83773348, 141.4998664, 24.67107738],
  },
  {
    id: '401',
    title: '『沖大東島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/sh396my9234',
    extent: [131.0006949, 24.50425314, 131.2506772, 24.33759946],
  },
  {
    id: '400',
    title: '『西表島西北部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qr131gj9716',
    extent: [123.5013305, 24.50415876, 123.7514247, 24.33743904],
  },
  {
    id: '399',
    title: '『与那国島』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/ps095dc8989',
    extent: [123.0013739, 24.5041536, 123.2513542, 24.33750166],
  },
  {
    id: '398',
    title: '『西表島南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/wq528jb3193',
    extent: [123.7513129, 24.33743904, 124.0014044, 24.17085981],
  },
  {
    id: '397',
    title: '『西表島西南部』五万分一地形圖',
    source_uri: 'http://purl.stanford.edu/qq146kj4438',
    extent: [123.5013325, 24.33750672, 123.7514247, 24.17085724],
  },
  {
    id: '47',
    title: '神戸：五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/fs206br6980',
    extent: [135.000122, 34.836564, 135.250098, 34.669915],
  },
  {
    id: '5374',
    title: '『雷公計島』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/bz548ch1926',
    extent: [153.233885, 48.301372, 153.26634, 48.282155],
  },
  {
    id: '5396',
    title: '『後鏃岳』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/nn337xf9041',
    extent: [155.002789, 50.333333, 155.252789, 50.1666667],
  },
  {
    id: '5402',
    title: '『千島鳥島』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/qm876qb4831',
    extent: [156.252789, 50.66666667, 156.502789, 50.5],
  },
  {
    id: '5392',
    title: '『千島熊川』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/gt573yz8259',
    extent: [155.752789, 50.3333333, 156.002789, 50.1666667],
  },
  {
    id: '5405',
    title: '『別飛沼』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/xw807yb9561',
    extent: [156.252789, 50.8333333, 156.502789, 50.6666666],
  },
  {
    id: '5414',
    title: '『鳥ノ尾崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/nb933kv2162',
    extent: [150.490789, 46.3303333, 150.740789, 46.1636667],
  },
  {
    id: '5406',
    title: '『片岡』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/rf127gq1103',
    extent: [156.002789, 50.83333333, 156.252789, 50.66666667],
  },
  {
    id: '5389',
    title: '『南四岩』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/bt371bh7036',
    extent: [155.502789, 50.1666667, 155.752789, 50.0],
  },
  {
    id: '5408',
    title: '『阿頼度嶋南部』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/qq889rj3953',
    extent: [155.483262, 50.8333333, 155.752789, 50.66666667],
  },
  {
    id: '5407',
    title: '『白川』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/yy914gw2962',
    extent: [155.752789, 50.8333333, 156.002789, 50.66666667],
  },
  {
    id: '5397',
    title: '『志林規嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/bk228mk6916',
    extent: [154.752789, 50.333333, 155.002789, 50.16666667],
  },
  {
    id: '5390',
    title: '『白煙山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/ty347dv9138',
    extent: [155.252789, 50.16666667, 155.502789, 50.0],
  },
  {
    id: '5403',
    title: '『三子山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/tm933bj0281',
    extent: [156.002789, 50.6666667, 156.252789, 50.5],
  },
  {
    id: '5398',
    title: '『朝日灣』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/zc322jd8254',
    extent: [156.002789, 50.5, 156.252789, 50.3333333],
  },
  {
    id: '5394',
    title: '『千島釋迦ヶ嶽』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/wz614vj7488',
    extent: [155.252789, 50.333333, 155.502789, 50.1666667],
  },
  {
    id: '5380',
    title: '『春牟古丹島東部』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/jj066pn3206',
    extent: [154.502789, 49.166667, 154.752789, 49.0],
  },
  {
    id: '5383',
    title: '『寶珠山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/vj228gb3712',
    extent: [154.752789, 49.3333333, 155.002789, 49.1666667],
  },
  {
    id: '5399',
    title: '『速毛川』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/cy583fc2267',
    extent: [155.752789, 50.5, 156.002789, 50.3333333],
  },
  {
    id: '5401',
    title: '『仙波崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/wb934vj9756',
    extent: [155.252789, 50.5, 155.502789, 50.3333333],
  },
  {
    id: '5387',
    title: '『根茂山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/vf844pc9780',
    extent: [154.752789, 49.6666667, 155.002789, 49.5],
  },
  {
    id: '5384',
    title: '『兜山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/ck208mw6084',
    extent: [154.502789, 49.3333333, 154.752789, 49.1666667],
  },
  {
    id: '5381',
    title: '『春牟古丹島西部』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/zq353mr8539',
    extent: [154.252789, 49.166667, 154.502789, 49.0],
  },
  {
    id: '5379',
    title: '『知林古丹嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/rv016px1793',
    extent: [153.252789, 49.0, 153.502789, 48.833333],
  },
  {
    id: '5385',
    title: '『三股山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/xc972fb6163',
    extent: [154.752789, 49.5, 155.002789, 49.3333333],
  },
  {
    id: '5367',
    title: '『宇志知島』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/df098tc7808',
    extent: [152.757903, 47.664358, 153.007908, 47.497661],
  },
  {
    id: '5400',
    title: '『加熊別』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/qn953tm9804',
    extent: [155.502789, 50.5, 155.752789, 50.333333333],
  },
  {
    id: '5371',
    title: '『計吐夷島』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/gd984bk8543',
    extent: [152.382836, 47.414344, 152.632842, 47.247647],
  },
  {
    id: '5404',
    title: '『土美追川』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/qz514bn4437',
    extent: [155.752789, 50.666667, 156.002789, 50.5],
  },
  {
    id: '5391',
    title: '『樺里』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/pk939vz4538',
    extent: [155.002789, 50.1666667, 155.252789, 50.0],
  },
  {
    id: '5388',
    title: '『磨勘留嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/mq437dp1500',
    extent: [154.252789, 49.83333333, 154.502789, 49.6666667],
  },
  {
    id: '5386',
    title: '『黒石山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/dv613hv6296',
    extent: [154.502789, 49.5, 154.752789, 49.3333333],
  },
  {
    id: '5393',
    title: '『轟川』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/cj455zv4669',
    extent: [155.502789, 50.3333333, 155.752789, 50.1666667],
  },
  {
    id: '5369',
    title: '『新知灣』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/hn641vv6810',
    extent: [151.757753, 46.997656, 152.007761, 46.830958],
  },
  {
    id: '5373',
    title: '『松輪島』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/mh283vp6575',
    extent: [153.007972, 48.164408, 153.297771, 47.997708],
  },
  {
    id: '5377',
    title: '『越渇麿嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/gs620rp2542',
    extent: [153.755, 49.0, 154.005, 48.833333],
  },
  {
    id: '5376',
    title: '『黑嶽』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/bh759fj0970',
    extent: [154.005789, 49.0, 154.255789, 48.833333],
  },
  {
    id: '5366',
    title: '『末廣嶽』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/jn789qx1934',
    extent: [152.007761, 46.997633, 152.257797, 46.830958],
  },
  {
    id: '5375',
    title: '『乙女灣』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/wh462vj8967',
    extent: [153.974556, 48.833333, 154.255789, 48.666667],
  },
  {
    id: '5417',
    title: '『海靣山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/pd333rz1333',
    extent: [150.240789, 46.16366667, 150.490789, 45.997],
  },
  {
    id: '5426',
    title: '『知理保以北嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/kv303dv1293',
    extent: [150.740789, 46.66366667, 150.990789, 46.497],
  },
  {
    id: '5372',
    title: '『羅處和島』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/bc544ts4056',
    extent: [152.959097, 47.807824, 153.062151, 47.676181],
  },
  {
    id: '5370',
    title: '『新知嶽』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/xb150bc7209',
    extent: [151.723898, 46.830958, 152.007761, 46.664283],
  },
  {
    id: '5427',
    title: '『武魯頓嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/pc497qb5588',
    extent: [150.490789, 46.83033333, 150.751017, 46.66366667],
  },
  {
    id: '5425',
    title: '『知理保以南嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/tr738wp2582',
    extent: [150.740789, 46.497, 150.990789, 46.3303333],
  },
  {
    id: '5415',
    title: '『大三頭山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/xs716vw2331',
    extent: [150.240789, 46.3303333, 150.490789, 46.1636667],
  },
  {
    id: '5368',
    title: '『武魯頓灣』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/bt071pk2537',
    extent: [152.007792, 47.167687, 152.292152, 46.997633],
  },
  {
    id: '5421',
    title: '『床丹』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/wn407kb5431',
    extent: [149.740789, 45.997, 149.990789, 45.8303333],
  },
  {
    id: '5423',
    title: '『伽藍崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/nr323qz5075',
    extent: [149.740789, 45.83133333, 149.990789, 45.66566667],
  },
  {
    id: '5418',
    title: '『鐘灣』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/zr750tq8099',
    extent: [149.990789, 46.16366667, 150.240789, 45.997],
  },
  {
    id: '5424',
    title: '『白妙山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/qg926dt9863',
    extent: [149.490789, 45.83133333, 149.740789, 45.6646667],
  },
  {
    id: '5412',
    title: '『櫛ノ崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/dg820fb8909',
    extent: [149.490789, 45.666666667, 149.740789, 45.5],
  },
  {
    id: '5413',
    title: '『伸津崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/ny257nc3685',
    extent: [149.240789, 45.673388, 149.490789, 45.5],
  },
  {
    id: '5420',
    title: '『尖山』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/cs660pz7215',
    extent: [149.990789, 45.997, 150.240789, 45.81982],
  },
  {
    id: '5410',
    title: '『國端崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/',
    extent: [156.252789, 51.0, 156.506964, 50.83333333],
  },
  {
    id: '5409',
    title: '『阿頼度嶋北部』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/qz733zh0006',
    extent: [155.456474, 51.0, 155.752789, 50.83333333],
  },
  {
    id: '5419',
    title: '『名古嶋』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/yd727vp9889',
    extent: [149.740789, 46.16366667, 149.990789, 45.997],
  },
  {
    id: '5416',
    title: '『劒崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/gf520xd4249',
    extent: [149.990789, 46.33033333, 150.240789, 46.16366667],
  },
  {
    id: '5422',
    title: '『ピリカモヘ崎』五万分一地形圖',
    source_uri: 'https://purl.stanford.edu/bx924hy4613',
    extent: [149.490789, 45.997, 149.740789, 45.8303333],
  },
]
export default mw5
